(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports'], factory);
  else if (typeof exports === 'object')
    factory(module.exports);
  else
    root.venus = factory(typeof venus === 'undefined' ? {} : venus);
}(this, function (_) {
  'use strict';
  Error_0.prototype = Object.create(Error.prototype);
  Error_0.prototype.constructor = Error_0;
  NotImplementedError.prototype = Object.create(Error_0.prototype);
  NotImplementedError.prototype.constructor = NotImplementedError;
  IntProgressionIterator.prototype = Object.create(IntIterator.prototype);
  IntProgressionIterator.prototype.constructor = IntProgressionIterator;
  IntRange.prototype = Object.create(IntProgression.prototype);
  IntRange.prototype.constructor = IntRange;
  AbstractMutableCollection.prototype = Object.create(AbstractCollection.prototype);
  AbstractMutableCollection.prototype.constructor = AbstractMutableCollection;
  ListIteratorImpl.prototype = Object.create(IteratorImpl.prototype);
  ListIteratorImpl.prototype.constructor = ListIteratorImpl;
  AbstractMutableList.prototype = Object.create(AbstractMutableCollection.prototype);
  AbstractMutableList.prototype.constructor = AbstractMutableList;
  AbstractMutableSet.prototype = Object.create(AbstractMutableCollection.prototype);
  AbstractMutableSet.prototype.constructor = AbstractMutableSet;
  AbstractEntrySet.prototype = Object.create(AbstractMutableSet.prototype);
  AbstractEntrySet.prototype.constructor = AbstractEntrySet;
  _no_name_provided__6.prototype = Object.create(AbstractMutableSet.prototype);
  _no_name_provided__6.prototype.constructor = _no_name_provided__6;
  AbstractMutableMap.prototype = Object.create(AbstractMap.prototype);
  AbstractMutableMap.prototype.constructor = AbstractMutableMap;
  ArrayList.prototype = Object.create(AbstractMutableList.prototype);
  ArrayList.prototype.constructor = ArrayList;
  EntrySet.prototype = Object.create(AbstractEntrySet.prototype);
  EntrySet.prototype.constructor = EntrySet;
  HashMap.prototype = Object.create(AbstractMutableMap.prototype);
  HashMap.prototype.constructor = HashMap;
  HashSet.prototype = Object.create(AbstractMutableSet.prototype);
  HashSet.prototype.constructor = HashSet;
  NodeJsOutput_0.prototype = Object.create(BaseOutput.prototype);
  NodeJsOutput_0.prototype.constructor = NodeJsOutput_0;
  BufferedOutput_0.prototype = Object.create(BaseOutput.prototype);
  BufferedOutput_0.prototype.constructor = BufferedOutput_0;
  BufferedOutputToConsoleLog_0.prototype = Object.create(BufferedOutput_0.prototype);
  BufferedOutputToConsoleLog_0.prototype.constructor = BufferedOutputToConsoleLog_0;
  PrimitiveKClassImpl.prototype = Object.create(KClassImpl.prototype);
  PrimitiveKClassImpl.prototype.constructor = PrimitiveKClassImpl;
  NothingKClassImpl.prototype = Object.create(KClassImpl.prototype);
  NothingKClassImpl.prototype.constructor = NothingKClassImpl;
  SimpleKClassImpl.prototype = Object.create(KClassImpl.prototype);
  SimpleKClassImpl.prototype.constructor = SimpleKClassImpl;
  Long.prototype = Object.create(Number_0.prototype);
  Long.prototype.constructor = Long;
  Exception.prototype = Object.create(Error.prototype);
  Exception.prototype.constructor = Exception;
  RuntimeException.prototype = Object.create(Exception.prototype);
  RuntimeException.prototype.constructor = RuntimeException;
  IllegalArgumentException.prototype = Object.create(RuntimeException.prototype);
  IllegalArgumentException.prototype.constructor = IllegalArgumentException;
  NoSuchElementException.prototype = Object.create(RuntimeException.prototype);
  NoSuchElementException.prototype.constructor = NoSuchElementException;
  IllegalStateException.prototype = Object.create(RuntimeException.prototype);
  IllegalStateException.prototype.constructor = IllegalStateException;
  NumberFormatException.prototype = Object.create(IllegalArgumentException.prototype);
  NumberFormatException.prototype.constructor = NumberFormatException;
  IndexOutOfBoundsException.prototype = Object.create(RuntimeException.prototype);
  IndexOutOfBoundsException.prototype.constructor = IndexOutOfBoundsException;
  UnsupportedOperationException.prototype = Object.create(RuntimeException.prototype);
  UnsupportedOperationException.prototype.constructor = UnsupportedOperationException;
  NullPointerException.prototype = Object.create(RuntimeException.prototype);
  NullPointerException.prototype.constructor = NullPointerException;
  ClassCastException.prototype = Object.create(RuntimeException.prototype);
  ClassCastException.prototype.constructor = ClassCastException;
  UninitializedPropertyAccessException.prototype = Object.create(RuntimeException.prototype);
  UninitializedPropertyAccessException.prototype.constructor = UninitializedPropertyAccessException;
  AssemblerError.prototype = Object.create(Error.prototype);
  AssemblerError.prototype.constructor = AssemblerError;
  PseudoDispatcher.prototype = Object.create(Enum.prototype);
  PseudoDispatcher.prototype.constructor = PseudoDispatcher;
  BEQZ.prototype = Object.create(PseudoWriter.prototype);
  BEQZ.prototype.constructor = BEQZ;
  BGEZ.prototype = Object.create(PseudoWriter.prototype);
  BGEZ.prototype.constructor = BGEZ;
  BGT.prototype = Object.create(PseudoWriter.prototype);
  BGT.prototype.constructor = BGT;
  BGTU.prototype = Object.create(PseudoWriter.prototype);
  BGTU.prototype.constructor = BGTU;
  BGTZ.prototype = Object.create(PseudoWriter.prototype);
  BGTZ.prototype.constructor = BGTZ;
  BLE.prototype = Object.create(PseudoWriter.prototype);
  BLE.prototype.constructor = BLE;
  BLEU.prototype = Object.create(PseudoWriter.prototype);
  BLEU.prototype.constructor = BLEU;
  BLEZ.prototype = Object.create(PseudoWriter.prototype);
  BLEZ.prototype.constructor = BLEZ;
  BLTZ.prototype = Object.create(PseudoWriter.prototype);
  BLTZ.prototype.constructor = BLTZ;
  BNEZ.prototype = Object.create(PseudoWriter.prototype);
  BNEZ.prototype.constructor = BNEZ;
  CALL.prototype = Object.create(PseudoWriter.prototype);
  CALL.prototype.constructor = CALL;
  J.prototype = Object.create(PseudoWriter.prototype);
  J.prototype.constructor = J;
  JAL.prototype = Object.create(PseudoWriter.prototype);
  JAL.prototype.constructor = JAL;
  JALR.prototype = Object.create(PseudoWriter.prototype);
  JALR.prototype.constructor = JALR;
  JR.prototype = Object.create(PseudoWriter.prototype);
  JR.prototype.constructor = JR;
  LA.prototype = Object.create(PseudoWriter.prototype);
  LA.prototype.constructor = LA;
  LI.prototype = Object.create(PseudoWriter.prototype);
  LI.prototype.constructor = LI;
  Load.prototype = Object.create(PseudoWriter.prototype);
  Load.prototype.constructor = Load;
  MV.prototype = Object.create(PseudoWriter.prototype);
  MV.prototype.constructor = MV;
  NEG.prototype = Object.create(PseudoWriter.prototype);
  NEG.prototype.constructor = NEG;
  NOP.prototype = Object.create(PseudoWriter.prototype);
  NOP.prototype.constructor = NOP;
  NOT.prototype = Object.create(PseudoWriter.prototype);
  NOT.prototype.constructor = NOT;
  RET.prototype = Object.create(PseudoWriter.prototype);
  RET.prototype.constructor = RET;
  SEQ.prototype = Object.create(PseudoWriter.prototype);
  SEQ.prototype.constructor = SEQ;
  SEQZ.prototype = Object.create(PseudoWriter.prototype);
  SEQZ.prototype.constructor = SEQZ;
  SGE.prototype = Object.create(PseudoWriter.prototype);
  SGE.prototype.constructor = SGE;
  SGT.prototype = Object.create(PseudoWriter.prototype);
  SGT.prototype.constructor = SGT;
  SGTZ.prototype = Object.create(PseudoWriter.prototype);
  SGTZ.prototype.constructor = SGTZ;
  SLE.prototype = Object.create(PseudoWriter.prototype);
  SLE.prototype.constructor = SLE;
  SLTZ.prototype = Object.create(PseudoWriter.prototype);
  SLTZ.prototype.constructor = SLTZ;
  SNE.prototype = Object.create(PseudoWriter.prototype);
  SNE.prototype.constructor = SNE;
  SNEZ.prototype = Object.create(PseudoWriter.prototype);
  SNEZ.prototype.constructor = SNEZ;
  Store.prototype = Object.create(PseudoWriter.prototype);
  Store.prototype.constructor = Store;
  TAIL.prototype = Object.create(PseudoWriter.prototype);
  TAIL.prototype.constructor = TAIL;
  InstructionField.prototype = Object.create(Enum.prototype);
  InstructionField.prototype.constructor = InstructionField;
  BTypeInstruction.prototype = Object.create(Instruction.prototype);
  BTypeInstruction.prototype.constructor = BTypeInstruction;
  ITypeInstruction.prototype = Object.create(Instruction.prototype);
  ITypeInstruction.prototype.constructor = ITypeInstruction;
  LoadTypeInstruction.prototype = Object.create(Instruction.prototype);
  LoadTypeInstruction.prototype.constructor = LoadTypeInstruction;
  RTypeInstruction.prototype = Object.create(Instruction.prototype);
  RTypeInstruction.prototype.constructor = RTypeInstruction;
  STypeInstruction.prototype = Object.create(Instruction.prototype);
  STypeInstruction.prototype.constructor = STypeInstruction;
  ShiftImmediateInstruction.prototype = Object.create(Instruction.prototype);
  ShiftImmediateInstruction.prototype.constructor = ShiftImmediateInstruction;
  UTypeInstruction.prototype = Object.create(Instruction.prototype);
  UTypeInstruction.prototype.constructor = UTypeInstruction;
  OpcodeFunct3Format.prototype = Object.create(InstructionFormat.prototype);
  OpcodeFunct3Format.prototype.constructor = OpcodeFunct3Format;
  BTypeFormat.prototype = Object.create(OpcodeFunct3Format.prototype);
  BTypeFormat.prototype.constructor = BTypeFormat;
  ITypeFormat.prototype = Object.create(OpcodeFunct3Format.prototype);
  ITypeFormat.prototype.constructor = ITypeFormat;
  OpcodeFormat.prototype = Object.create(InstructionFormat.prototype);
  OpcodeFormat.prototype.constructor = OpcodeFormat;
  RTypeFormat.prototype = Object.create(InstructionFormat.prototype);
  RTypeFormat.prototype.constructor = RTypeFormat;
  STypeFormat.prototype = Object.create(OpcodeFunct3Format.prototype);
  STypeFormat.prototype.constructor = STypeFormat;
  UTypeFormat.prototype = Object.create(OpcodeFormat.prototype);
  UTypeFormat.prototype.constructor = UTypeFormat;
  HeapSpaceDiff.prototype = Object.create(Diff.prototype);
  HeapSpaceDiff.prototype.constructor = HeapSpaceDiff;
  MemoryDiff.prototype = Object.create(Diff.prototype);
  MemoryDiff.prototype.constructor = MemoryDiff;
  PCDiff.prototype = Object.create(Diff.prototype);
  PCDiff.prototype.constructor = PCDiff;
  RegisterDiff.prototype = Object.create(Diff.prototype);
  RegisterDiff.prototype.constructor = RegisterDiff;
  SimulatorError.prototype = Object.create(Error.prototype);
  SimulatorError.prototype.constructor = SimulatorError;
  function indexOf(_this_, element) {
    if (element == null) {
      var inductionVariable = 0;
      var last_2 = _this_.length - 1 | 0;
      if (inductionVariable <= last_2)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (_this_[index] == null) {
            return index;
          }}
         while (inductionVariable <= last_2);
    } else {
      var inductionVariable_0 = 0;
      var last_3 = _this_.length - 1 | 0;
      if (inductionVariable_0 <= last_3)
        do {
          var index_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          if (equals_0(element, _this_[index_0])) {
            return index_0;
          }}
         while (inductionVariable_0 <= last_3);
    }
    return -1;
  }
  function contains(_this_, element) {
    return indexOf(_this_, element) >= 0;
  }
  function joinToString(_this_, separator, prefix, postfix, limit, truncated, transform) {
    return joinTo(_this_, StringBuilder_init_$Create$(), separator, prefix, postfix, limit, truncated, transform).toString();
  }
  function joinToString$default(_this_, separator, prefix, postfix, limit, truncated, transform, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      separator = ', ';
    if (!(($mask0 & 2) === 0))
      prefix = '';
    if (!(($mask0 & 4) === 0))
      postfix = '';
    if (!(($mask0 & 8) === 0))
      limit = -1;
    if (!(($mask0 & 16) === 0))
      truncated = '...';
    if (!(($mask0 & 32) === 0))
      transform = null;
    return joinToString(_this_, separator, prefix, postfix, limit, truncated, transform);
  }
  function joinTo(_this_, buffer, separator, prefix, postfix, limit, truncated, transform) {
    buffer.append_3(prefix);
    Unit_getInstance();
    var count = 0;
    var indexedObject = _this_;
    var inductionVariable = 0;
    var last_2 = indexedObject.length;
    $l$break: while (inductionVariable < last_2) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      count = count + 1 | 0;
      if (count > 1) {
        buffer.append_3(separator);
        Unit_getInstance();
      } else {
      }
      if (limit < 0 ? true : count <= limit) {
        appendElement(buffer, element, transform);
      } else
        break $l$break;
    }
    if (limit >= 0 ? count > limit : false) {
      buffer.append_3(truncated);
      Unit_getInstance();
    }buffer.append_3(postfix);
    Unit_getInstance();
    return buffer;
  }
  function drop(_this_, n) {
    var tmp0_require_0 = n >= 0;
    if (!tmp0_require_0) {
      var message_2 = '' + 'Requested element count ' + n + ' is less than zero.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_2));
    }if (n === 0)
      return toList(_this_);
    var list;
    if (isInterface(_this_, Collection)) {
      var resultSize = _this_._get_size__23() - n | 0;
      if (resultSize <= 0)
        return emptyList();
      if (resultSize === 1)
        return listOf_0(last(_this_));
      list = ArrayList_init_$Create$_0(resultSize);
      if (isInterface(_this_, List)) {
        if (isInterface(_this_, RandomAccess)) {
          var inductionVariable = n;
          var last_2 = _this_._get_size__23();
          if (inductionVariable < last_2)
            do {
              var index = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              list.add_12(_this_.get_24(index));
              Unit_getInstance();
            }
             while (inductionVariable < last_2);
        } else {
          {
            var tmp1_iterator_0 = _this_.listIterator_2(n);
            var tmp1_iterator = tmp1_iterator_0;
            while (tmp1_iterator.hasNext_10()) {
              var item = tmp1_iterator.next_10();
              list.add_12(item);
              Unit_getInstance();
            }
          }
        }
        return list;
      } else {
      }
    } else {
      {
        list = ArrayList_init_$Create$();
      }
    }
    var count = 0;
    var tmp2_iterator = _this_.iterator_29();
    while (tmp2_iterator.hasNext_10()) {
      var item_0 = tmp2_iterator.next_10();
      if (count >= n) {
        list.add_12(item_0);
        Unit_getInstance();
      } else {
        count = count + 1 | 0;
        Unit_getInstance();
      }
    }
    return optimizeReadOnlyList(list);
  }
  function first(_this_) {
    if (_this_.isEmpty_16())
      throw NoSuchElementException_init_$Create$_0('List is empty.');
    return _this_.get_24(0);
  }
  function toList(_this_) {
    if (isInterface(_this_, Collection)) {
      var tmp0_subject = _this_._get_size__23();
      var tmp;
      switch (tmp0_subject) {
        case 0:
          tmp = emptyList();
          break;
        case 1:
          var tmp_0;
          if (isInterface(_this_, List)) {
            tmp_0 = _this_.get_24(0);
          } else {
            {
              tmp_0 = _this_.iterator_29().next_10();
            }
          }

          tmp = listOf_0(tmp_0);
          break;
        default:tmp = toMutableList(_this_);
          break;
      }
      return tmp;
    } else {
    }
    return optimizeReadOnlyList(toMutableList_0(_this_));
  }
  function single(_this_) {
    var tmp0_subject = _this_;
    if (isInterface(tmp0_subject, List))
      return single_0(_this_);
    else {
      {
        var iterator = _this_.iterator_29();
        if (!iterator.hasNext_10())
          throw NoSuchElementException_init_$Create$_0('Collection is empty.');
        var single_1 = iterator.next_10();
        if (iterator.hasNext_10())
          throw IllegalArgumentException_init_$Create$('Collection has more than one element.');
        return single_1;
      }
    }
  }
  function last(_this_) {
    var tmp0_subject = _this_;
    if (isInterface(tmp0_subject, List))
      return last_0(_this_);
    else {
      {
        var iterator = _this_.iterator_29();
        if (!iterator.hasNext_10())
          throw NoSuchElementException_init_$Create$_0('Collection is empty.');
        var last_2 = iterator.next_10();
        while (iterator.hasNext_10())
          last_2 = iterator.next_10();
        return last_2;
      }
    }
  }
  function toMutableList(_this_) {
    return ArrayList_init_$Create$_1(_this_);
  }
  function toMutableList_0(_this_) {
    if (isInterface(_this_, Collection))
      return toMutableList(_this_);
    else {
    }
    return toCollection(_this_, ArrayList_init_$Create$());
  }
  function single_0(_this_) {
    var tmp0_subject = _this_._get_size__23();
    var tmp;
    switch (tmp0_subject) {
      case 0:
        throw NoSuchElementException_init_$Create$_0('List is empty.');
      case 1:
        tmp = _this_.get_24(0);
        break;
      default:throw IllegalArgumentException_init_$Create$('List has more than one element.');
    }
    return tmp;
  }
  function last_0(_this_) {
    if (_this_.isEmpty_16())
      throw NoSuchElementException_init_$Create$_0('List is empty.');
    return _this_.get_24(_get_lastIndex_(_this_));
  }
  function toCollection(_this_, destination) {
    var tmp0_iterator = _this_.iterator_29();
    while (tmp0_iterator.hasNext_10()) {
      var item = tmp0_iterator.next_10();
      destination.add_12(item);
      Unit_getInstance();
    }
    return destination;
  }
  function joinToString_0(_this_, separator, prefix, postfix, limit, truncated, transform) {
    return joinTo_0(_this_, StringBuilder_init_$Create$(), separator, prefix, postfix, limit, truncated, transform).toString();
  }
  function joinToString$default_0(_this_, separator, prefix, postfix, limit, truncated, transform, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      separator = ', ';
    if (!(($mask0 & 2) === 0))
      prefix = '';
    if (!(($mask0 & 4) === 0))
      postfix = '';
    if (!(($mask0 & 8) === 0))
      limit = -1;
    if (!(($mask0 & 16) === 0))
      truncated = '...';
    if (!(($mask0 & 32) === 0))
      transform = null;
    return joinToString_0(_this_, separator, prefix, postfix, limit, truncated, transform);
  }
  function joinTo_0(_this_, buffer, separator, prefix, postfix, limit, truncated, transform) {
    buffer.append_3(prefix);
    Unit_getInstance();
    var count = 0;
    var tmp0_iterator = _this_.iterator_29();
    $l$break: while (tmp0_iterator.hasNext_10()) {
      var element = tmp0_iterator.next_10();
      count = count + 1 | 0;
      if (count > 1) {
        buffer.append_3(separator);
        Unit_getInstance();
      } else {
      }
      if (limit < 0 ? true : count <= limit) {
        appendElement(buffer, element, transform);
      } else
        break $l$break;
    }
    if (limit >= 0 ? count > limit : false) {
      buffer.append_3(truncated);
      Unit_getInstance();
    }buffer.append_3(postfix);
    Unit_getInstance();
    return buffer;
  }
  function until(_this_, to_0) {
    if (to_0 <= IntCompanionObject_getInstance()._MIN_VALUE)
      return Companion_getInstance_3()._EMPTY;
    return numberRangeToNumber(_this_, to_0 - 1 | 0);
  }
  function coerceIn(_this_, minimumValue, maximumValue) {
    if (minimumValue > maximumValue)
      throw IllegalArgumentException_init_$Create$('' + 'Cannot coerce value to an empty range: maximum ' + maximumValue + ' is less than minimum ' + minimumValue + '.');
    if (_this_ < minimumValue)
      return minimumValue;
    if (_this_ > maximumValue)
      return maximumValue;
    return _this_;
  }
  function coerceAtLeast(_this_, minimumValue) {
    return _this_ < minimumValue ? minimumValue : _this_;
  }
  function downTo(_this_, to_0) {
    return Companion_getInstance_2().fromClosedRange(_this_, to_0, -1);
  }
  function coerceAtMost(_this_, maximumValue) {
    return _this_ > maximumValue ? maximumValue : _this_;
  }
  function toList_0(_this_) {
    return optimizeReadOnlyList(toMutableList_1(_this_));
  }
  function map(_this_, transform) {
    return new TransformingSequence(_this_, transform);
  }
  function toMutableList_1(_this_) {
    return toCollection_0(_this_, ArrayList_init_$Create$());
  }
  function toCollection_0(_this_, destination) {
    var tmp0_iterator = _this_.iterator_29();
    while (tmp0_iterator.hasNext_10()) {
      var item = tmp0_iterator.next_10();
      destination.add_12(item);
      Unit_getInstance();
    }
    return destination;
  }
  function drop_0(_this_, n) {
    var tmp0_require_0 = n >= 0;
    if (!tmp0_require_0) {
      var message_2 = '' + 'Requested character count ' + n + ' is less than zero.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_2));
    }var tmp1_substring_0 = coerceAtMost(n, _this_.length);
    return _this_.substring(tmp1_substring_0);
  }
  function first_0(_this_) {
    if (charSequenceLength(_this_) === 0)
      throw NoSuchElementException_init_$Create$_0('Char sequence is empty.');
    else {
    }
    return charSequenceGet(_this_, 0);
  }
  function take(_this_, n) {
    var tmp0_require_0 = n >= 0;
    if (!tmp0_require_0) {
      var message_2 = '' + 'Requested character count ' + n + ' is less than zero.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_2));
    }var tmp1_substring_0 = 0;
    var tmp2_substring_0 = coerceAtMost(n, _this_.length);
    return _this_.substring(tmp1_substring_0, tmp2_substring_0);
  }
  function last_1(_this_) {
    if (charSequenceLength(_this_) === 0)
      throw NoSuchElementException_init_$Create$_0('Char sequence is empty.');
    else {
    }
    return charSequenceGet(_this_, _get_lastIndex__0(_this_));
  }
  function dropLast(_this_, n) {
    var tmp0_require_0 = n >= 0;
    if (!tmp0_require_0) {
      var message_2 = '' + 'Requested character count ' + n + ' is less than zero.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_2));
    }return take(_this_, coerceAtLeast(_this_.length - n | 0, 0));
  }
  function _no_name_provided_(this$0) {
    this._this$0 = this$0;
  }
  _no_name_provided_.prototype.invoke = function (it) {
    return it === this._this$0 ? '(this Collection)' : toString_0(it);
  };
  _no_name_provided_.prototype.invoke_213 = function (p1) {
    return this.invoke((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided_.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function AbstractCollection() {
  }
  AbstractCollection.prototype.contains_10 = function (element) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp;
      if (isInterface(this, Collection)) {
        tmp = this.isEmpty_16();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = false;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = this.iterator_29();
      while (tmp0_iterator_1.hasNext_10()) {
        var element_2 = tmp0_iterator_1.next_10();
        if (equals_0(element_2, element)) {
          tmp$ret$0 = true;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = false;
    }
     while (false);
    return tmp$ret$0;
  };
  AbstractCollection.prototype.containsAll_12 = function (elements) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp;
      if (isInterface(elements, Collection)) {
        tmp = elements.isEmpty_16();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = true;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = elements.iterator_29();
      while (tmp0_iterator_1.hasNext_10()) {
        var element_2 = tmp0_iterator_1.next_10();
        if (!this.contains_10(element_2)) {
          tmp$ret$0 = false;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = true;
    }
     while (false);
    return tmp$ret$0;
  };
  AbstractCollection.prototype.isEmpty_16 = function () {
    return this._get_size__23() === 0;
  };
  AbstractCollection.prototype.toString = function () {
    return joinToString$default_0(this, ', ', '[', ']', 0, null, _no_name_provided_$factory(this), 24, null);
  };
  AbstractCollection.prototype.toArray = function () {
    return copyToArrayImpl_0(this);
  };
  AbstractCollection.$metadata$ = {
    simpleName: 'AbstractCollection',
    kind: 'class',
    interfaces: [Collection]
  };
  function _no_name_provided_$factory(this$0) {
    var i = new _no_name_provided_(this$0);
    return function (p1) {
      return i.invoke(p1);
    };
  }
  function Companion_0() {
    Companion_instance = this;
  }
  Companion_0.prototype.checkElementIndex = function (index, size) {
    if (index < 0 ? true : index >= size) {
      throw IndexOutOfBoundsException_init_$Create$('' + 'index: ' + index + ', size: ' + size);
    }};
  Companion_0.prototype.checkPositionIndex = function (index, size) {
    if (index < 0 ? true : index > size) {
      throw IndexOutOfBoundsException_init_$Create$('' + 'index: ' + index + ', size: ' + size);
    }};
  Companion_0.prototype.orderedHashCode = function (c) {
    var hashCode_1 = 1;
    var tmp0_iterator = c.iterator_29();
    while (tmp0_iterator.hasNext_10()) {
      var e = tmp0_iterator.next_10();
      var tmp = imul(31, hashCode_1);
      var tmp1_safe_receiver = e;
      var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : hashCode(tmp1_safe_receiver);
      hashCode_1 = tmp + (tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs) | 0;
    }
    return hashCode_1;
  };
  Companion_0.prototype.orderedEquals = function (c, other) {
    if (!(c._get_size__23() === other._get_size__23()))
      return false;
    var otherIterator = other.iterator_29();
    var tmp0_iterator = c.iterator_29();
    while (tmp0_iterator.hasNext_10()) {
      var elem = tmp0_iterator.next_10();
      var elemOther = otherIterator.next_10();
      if (!equals_0(elem, elemOther)) {
        return false;
      }}
    return true;
  };
  Companion_0.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance;
  function Companion_getInstance() {
    if (Companion_instance == null)
      new Companion_0();
    return Companion_instance;
  }
  function toString($this, o) {
    return o === $this ? '(this Map)' : toString_0(o);
  }
  function implFindEntry($this, key) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_firstOrNull_0 = $this._get_entries__3();
      var tmp0_iterator_1 = tmp0_firstOrNull_0.iterator_29();
      while (tmp0_iterator_1.hasNext_10()) {
        var element_2 = tmp0_iterator_1.next_10();
        if (equals_0(element_2._get_key__5(), key)) {
          tmp$ret$0 = element_2;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = null;
    }
     while (false);
    return tmp$ret$0;
  }
  function Companion_1() {
    Companion_instance_0 = this;
  }
  Companion_1.prototype.entryHashCode = function (e) {
    var tmp2_safe_receiver_4 = e._get_key__5();
    var tmp3_elvis_lhs_3 = tmp2_safe_receiver_4 == null ? null : hashCode(tmp2_safe_receiver_4);
    var tmp = tmp3_elvis_lhs_3 == null ? 0 : tmp3_elvis_lhs_3;
    var tmp0_safe_receiver_6 = e._get_value__11();
    var tmp1_elvis_lhs_5 = tmp0_safe_receiver_6 == null ? null : hashCode(tmp0_safe_receiver_6);
    return tmp ^ (tmp1_elvis_lhs_5 == null ? 0 : tmp1_elvis_lhs_5);
  };
  Companion_1.prototype.entryToString = function (e) {
    return '' + e._get_key__5() + '=' + e._get_value__11();
  };
  Companion_1.prototype.entryEquals = function (e, other) {
    if (!(!(other == null) ? isInterface(other, Entry) : false))
      return false;
    else {
    }
    return equals_0(e._get_key__5(), other._get_key__5()) ? equals_0(e._get_value__11(), other._get_value__11()) : false;
  };
  Companion_1.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_0;
  function Companion_getInstance_0() {
    if (Companion_instance_0 == null)
      new Companion_1();
    return Companion_instance_0;
  }
  function _no_name_provided__0(this$0) {
    this._this$0_0 = this$0;
  }
  _no_name_provided__0.prototype.invoke_1 = function (it) {
    return this._this$0_0.toString_0(it);
  };
  _no_name_provided__0.prototype.invoke_213 = function (p1) {
    return this.invoke_1((!(p1 == null) ? isInterface(p1, Entry) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__0.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function AbstractMap() {
    Companion_getInstance_0();
    this.__keys = null;
    this.__values = null;
  }
  AbstractMap.prototype.containsKey_2 = function (key) {
    return !(implFindEntry(this, key) == null);
  };
  AbstractMap.prototype.containsEntry_3 = function (entry) {
    if (!(!(entry == null) ? isInterface(entry, Entry) : false))
      return false;
    else {
    }
    var key = entry._get_key__5();
    var value = entry._get_value__11();
    var ourValue = (isInterface(this, Map_0) ? this : THROW_CCE()).get_11(key);
    if (!equals_0(value, ourValue)) {
      return false;
    }var tmp;
    if (ourValue == null) {
      tmp = !(isInterface(this, Map_0) ? this : THROW_CCE()).containsKey_2(key);
    } else {
      tmp = false;
    }
    if (tmp) {
      return false;
    } else {
    }
    return true;
  };
  AbstractMap.prototype.equals = function (other) {
    if (other === this)
      return true;
    if (!(!(other == null) ? isInterface(other, Map_0) : false))
      return false;
    else {
    }
    if (!(this._get_size__23() === other._get_size__23()))
      return false;
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_all_0 = other._get_entries__3();
      var tmp;
      if (isInterface(tmp0_all_0, Collection)) {
        tmp = tmp0_all_0.isEmpty_16();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = true;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = tmp0_all_0.iterator_29();
      while (tmp0_iterator_1.hasNext_10()) {
        var element_2 = tmp0_iterator_1.next_10();
        if (!this.containsEntry_3(element_2)) {
          tmp$ret$0 = false;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = true;
    }
     while (false);
    return tmp$ret$0;
  };
  AbstractMap.prototype.get_11 = function (key) {
    var tmp0_safe_receiver = implFindEntry(this, key);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_value__11();
  };
  AbstractMap.prototype.hashCode = function () {
    return hashCode(this._get_entries__3());
  };
  AbstractMap.prototype.isEmpty_16 = function () {
    return this._get_size__23() === 0;
  };
  AbstractMap.prototype._get_size__23 = function () {
    return this._get_entries__3()._get_size__23();
  };
  AbstractMap.prototype.toString = function () {
    var tmp = this._get_entries__3();
    return joinToString$default_0(tmp, ', ', '{', '}', 0, null, _no_name_provided_$factory_0(this), 24, null);
  };
  AbstractMap.prototype.toString_0 = function (entry) {
    return toString(this, entry._get_key__5()) + '=' + toString(this, entry._get_value__11());
  };
  AbstractMap.$metadata$ = {
    simpleName: 'AbstractMap',
    kind: 'class',
    interfaces: [Map_0]
  };
  function _no_name_provided_$factory_0(this$0) {
    var i = new _no_name_provided__0(this$0);
    return function (p1) {
      return i.invoke_1(p1);
    };
  }
  function Companion_2() {
    Companion_instance_1 = this;
  }
  Companion_2.prototype.unorderedHashCode = function (c) {
    var hashCode_1 = 0;
    var tmp0_iterator = c.iterator_29();
    while (tmp0_iterator.hasNext_10()) {
      var element = tmp0_iterator.next_10();
      var tmp = hashCode_1;
      var tmp1_safe_receiver = element;
      var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : hashCode(tmp1_safe_receiver);
      hashCode_1 = tmp + (tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs) | 0;
    }
    return hashCode_1;
  };
  Companion_2.prototype.setEquals = function (c, other) {
    if (!(c._get_size__23() === other._get_size__23()))
      return false;
    return c.containsAll_12(other);
  };
  Companion_2.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_1;
  function Companion_getInstance_1() {
    if (Companion_instance_1 == null)
      new Companion_2();
    return Companion_instance_1;
  }
  function listOf(elements) {
    return elements.length > 0 ? asList(elements) : emptyList();
  }
  function emptyList() {
    return EmptyList_getInstance();
  }
  function EmptyList() {
    EmptyList_instance = this;
    this._serialVersionUID = new Long(-1478467534, -1720727600);
  }
  EmptyList.prototype.equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, List) : false) {
      tmp = other.isEmpty_16();
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  EmptyList.prototype.hashCode = function () {
    return 1;
  };
  EmptyList.prototype.toString = function () {
    return '[]';
  };
  EmptyList.prototype._get_size__23 = function () {
    return 0;
  };
  EmptyList.prototype.isEmpty_16 = function () {
    return true;
  };
  EmptyList.prototype.containsAll_0 = function (elements) {
    return elements.isEmpty_16();
  };
  EmptyList.prototype.containsAll_12 = function (elements) {
    return this.containsAll_0(elements);
  };
  EmptyList.prototype.get_24 = function (index) {
    throw IndexOutOfBoundsException_init_$Create$('' + "Empty list doesn't contain element at index " + index + '.');
  };
  EmptyList.prototype.iterator_29 = function () {
    return EmptyIterator_getInstance();
  };
  EmptyList.prototype.listIterator_2 = function (index) {
    if (!(index === 0))
      throw IndexOutOfBoundsException_init_$Create$('' + 'Index: ' + index);
    return EmptyIterator_getInstance();
  };
  EmptyList.$metadata$ = {
    simpleName: 'EmptyList',
    kind: 'object',
    interfaces: [List, Serializable, RandomAccess]
  };
  var EmptyList_instance;
  function EmptyList_getInstance() {
    if (EmptyList_instance == null)
      new EmptyList();
    return EmptyList_instance;
  }
  function EmptyIterator() {
    EmptyIterator_instance = this;
  }
  EmptyIterator.prototype.hasNext_10 = function () {
    return false;
  };
  EmptyIterator.prototype.next_10 = function () {
    throw NoSuchElementException_init_$Create$();
  };
  EmptyIterator.$metadata$ = {
    simpleName: 'EmptyIterator',
    kind: 'object',
    interfaces: [ListIterator]
  };
  var EmptyIterator_instance;
  function EmptyIterator_getInstance() {
    if (EmptyIterator_instance == null)
      new EmptyIterator();
    return EmptyIterator_instance;
  }
  function _get_lastIndex_(_this_) {
    return _this_._get_size__23() - 1 | 0;
  }
  function optimizeReadOnlyList(_this_) {
    var tmp0_subject = _this_._get_size__23();
    switch (tmp0_subject) {
      case 0:
        return emptyList();
      case 1:
        return listOf_0(_this_.get_24(0));
      default:return _this_;
    }
  }
  function arrayListOf(elements) {
    return elements.length === 0 ? ArrayList_init_$Create$() : ArrayList_init_$Create$_1(new ArrayAsCollection(elements, true));
  }
  function ArrayAsCollection(values, isVarargs) {
    this._values = values;
    this._isVarargs = isVarargs;
  }
  ArrayAsCollection.prototype._get_size__23 = function () {
    return this._values.length;
  };
  ArrayAsCollection.prototype.isEmpty_16 = function () {
    var tmp0_isEmpty_0 = this._values;
    return tmp0_isEmpty_0.length === 0;
  };
  ArrayAsCollection.prototype.contains_1 = function (element) {
    return contains(this._values, element);
  };
  ArrayAsCollection.prototype.containsAll_2 = function (elements) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp;
      if (isInterface(elements, Collection)) {
        tmp = elements.isEmpty_16();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = true;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = elements.iterator_29();
      while (tmp0_iterator_1.hasNext_10()) {
        var element_2 = tmp0_iterator_1.next_10();
        if (!this.contains_1(element_2)) {
          tmp$ret$0 = false;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = true;
    }
     while (false);
    return tmp$ret$0;
  };
  ArrayAsCollection.prototype.containsAll_12 = function (elements) {
    return this.containsAll_2(elements);
  };
  ArrayAsCollection.prototype.iterator_29 = function () {
    return arrayIterator(this._values);
  };
  ArrayAsCollection.$metadata$ = {
    simpleName: 'ArrayAsCollection',
    kind: 'class',
    interfaces: [Collection]
  };
  function Sequence() {
  }
  Sequence.$metadata$ = {
    simpleName: 'Sequence',
    kind: 'interface',
    interfaces: []
  };
  function _no_name_provided__1(this$0) {
    this._this$0_1 = this$0;
    this._iterator = this._this$0_1._sequence.iterator_29();
  }
  _no_name_provided__1.prototype.next_10 = function () {
    return this._this$0_1._transformer(this._iterator.next_10());
  };
  _no_name_provided__1.prototype.hasNext_10 = function () {
    return this._iterator.hasNext_10();
  };
  _no_name_provided__1.$metadata$ = {
    kind: 'class',
    interfaces: [Iterator]
  };
  function TransformingSequence(sequence, transformer) {
    this._sequence = sequence;
    this._transformer = transformer;
  }
  TransformingSequence.prototype.iterator_29 = function () {
    return new _no_name_provided__1(this);
  };
  TransformingSequence.$metadata$ = {
    simpleName: 'TransformingSequence',
    kind: 'class',
    interfaces: [Sequence]
  };
  function KClassifier() {
  }
  KClassifier.$metadata$ = {
    simpleName: 'KClassifier',
    kind: 'interface',
    interfaces: []
  };
  function appendElement(_this_, element, transform) {
    if (!(transform == null)) {
      _this_.append_3(transform(element));
      Unit_getInstance();
    } else {
      if (element == null ? true : isCharSequence(element)) {
        _this_.append_3(element);
        Unit_getInstance();
      } else {
        if (element instanceof Char) {
          _this_.append_2(element);
          Unit_getInstance();
        } else {
          {
            _this_.append_3(toString_0(element));
            Unit_getInstance();
          }
        }
      }
    }
  }
  function equals(_this_, other, ignoreCase) {
    if (_this_.equals(other))
      return true;
    if (!ignoreCase)
      return false;
    var thisUpper = uppercaseChar(_this_);
    var otherUpper = uppercaseChar(other);
    var tmp;
    if (thisUpper.equals(otherUpper)) {
      tmp = true;
    } else {
      var tmp0_asDynamic_0 = thisUpper.toString();
      var tmp1_unsafeCast_0 = tmp0_asDynamic_0.toLowerCase();
      var tmp_0 = charSequenceGet(tmp1_unsafeCast_0, 0);
      var tmp2_asDynamic_0 = otherUpper.toString();
      var tmp3_unsafeCast_0 = tmp2_asDynamic_0.toLowerCase();
      tmp = tmp_0.equals(charSequenceGet(tmp3_unsafeCast_0, 0));
    }
    return tmp;
  }
  function toIntOrNull(_this_) {
    return toIntOrNull_0(_this_, 10);
  }
  function numberFormatError(input) {
    throw NumberFormatException_init_$Create$('' + "Invalid number format: '" + input + "'");
  }
  function toLongOrNull(_this_) {
    return toLongOrNull_0(_this_, 10);
  }
  function toLongOrNull_0(_this_, radix) {
    checkRadix(radix);
    Unit_getInstance();
    var length = _this_.length;
    if (length === 0)
      return null;
    var start;
    var isNegative_0;
    var limit;
    var firstChar = charSequenceGet(_this_, 0);
    if (firstChar.compareTo_0(new Char(48)) < 0) {
      if (length === 1)
        return null;
      start = 1;
      if (firstChar.equals(new Char(45))) {
        isNegative_0 = true;
        Companion_getInstance_6();
        limit = new Long(0, -2147483648);
      } else if (firstChar.equals(new Char(43))) {
        isNegative_0 = false;
        Companion_getInstance_6();
        limit = (new Long(-1, 2147483647)).unaryMinus_4();
      } else
        return null;
    } else {
      start = 0;
      isNegative_0 = false;
      Companion_getInstance_6();
      limit = (new Long(-1, 2147483647)).unaryMinus_4();
    }
    Companion_getInstance_6();
    var tmp0_div_0 = (new Long(-1, 2147483647)).unaryMinus_4();
    var tmp1_div_0 = 36;
    var limitForMaxRadix = tmp0_div_0.div_27(toLong_1(tmp1_div_0));
    var limitBeforeMul = limitForMaxRadix;
    var result = new Long(0, 0);
    var inductionVariable = start;
    if (inductionVariable < length)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var digit = digitOf(charSequenceGet(_this_, i), radix);
        if (digit < 0)
          return null;
        if (result.compareTo_36(limitBeforeMul) < 0) {
          if (limitBeforeMul.equals(limitForMaxRadix)) {
            limitBeforeMul = limit.div_27(toLong_1(radix));
            if (result.compareTo_36(limitBeforeMul) < 0) {
              return null;
            }} else {
            return null;
          }
        }var tmp2_times_0 = result;
        result = tmp2_times_0.times_27(toLong_1(radix));
        var tmp = result;
        if (tmp.compareTo_36(limit.plus_27(toLong_1(digit))) < 0)
          return null;
        else {
        }
        var tmp3_minus_0 = result;
        result = tmp3_minus_0.minus_28(toLong_1(digit));
      }
       while (inductionVariable < length);
    return isNegative_0 ? result : result.unaryMinus_4();
  }
  function toIntOrNull_0(_this_, radix) {
    checkRadix(radix);
    Unit_getInstance();
    var length = _this_.length;
    if (length === 0)
      return null;
    var start;
    var isNegative_0;
    var limit;
    var firstChar = charSequenceGet(_this_, 0);
    if (firstChar.compareTo_0(new Char(48)) < 0) {
      if (length === 1)
        return null;
      start = 1;
      if (firstChar.equals(new Char(45))) {
        isNegative_0 = true;
        limit = IntCompanionObject_getInstance()._MIN_VALUE;
      } else if (firstChar.equals(new Char(43))) {
        isNegative_0 = false;
        limit = -IntCompanionObject_getInstance()._MAX_VALUE | 0;
      } else
        return null;
    } else {
      start = 0;
      isNegative_0 = false;
      limit = -IntCompanionObject_getInstance()._MAX_VALUE | 0;
    }
    var limitForMaxRadix = (-IntCompanionObject_getInstance()._MAX_VALUE | 0) / 36 | 0;
    var limitBeforeMul = limitForMaxRadix;
    var result = 0;
    var inductionVariable = start;
    if (inductionVariable < length)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var digit = digitOf(charSequenceGet(_this_, i), radix);
        if (digit < 0)
          return null;
        if (result < limitBeforeMul) {
          if (limitBeforeMul === limitForMaxRadix) {
            limitBeforeMul = limit / radix | 0;
            if (result < limitBeforeMul) {
              return null;
            }} else {
            return null;
          }
        }result = imul(result, radix);
        if (result < (limit + digit | 0))
          return null;
        result = result - digit | 0;
      }
       while (inductionVariable < length);
    return isNegative_0 ? result : -result | 0;
  }
  function lines(_this_) {
    return toList_0(lineSequence(_this_));
  }
  function removePrefix(_this_, prefix) {
    if (startsWith$default(_this_, prefix, false, 2, null)) {
      var tmp0_substring_0 = charSequenceLength(prefix);
      return _this_.substring(tmp0_substring_0);
    } else {
    }
    return _this_;
  }
  function lineSequence(_this_) {
    var tmp = ['\r\n', '\n', '\r'];
    return splitToSequence$default(_this_, tmp, false, 0, 6, null);
  }
  function startsWith(_this_, prefix, ignoreCase) {
    var tmp;
    var tmp_0;
    if (!ignoreCase) {
      tmp_0 = typeof _this_ === 'string';
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = typeof prefix === 'string';
    } else {
      {
        tmp = false;
      }
    }
    if (tmp) {
      var tmp_1 = _this_;
      var tmp_2 = prefix;
      return startsWith$default_0(tmp_1, tmp_2, false, 2, null);
    } else {
      return regionMatchesImpl(_this_, 0, prefix, 0, charSequenceLength(prefix), ignoreCase);
    }
  }
  function startsWith$default(_this_, prefix, ignoreCase, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      ignoreCase = false;
    return startsWith(_this_, prefix, ignoreCase);
  }
  function splitToSequence(_this_, delimiters, ignoreCase, limit) {
    var tmp = rangesDelimitedBy$default(_this_, delimiters, 0, ignoreCase, limit, 2, null);
    return map(tmp, _no_name_provided_$factory_1(_this_));
  }
  function splitToSequence$default(_this_, delimiters, ignoreCase, limit, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      ignoreCase = false;
    if (!(($mask0 & 4) === 0))
      limit = 0;
    return splitToSequence(_this_, delimiters, ignoreCase, limit);
  }
  function regionMatchesImpl(_this_, thisOffset, other, otherOffset, length, ignoreCase) {
    if (((otherOffset < 0 ? true : thisOffset < 0) ? true : thisOffset > (charSequenceLength(_this_) - length | 0)) ? true : otherOffset > (charSequenceLength(other) - length | 0)) {
      return false;
    }var inductionVariable = 0;
    if (inductionVariable < length)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!equals(charSequenceGet(_this_, thisOffset + index | 0), charSequenceGet(other, otherOffset + index | 0), ignoreCase))
          return false;
      }
       while (inductionVariable < length);
    return true;
  }
  function substring(_this_, range) {
    return toString_1(charSequenceSubSequence(_this_, range._get_start_(), range._get_endInclusive_() + 1 | 0));
  }
  function rangesDelimitedBy(_this_, delimiters, startIndex, ignoreCase, limit) {
    var tmp0_require_0 = limit >= 0;
    if (!tmp0_require_0) {
      var message_2 = '' + 'Limit must be non-negative, but was ' + limit + '.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_2));
    }var delimitersList = asList(delimiters);
    return new DelimitedRangesSequence(_this_, startIndex, limit, _no_name_provided_$factory_2(delimitersList, ignoreCase));
  }
  function rangesDelimitedBy$default(_this_, delimiters, startIndex, ignoreCase, limit, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      startIndex = 0;
    if (!(($mask0 & 4) === 0))
      ignoreCase = false;
    if (!(($mask0 & 8) === 0))
      limit = 0;
    return rangesDelimitedBy(_this_, delimiters, startIndex, ignoreCase, limit);
  }
  function calcNext($this) {
    if ($this._nextSearchIndex < 0) {
      $this._nextState = 0;
      $this._nextItem = null;
    } else {
      var tmp;
      var tmp_0;
      if ($this._this$0_2._limit > 0) {
        var tmp0_this = $this;
        tmp0_this._counter = tmp0_this._counter + 1 | 0;
        tmp_0 = tmp0_this._counter >= $this._this$0_2._limit;
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp = true;
      } else {
        {
          tmp = $this._nextSearchIndex > charSequenceLength($this._this$0_2._input);
        }
      }
      if (tmp) {
        $this._nextItem = numberRangeToNumber($this._currentStartIndex, _get_lastIndex__0($this._this$0_2._input));
        $this._nextSearchIndex = -1;
      } else {
        {
          var match = $this._this$0_2._getNextMatch($this._this$0_2._input, $this._nextSearchIndex);
          if (match == null) {
            $this._nextItem = numberRangeToNumber($this._currentStartIndex, _get_lastIndex__0($this._this$0_2._input));
            $this._nextSearchIndex = -1;
          } else {
            var tmp1_container = match;
            var index = tmp1_container.component1_5();
            var length = tmp1_container.component2_6();
            $this._nextItem = until($this._currentStartIndex, index);
            $this._currentStartIndex = index + length | 0;
            $this._nextSearchIndex = $this._currentStartIndex + (length === 0 ? 1 : 0) | 0;
          }
        }
      }
      $this._nextState = 1;
    }
  }
  function _no_name_provided__2(this$0) {
    this._this$0_2 = this$0;
    this._nextState = -1;
    this._currentStartIndex = coerceIn(this._this$0_2._startIndex, 0, charSequenceLength(this._this$0_2._input));
    this._nextSearchIndex = this._currentStartIndex;
    this._nextItem = null;
    this._counter = 0;
  }
  _no_name_provided__2.prototype.next_10 = function () {
    if (this._nextState === -1)
      calcNext(this);
    if (this._nextState === 0)
      throw NoSuchElementException_init_$Create$();
    var tmp = this._nextItem;
    var result = tmp instanceof IntRange ? tmp : THROW_CCE();
    this._nextItem = null;
    this._nextState = -1;
    return result;
  };
  _no_name_provided__2.prototype.hasNext_10 = function () {
    if (this._nextState === -1)
      calcNext(this);
    return this._nextState === 1;
  };
  _no_name_provided__2.$metadata$ = {
    kind: 'class',
    interfaces: [Iterator]
  };
  function DelimitedRangesSequence(input, startIndex, limit, getNextMatch) {
    this._input = input;
    this._startIndex = startIndex;
    this._limit = limit;
    this._getNextMatch = getNextMatch;
  }
  DelimitedRangesSequence.prototype.iterator_29 = function () {
    return new _no_name_provided__2(this);
  };
  DelimitedRangesSequence.$metadata$ = {
    simpleName: 'DelimitedRangesSequence',
    kind: 'class',
    interfaces: [Sequence]
  };
  function findAnyOf(_this_, strings, startIndex, ignoreCase, last_2) {
    if (!ignoreCase ? strings._get_size__23() === 1 : false) {
      var string = single(strings);
      var tmp;
      if (!last_2) {
        tmp = indexOf$default(_this_, string, startIndex, false, 4, null);
      } else {
        tmp = lastIndexOf$default(_this_, string, startIndex, false, 4, null);
      }
      var index = tmp;
      return index < 0 ? null : to(index, string);
    }var indices = !last_2 ? numberRangeToNumber(coerceAtLeast(startIndex, 0), charSequenceLength(_this_)) : downTo(coerceAtMost(startIndex, _get_lastIndex__0(_this_)), 0);
    if (typeof _this_ === 'string') {
      var inductionVariable = indices._first_0;
      var last_3 = indices._last;
      var step = indices._step_0;
      if ((step > 0 ? inductionVariable <= last_3 : false) ? true : step < 0 ? last_3 <= inductionVariable : false)
        do {
          var index_0 = inductionVariable;
          inductionVariable = inductionVariable + step | 0;
          var tmp$ret$0;
          l$ret$1: do {
            var tmp0_iterator_1 = strings.iterator_29();
            while (tmp0_iterator_1.hasNext_10()) {
              var element_2 = tmp0_iterator_1.next_10();
              if (regionMatches(element_2, 0, _this_, index_0, element_2.length, ignoreCase)) {
                tmp$ret$0 = element_2;
                break l$ret$1;
              } else {
              }
            }
            tmp$ret$0 = null;
          }
           while (false);
          var matchingString = tmp$ret$0;
          if (!(matchingString == null))
            return to(index_0, matchingString);
        }
         while (!(index_0 === last_3));
    } else {
      {
        var inductionVariable_0 = indices._first_0;
        var last_4 = indices._last;
        var step_0 = indices._step_0;
        if ((step_0 > 0 ? inductionVariable_0 <= last_4 : false) ? true : step_0 < 0 ? last_4 <= inductionVariable_0 : false)
          do {
            var index_1 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + step_0 | 0;
            var tmp$ret$2;
            l$ret$3: do {
              var tmp0_iterator_1_0 = strings.iterator_29();
              while (tmp0_iterator_1_0.hasNext_10()) {
                var element_2_0 = tmp0_iterator_1_0.next_10();
                if (regionMatchesImpl(element_2_0, 0, _this_, index_1, element_2_0.length, ignoreCase)) {
                  tmp$ret$2 = element_2_0;
                  break l$ret$3;
                } else {
                }
              }
              tmp$ret$2 = null;
            }
             while (false);
            var matchingString_0 = tmp$ret$2;
            if (!(matchingString_0 == null))
              return to(index_1, matchingString_0);
          }
           while (!(index_1 === last_4));
      }
    }
    return null;
  }
  function _get_lastIndex__0(_this_) {
    return charSequenceLength(_this_) - 1 | 0;
  }
  function indexOf_0(_this_, string, startIndex, ignoreCase) {
    var tmp;
    var tmp_0;
    if (ignoreCase) {
      tmp_0 = true;
    } else {
      tmp_0 = !(typeof _this_ === 'string');
    }
    if (tmp_0) {
      var tmp_1 = charSequenceLength(_this_);
      tmp = indexOf$default_0(_this_, string, startIndex, tmp_1, ignoreCase, false, 16, null);
    } else {
      {
        var tmp0_nativeIndexOf_0 = _this_;
        tmp = tmp0_nativeIndexOf_0.indexOf(string, startIndex);
      }
    }
    return tmp;
  }
  function indexOf$default(_this_, string, startIndex, ignoreCase, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      startIndex = 0;
    if (!(($mask0 & 4) === 0))
      ignoreCase = false;
    return indexOf_0(_this_, string, startIndex, ignoreCase);
  }
  function lastIndexOf(_this_, string, startIndex, ignoreCase) {
    var tmp;
    var tmp_0;
    if (ignoreCase) {
      tmp_0 = true;
    } else {
      tmp_0 = !(typeof _this_ === 'string');
    }
    if (tmp_0) {
      tmp = indexOf_1(_this_, string, startIndex, 0, ignoreCase, true);
    } else {
      {
        var tmp0_nativeLastIndexOf_0 = _this_;
        tmp = tmp0_nativeLastIndexOf_0.lastIndexOf(string, startIndex);
      }
    }
    return tmp;
  }
  function lastIndexOf$default(_this_, string, startIndex, ignoreCase, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      startIndex = _get_lastIndex__0(_this_);
    if (!(($mask0 & 4) === 0))
      ignoreCase = false;
    return lastIndexOf(_this_, string, startIndex, ignoreCase);
  }
  function indexOf_1(_this_, other, startIndex, endIndex, ignoreCase, last_2) {
    var indices = !last_2 ? numberRangeToNumber(coerceAtLeast(startIndex, 0), coerceAtMost(endIndex, charSequenceLength(_this_))) : downTo(coerceAtMost(startIndex, _get_lastIndex__0(_this_)), coerceAtLeast(endIndex, 0));
    var tmp;
    if (typeof _this_ === 'string') {
      tmp = typeof other === 'string';
    } else {
      {
        tmp = false;
      }
    }
    if (tmp) {
      var inductionVariable = indices._first_0;
      var last_3 = indices._last;
      var step = indices._step_0;
      if ((step > 0 ? inductionVariable <= last_3 : false) ? true : step < 0 ? last_3 <= inductionVariable : false)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + step | 0;
          if (regionMatches(other, 0, _this_, index, charSequenceLength(other), ignoreCase))
            return index;
        }
         while (!(index === last_3));
    } else {
      {
        var inductionVariable_0 = indices._first_0;
        var last_4 = indices._last;
        var step_0 = indices._step_0;
        if ((step_0 > 0 ? inductionVariable_0 <= last_4 : false) ? true : step_0 < 0 ? last_4 <= inductionVariable_0 : false)
          do {
            var index_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + step_0 | 0;
            if (regionMatchesImpl(other, 0, _this_, index_0, charSequenceLength(other), ignoreCase))
              return index_0;
          }
           while (!(index_0 === last_4));
      }
    }
    return -1;
  }
  function indexOf$default_0(_this_, other, startIndex, endIndex, ignoreCase, last_2, $mask0, $handler) {
    if (!(($mask0 & 16) === 0))
      last_2 = false;
    return indexOf_1(_this_, other, startIndex, endIndex, ignoreCase, last_2);
  }
  function _no_name_provided__3($this_splitToSequence) {
    this._$this_splitToSequence = $this_splitToSequence;
  }
  _no_name_provided__3.prototype.invoke_3 = function (it) {
    return substring(this._$this_splitToSequence, it);
  };
  _no_name_provided__3.prototype.invoke_213 = function (p1) {
    return this.invoke_3(p1 instanceof IntRange ? p1 : THROW_CCE());
  };
  _no_name_provided__3.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__4($delimitersList, $ignoreCase) {
    this._$delimitersList = $delimitersList;
    this._$ignoreCase = $ignoreCase;
  }
  _no_name_provided__4.prototype.invoke_5 = function ($this$$receiver, currentIndex) {
    var tmp0_safe_receiver = findAnyOf($this$$receiver, this._$delimitersList, currentIndex, this._$ignoreCase, false);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      tmp = to(tmp0_safe_receiver._first, tmp0_safe_receiver._second.length);
    }
    return tmp;
  };
  _no_name_provided__4.prototype.invoke_293 = function (p1, p2) {
    var tmp = (!(p1 == null) ? isCharSequence(p1) : false) ? p1 : THROW_CCE();
    return this.invoke_5(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__4.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_1($this_splitToSequence) {
    var i = new _no_name_provided__3($this_splitToSequence);
    return function (p1) {
      return i.invoke_3(p1);
    };
  }
  function _no_name_provided_$factory_2($delimitersList, $ignoreCase) {
    var i = new _no_name_provided__4($delimitersList, $ignoreCase);
    return function (p1, p2) {
      return i.invoke_5(p1, p2);
    };
  }
  function NotImplementedError(message) {
    Error_init_$Init$(message, this);
    captureStack(this, NotImplementedError);
  }
  NotImplementedError.$metadata$ = {
    simpleName: 'NotImplementedError',
    kind: 'class',
    interfaces: []
  };
  function Pair(first_1, second) {
    this._first = first_1;
    this._second = second;
  }
  Pair.prototype.toString = function () {
    return '' + '(' + this._first + ', ' + this._second + ')';
  };
  Pair.prototype.component1_5 = function () {
    return this._first;
  };
  Pair.prototype.component2_6 = function () {
    return this._second;
  };
  Pair.prototype.hashCode = function () {
    var result = this._first == null ? 0 : hashCode(this._first);
    result = imul(result, 31) + (this._second == null ? 0 : hashCode(this._second)) | 0;
    return result;
  };
  Pair.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Pair))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Pair ? other : THROW_CCE();
    if (!equals_0(this._first, tmp0_other_with_cast._first))
      return false;
    if (!equals_0(this._second, tmp0_other_with_cast._second))
      return false;
    return true;
  };
  Pair.$metadata$ = {
    simpleName: 'Pair',
    kind: 'class',
    interfaces: [Serializable]
  };
  function to(_this_, that) {
    return new Pair(_this_, that);
  }
  function _UShort___init__impl_(data) {
    return data;
  }
  function _UShort___get_data__impl_(this_0) {
    return this_0;
  }
  function CharSequence() {
  }
  CharSequence.$metadata$ = {
    simpleName: 'CharSequence',
    kind: 'interface',
    interfaces: []
  };
  function Comparable() {
  }
  Comparable.$metadata$ = {
    simpleName: 'Comparable',
    kind: 'interface',
    interfaces: []
  };
  function Iterator() {
  }
  Iterator.$metadata$ = {
    simpleName: 'Iterator',
    kind: 'interface',
    interfaces: []
  };
  function MutableIterator() {
  }
  MutableIterator.$metadata$ = {
    simpleName: 'MutableIterator',
    kind: 'interface',
    interfaces: [Iterator]
  };
  function ListIterator() {
  }
  ListIterator.$metadata$ = {
    simpleName: 'ListIterator',
    kind: 'interface',
    interfaces: [Iterator]
  };
  function MutableListIterator() {
  }
  MutableListIterator.$metadata$ = {
    simpleName: 'MutableListIterator',
    kind: 'interface',
    interfaces: [ListIterator, MutableIterator]
  };
  function Number_0() {
  }
  Number_0.$metadata$ = {
    simpleName: 'Number',
    kind: 'class',
    interfaces: []
  };
  function IntIterator() {
  }
  IntIterator.prototype.next_10 = function () {
    return this.nextInt_0();
  };
  IntIterator.$metadata$ = {
    simpleName: 'IntIterator',
    kind: 'class',
    interfaces: [Iterator]
  };
  function IntProgressionIterator(first_1, last_2, step) {
    IntIterator.call(this);
    this._step = step;
    this._finalElement = last_2;
    this._hasNext = this._step > 0 ? first_1 <= last_2 : first_1 >= last_2;
    this._next = this._hasNext ? first_1 : this._finalElement;
  }
  IntProgressionIterator.prototype.hasNext_10 = function () {
    return this._hasNext;
  };
  IntProgressionIterator.prototype.nextInt_0 = function () {
    var value = this._next;
    if (value === this._finalElement) {
      if (!this._hasNext)
        throw NoSuchElementException_init_$Create$();
      this._hasNext = false;
    } else {
      var tmp0_this = this;
      tmp0_this._next = tmp0_this._next + this._step | 0;
    }
    return value;
  };
  IntProgressionIterator.$metadata$ = {
    simpleName: 'IntProgressionIterator',
    kind: 'class',
    interfaces: []
  };
  function Companion_3() {
    Companion_instance_2 = this;
  }
  Companion_3.prototype.fromClosedRange = function (rangeStart, rangeEnd, step) {
    return new IntProgression(rangeStart, rangeEnd, step);
  };
  Companion_3.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_2;
  function Companion_getInstance_2() {
    if (Companion_instance_2 == null)
      new Companion_3();
    return Companion_instance_2;
  }
  function IntProgression(start, endInclusive, step) {
    Companion_getInstance_2();
    if (step === 0)
      throw IllegalArgumentException_init_$Create$('Step must be non-zero.');
    if (step === IntCompanionObject_getInstance()._MIN_VALUE)
      throw IllegalArgumentException_init_$Create$('Step must be greater than Int.MIN_VALUE to avoid overflow on negation.');
    this._first_0 = start;
    this._last = getProgressionLastElement(start, endInclusive, step);
    this._step_0 = step;
  }
  IntProgression.prototype._get_first__0 = function () {
    return this._first_0;
  };
  IntProgression.prototype._get_last__0 = function () {
    return this._last;
  };
  IntProgression.prototype.iterator_29 = function () {
    return new IntProgressionIterator(this._first_0, this._last, this._step_0);
  };
  IntProgression.prototype.isEmpty_16 = function () {
    return this._step_0 > 0 ? this._first_0 > this._last : this._first_0 < this._last;
  };
  IntProgression.prototype.equals = function (other) {
    var tmp;
    if (other instanceof IntProgression) {
      tmp = (this.isEmpty_16() ? other.isEmpty_16() : false) ? true : (this._first_0 === other._first_0 ? this._last === other._last : false) ? this._step_0 === other._step_0 : false;
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  IntProgression.prototype.hashCode = function () {
    return this.isEmpty_16() ? -1 : imul(31, imul(31, this._first_0) + this._last | 0) + this._step_0 | 0;
  };
  IntProgression.prototype.toString = function () {
    return this._step_0 > 0 ? '' + this._first_0 + '..' + this._last + ' step ' + this._step_0 : '' + this._first_0 + ' downTo ' + this._last + ' step ' + (-this._step_0 | 0);
  };
  IntProgression.$metadata$ = {
    simpleName: 'IntProgression',
    kind: 'class',
    interfaces: [Iterable]
  };
  function ClosedRange() {
  }
  ClosedRange.$metadata$ = {
    simpleName: 'ClosedRange',
    kind: 'interface',
    interfaces: []
  };
  function Companion_4() {
    Companion_instance_3 = this;
    this._EMPTY = new IntRange(1, 0);
  }
  Companion_4.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_3;
  function Companion_getInstance_3() {
    if (Companion_instance_3 == null)
      new Companion_4();
    return Companion_instance_3;
  }
  function IntRange(start, endInclusive) {
    Companion_getInstance_3();
    IntProgression.call(this, start, endInclusive, 1);
  }
  IntRange.prototype._get_start_ = function () {
    return this._get_first__0();
  };
  IntRange.prototype._get_endInclusive_ = function () {
    return this._get_last__0();
  };
  IntRange.prototype.isEmpty_16 = function () {
    return this._get_first__0() > this._get_last__0();
  };
  IntRange.prototype.equals = function (other) {
    var tmp;
    if (other instanceof IntRange) {
      tmp = (this.isEmpty_16() ? other.isEmpty_16() : false) ? true : this._get_first__0() === other._get_first__0() ? this._get_last__0() === other._get_last__0() : false;
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  IntRange.prototype.hashCode = function () {
    return this.isEmpty_16() ? -1 : imul(31, this._get_first__0()) + this._get_last__0() | 0;
  };
  IntRange.prototype.toString = function () {
    return '' + this._get_first__0() + '..' + this._get_last__0();
  };
  IntRange.$metadata$ = {
    simpleName: 'IntRange',
    kind: 'class',
    interfaces: [ClosedRange]
  };
  function Unit() {
    Unit_instance = this;
  }
  Unit.prototype.toString = function () {
    return 'kotlin.Unit';
  };
  Unit.$metadata$ = {
    simpleName: 'Unit',
    kind: 'object',
    interfaces: []
  };
  var Unit_instance;
  function Unit_getInstance() {
    if (Unit_instance == null)
      new Unit();
    return Unit_instance;
  }
  function getProgressionLastElement(start, end, step) {
    var tmp;
    if (step > 0) {
      tmp = start >= end ? end : end - differenceModulo(end, start, step) | 0;
    } else if (step < 0) {
      tmp = start <= end ? end : end + differenceModulo(start, end, -step | 0) | 0;
    } else {
      throw IllegalArgumentException_init_$Create$('Step is zero.');
    }
    return tmp;
  }
  function differenceModulo(a, b, c) {
    return mod(mod(a, c) - mod(b, c) | 0, c);
  }
  function mod(a, b) {
    var mod_0 = a % b;
    return mod_0 >= 0 ? mod_0 : mod_0 + b | 0;
  }
  function IntCompanionObject_0() {
    IntCompanionObject_instance = this;
    this._MIN_VALUE = -2147483648;
    this._MAX_VALUE = 2147483647;
    this._SIZE_BYTES = 4;
    this._SIZE_BITS = 32;
  }
  IntCompanionObject_0.prototype._get_MIN_VALUE_ = function () {
    return this._MIN_VALUE;
  };
  IntCompanionObject_0.prototype._get_MAX_VALUE_ = function () {
    return this._MAX_VALUE;
  };
  IntCompanionObject_0.prototype._get_SIZE_BYTES_ = function () {
    return this._SIZE_BYTES;
  };
  IntCompanionObject_0.prototype._get_SIZE_BITS_ = function () {
    return this._SIZE_BITS;
  };
  IntCompanionObject_0.$metadata$ = {
    simpleName: 'IntCompanionObject',
    kind: 'object',
    interfaces: []
  };
  Object.defineProperty(IntCompanionObject_0.prototype, 'MIN_VALUE', {
    configurable: true,
    get: IntCompanionObject_0.prototype._get_MIN_VALUE_
  });
  Object.defineProperty(IntCompanionObject_0.prototype, 'MAX_VALUE', {
    configurable: true,
    get: IntCompanionObject_0.prototype._get_MAX_VALUE_
  });
  Object.defineProperty(IntCompanionObject_0.prototype, 'SIZE_BYTES', {
    configurable: true,
    get: IntCompanionObject_0.prototype._get_SIZE_BYTES_
  });
  Object.defineProperty(IntCompanionObject_0.prototype, 'SIZE_BITS', {
    configurable: true,
    get: IntCompanionObject_0.prototype._get_SIZE_BITS_
  });
  var IntCompanionObject_instance;
  function IntCompanionObject_getInstance() {
    if (IntCompanionObject_instance == null)
      new IntCompanionObject_0();
    return IntCompanionObject_instance;
  }
  function listOf_0(element) {
    return arrayListOf([element]);
  }
  function copyToArray_0(collection) {
    var tmp;
    if (collection.toArray !== undefined) {
      var tmp0_unsafeCast_0 = collection.toArray();
      tmp = tmp0_unsafeCast_0;
    } else {
      {
        var tmp1_unsafeCast_0 = copyToArrayImpl_0(collection);
        tmp = tmp1_unsafeCast_0;
      }
    }
    return tmp;
  }
  function copyToArrayImpl_0(collection) {
    var array = [];
    var iterator = collection.iterator_29();
    while (iterator.hasNext_10()) {
      array.push(iterator.next_10());
    }
    return array;
  }
  function AbstractMutableCollection() {
    AbstractCollection.call(this);
  }
  AbstractMutableCollection.prototype.toJSON = function () {
    return this.toArray();
  };
  AbstractMutableCollection.prototype.checkIsMutable_1 = function () {
  };
  AbstractMutableCollection.$metadata$ = {
    simpleName: 'AbstractMutableCollection',
    kind: 'class',
    interfaces: [MutableCollection]
  };
  function IteratorImpl($outer) {
    this._$this = $outer;
    this._index = 0;
    this._last_0 = -1;
  }
  IteratorImpl.prototype._set_index__0 = function (_set___) {
    this._index = _set___;
  };
  IteratorImpl.prototype.hasNext_10 = function () {
    return this._index < this._$this._get_size__23();
  };
  IteratorImpl.prototype.next_10 = function () {
    if (!this.hasNext_10())
      throw NoSuchElementException_init_$Create$();
    var tmp = this;
    var tmp0_this = this;
    var tmp1 = tmp0_this._index;
    tmp0_this._index = tmp1 + 1 | 0;
    tmp._last_0 = tmp1;
    return this._$this.get_24(this._last_0);
  };
  IteratorImpl.$metadata$ = {
    simpleName: 'IteratorImpl',
    kind: 'class',
    interfaces: [MutableIterator]
  };
  function ListIteratorImpl($outer, index) {
    this._$this_0 = $outer;
    IteratorImpl.call(this, $outer);
    Companion_getInstance().checkPositionIndex(index, this._$this_0._get_size__23());
    this._set_index__0(index);
  }
  ListIteratorImpl.$metadata$ = {
    simpleName: 'ListIteratorImpl',
    kind: 'class',
    interfaces: [MutableListIterator]
  };
  function AbstractMutableList() {
    AbstractMutableCollection.call(this);
    this._modCount = 0;
  }
  AbstractMutableList.prototype._set_modCount__0 = function (_set___) {
    this._modCount = _set___;
  };
  AbstractMutableList.prototype._get_modCount__0 = function () {
    return this._modCount;
  };
  AbstractMutableList.prototype.add_12 = function (element) {
    this.checkIsMutable_1();
    this.add_8(this._get_size__23(), element);
    return true;
  };
  AbstractMutableList.prototype.iterator_29 = function () {
    return new IteratorImpl(this);
  };
  AbstractMutableList.prototype.contains_10 = function (element) {
    return this.indexOf_0(element) >= 0;
  };
  AbstractMutableList.prototype.indexOf_0 = function (element) {
    var inductionVariable = 0;
    var last_2 = _get_lastIndex_(this);
    if (inductionVariable <= last_2)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (equals_0(this.get_24(index), element)) {
          return index;
        }}
       while (!(index === last_2));
    return -1;
  };
  AbstractMutableList.prototype.listIterator_2 = function (index) {
    return new ListIteratorImpl(this, index);
  };
  AbstractMutableList.prototype.equals = function (other) {
    if (other === this)
      return true;
    if (!(!(other == null) ? isInterface(other, List) : false))
      return false;
    else {
    }
    return Companion_getInstance().orderedEquals(this, other);
  };
  AbstractMutableList.prototype.hashCode = function () {
    return Companion_getInstance().orderedHashCode(this);
  };
  AbstractMutableList.$metadata$ = {
    simpleName: 'AbstractMutableList',
    kind: 'class',
    interfaces: [MutableList]
  };
  function _no_name_provided__5($entryIterator) {
    this._$entryIterator = $entryIterator;
  }
  _no_name_provided__5.prototype.hasNext_10 = function () {
    return this._$entryIterator.hasNext_10();
  };
  _no_name_provided__5.prototype.next_10 = function () {
    return this._$entryIterator.next_10()._get_key__5();
  };
  _no_name_provided__5.$metadata$ = {
    kind: 'class',
    interfaces: [MutableIterator]
  };
  function SimpleEntry(key, value) {
    this._key = key;
    this.__value = value;
  }
  SimpleEntry.prototype._get_key__5 = function () {
    return this._key;
  };
  SimpleEntry.prototype._get_value__11 = function () {
    return this.__value;
  };
  SimpleEntry.prototype.setValue_0 = function (newValue) {
    var oldValue = this.__value;
    this.__value = newValue;
    return oldValue;
  };
  SimpleEntry.prototype.hashCode = function () {
    return Companion_getInstance_0().entryHashCode(this);
  };
  SimpleEntry.prototype.toString = function () {
    return Companion_getInstance_0().entryToString(this);
  };
  SimpleEntry.prototype.equals = function (other) {
    return Companion_getInstance_0().entryEquals(this, other);
  };
  SimpleEntry.$metadata$ = {
    simpleName: 'SimpleEntry',
    kind: 'class',
    interfaces: [MutableEntry]
  };
  function AbstractEntrySet() {
    AbstractMutableSet.call(this);
  }
  AbstractEntrySet.prototype.contains_10 = function (element) {
    return this.containsEntry_2(element);
  };
  AbstractEntrySet.$metadata$ = {
    simpleName: 'AbstractEntrySet',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__6(this$0) {
    this._this$0_3 = this$0;
    AbstractMutableSet.call(this);
  }
  _no_name_provided__6.prototype.add_4 = function (element) {
    throw UnsupportedOperationException_init_$Create$_0('Add is not supported on keys');
  };
  _no_name_provided__6.prototype.add_12 = function (element) {
    return this.add_4((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  _no_name_provided__6.prototype.contains_12 = function (element) {
    return this._this$0_3.containsKey_2(element);
  };
  _no_name_provided__6.prototype.contains_10 = function (element) {
    if (!(element == null ? true : isObject(element)))
      return false;
    else {
    }
    return this.contains_12((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  _no_name_provided__6.prototype.iterator_29 = function () {
    var entryIterator = this._this$0_3._get_entries__3().iterator_29();
    return new _no_name_provided__5(entryIterator);
  };
  _no_name_provided__6.prototype._get_size__23 = function () {
    return this._this$0_3._get_size__23();
  };
  _no_name_provided__6.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function AbstractMutableMap() {
    AbstractMap.call(this);
    this.__keys_0 = null;
    this.__values_0 = null;
  }
  AbstractMutableMap.prototype._get_keys__0 = function () {
    if (this.__keys_0 == null) {
      var tmp = this;
      tmp.__keys_0 = new _no_name_provided__6(this);
    }return ensureNotNull(this.__keys_0);
  };
  AbstractMutableMap.$metadata$ = {
    simpleName: 'AbstractMutableMap',
    kind: 'class',
    interfaces: [MutableMap]
  };
  function AbstractMutableSet() {
    AbstractMutableCollection.call(this);
  }
  AbstractMutableSet.prototype.equals = function (other) {
    if (other === this)
      return true;
    if (!(!(other == null) ? isInterface(other, Set) : false))
      return false;
    else {
    }
    return Companion_getInstance_1().setEquals(this, other);
  };
  AbstractMutableSet.prototype.hashCode = function () {
    return Companion_getInstance_1().unorderedHashCode(this);
  };
  AbstractMutableSet.$metadata$ = {
    simpleName: 'AbstractMutableSet',
    kind: 'class',
    interfaces: [MutableSet]
  };
  function ArrayList_init_$Init$($this) {
    ArrayList.call($this, []);
    return $this;
  }
  function ArrayList_init_$Create$() {
    return ArrayList_init_$Init$(Object.create(ArrayList.prototype));
  }
  function ArrayList_init_$Init$_0(initialCapacity, $this) {
    ArrayList.call($this, []);
    return $this;
  }
  function ArrayList_init_$Create$_0(initialCapacity) {
    return ArrayList_init_$Init$_0(initialCapacity, Object.create(ArrayList.prototype));
  }
  function ArrayList_init_$Init$_1(elements, $this) {
    ArrayList.call($this, copyToArray_0(elements));
    return $this;
  }
  function ArrayList_init_$Create$_1(elements) {
    return ArrayList_init_$Init$_1(elements, Object.create(ArrayList.prototype));
  }
  function rangeCheck($this, index) {
    Companion_getInstance().checkElementIndex(index, $this._get_size__23());
    return index;
  }
  function insertionRangeCheck($this, index) {
    Companion_getInstance().checkPositionIndex(index, $this._get_size__23());
    return index;
  }
  function ArrayList(array) {
    AbstractMutableList.call(this);
    this._array = array;
    this._isReadOnly = false;
  }
  ArrayList.prototype._get_size__23 = function () {
    return this._array.length;
  };
  ArrayList.prototype.get_24 = function (index) {
    var tmp = this._array[rangeCheck(this, index)];
    return (tmp == null ? true : isObject(tmp)) ? tmp : THROW_CCE();
  };
  ArrayList.prototype.add_12 = function (element) {
    this.checkIsMutable_1();
    var tmp0_asDynamic_0 = this._array;
    tmp0_asDynamic_0.push(element);
    var tmp0_this = this;
    var tmp1 = tmp0_this._get_modCount__0();
    tmp0_this._set_modCount__0(tmp1 + 1 | 0);
    Unit_getInstance();
    return true;
  };
  ArrayList.prototype.add_8 = function (index, element) {
    this.checkIsMutable_1();
    var tmp0_asDynamic_0 = this._array;
    tmp0_asDynamic_0.splice(insertionRangeCheck(this, index), 0, element);
    var tmp0_this = this;
    var tmp1 = tmp0_this._get_modCount__0();
    tmp0_this._set_modCount__0(tmp1 + 1 | 0);
    Unit_getInstance();
  };
  ArrayList.prototype.removeAt = function (index) {
    this.checkIsMutable_1();
    rangeCheck(this, index);
    Unit_getInstance();
    var tmp0_this = this;
    var tmp1 = tmp0_this._get_modCount__0();
    tmp0_this._set_modCount__0(tmp1 + 1 | 0);
    Unit_getInstance();
    var tmp;
    if (index === _get_lastIndex_(this)) {
      var tmp0_asDynamic_0 = this._array;
      tmp = tmp0_asDynamic_0.pop();
    } else {
      var tmp1_asDynamic_0 = this._array;
      tmp = tmp1_asDynamic_0.splice(index, 1)[0];
    }
    return tmp;
  };
  ArrayList.prototype.clear_0 = function () {
    this.checkIsMutable_1();
    var tmp = this;
    tmp._array = [];
    var tmp0_this = this;
    var tmp1 = tmp0_this._get_modCount__0();
    tmp0_this._set_modCount__0(tmp1 + 1 | 0);
    Unit_getInstance();
  };
  ArrayList.prototype.indexOf_0 = function (element) {
    return indexOf(this._array, element);
  };
  ArrayList.prototype.toString = function () {
    return arrayToString(this._array);
  };
  ArrayList.prototype.toArray_0 = function () {
    return [].slice.call(this._array);
  };
  ArrayList.prototype.toArray = function () {
    return this.toArray_0();
  };
  ArrayList.prototype.checkIsMutable_1 = function () {
    if (this._isReadOnly)
      throw UnsupportedOperationException_init_$Create$();
  };
  ArrayList.$metadata$ = {
    simpleName: 'ArrayList',
    kind: 'class',
    interfaces: [MutableList, RandomAccess]
  };
  function HashCode() {
    HashCode_instance = this;
  }
  HashCode.prototype.equals_1 = function (value1, value2) {
    return equals_0(value1, value2);
  };
  HashCode.prototype.getHashCode_0 = function (value) {
    var tmp0_safe_receiver = value;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  };
  HashCode.$metadata$ = {
    simpleName: 'HashCode',
    kind: 'object',
    interfaces: [EqualityComparator]
  };
  var HashCode_instance;
  function HashCode_getInstance() {
    if (HashCode_instance == null)
      new HashCode();
    return HashCode_instance;
  }
  function EqualityComparator() {
  }
  EqualityComparator.$metadata$ = {
    simpleName: 'EqualityComparator',
    kind: 'interface',
    interfaces: []
  };
  function EntrySet($outer) {
    this._$this_1 = $outer;
    AbstractEntrySet.call(this);
  }
  EntrySet.prototype.add_9 = function (element) {
    throw UnsupportedOperationException_init_$Create$_0('Add is not supported on entries');
  };
  EntrySet.prototype.add_12 = function (element) {
    return this.add_9((!(element == null) ? isInterface(element, MutableEntry) : false) ? element : THROW_CCE());
  };
  EntrySet.prototype.containsEntry_2 = function (element) {
    return this._$this_1.containsEntry_3(element);
  };
  EntrySet.prototype.iterator_29 = function () {
    return this._$this_1._internalMap.iterator_29();
  };
  EntrySet.prototype._get_size__23 = function () {
    return this._$this_1._get_size__23();
  };
  EntrySet.$metadata$ = {
    simpleName: 'EntrySet',
    kind: 'class',
    interfaces: []
  };
  function HashMap_init_$Init$(internalMap, $this) {
    AbstractMutableMap.call($this);
    HashMap.call($this);
    $this._internalMap = internalMap;
    $this._equality = internalMap._get_equality__0();
    return $this;
  }
  function HashMap_init_$Init$_0($this) {
    HashMap_init_$Init$(new InternalHashCodeMap(HashCode_getInstance()), $this);
    return $this;
  }
  function HashMap_init_$Create$() {
    return HashMap_init_$Init$_0(Object.create(HashMap.prototype));
  }
  HashMap.prototype.containsKey_2 = function (key) {
    return this._internalMap.contains_12(key);
  };
  HashMap.prototype._get_entries__3 = function () {
    if (this.__entries == null) {
      this.__entries = this.createEntrySet();
    }return ensureNotNull(this.__entries);
  };
  HashMap.prototype.createEntrySet = function () {
    return new EntrySet(this);
  };
  HashMap.prototype.get_11 = function (key) {
    return this._internalMap.get_11(key);
  };
  HashMap.prototype.put_2 = function (key, value) {
    return this._internalMap.put_2(key, value);
  };
  HashMap.prototype._get_size__23 = function () {
    return this._internalMap._get_size__23();
  };
  function HashMap() {
    this.__entries = null;
  }
  HashMap.$metadata$ = {
    simpleName: 'HashMap',
    kind: 'class',
    interfaces: [MutableMap]
  };
  function HashSet_init_$Init$($this) {
    AbstractMutableSet.call($this);
    HashSet.call($this);
    $this._map = HashMap_init_$Create$();
    return $this;
  }
  function HashSet_init_$Create$() {
    return HashSet_init_$Init$(Object.create(HashSet.prototype));
  }
  HashSet.prototype.add_12 = function (element) {
    var old = this._map.put_2(element, this);
    return old == null;
  };
  HashSet.prototype.contains_10 = function (element) {
    return this._map.containsKey_2(element);
  };
  HashSet.prototype.isEmpty_16 = function () {
    return this._map.isEmpty_16();
  };
  HashSet.prototype.iterator_29 = function () {
    return this._map._get_keys__0().iterator_29();
  };
  HashSet.prototype._get_size__23 = function () {
    return this._map._get_size__23();
  };
  function HashSet() {
  }
  HashSet.$metadata$ = {
    simpleName: 'HashSet',
    kind: 'class',
    interfaces: [MutableSet]
  };
  function computeNext($this) {
    if ($this._chainOrEntry != null ? $this._isChain : false) {
      var tmp0_unsafeCast_0 = $this._chainOrEntry;
      var chainSize = tmp0_unsafeCast_0.length;
      var tmp0_this = $this;
      tmp0_this._itemIndex = tmp0_this._itemIndex + 1 | 0;
      if (tmp0_this._itemIndex < chainSize)
        return 0;
      else {
      }
    }var tmp1_this = $this;
    tmp1_this._keyIndex = tmp1_this._keyIndex + 1 | 0;
    if (tmp1_this._keyIndex < $this._keys.length) {
      $this._chainOrEntry = $this._this$0_4._backingMap[$this._keys[$this._keyIndex]];
      var tmp = $this;
      var tmp_0 = $this._chainOrEntry;
      tmp._isChain = !(tmp_0 == null) ? isArray(tmp_0) : false;
      $this._itemIndex = 0;
      return 0;
    } else {
      {
        $this._chainOrEntry = null;
        return 1;
      }
    }
  }
  function getEntry($this, key) {
    var tmp0_elvis_lhs = getChainOrEntryOrNull($this, $this._equality_0.getHashCode_0(key));
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var chainOrEntry = tmp;
    if (!(!(chainOrEntry == null) ? isArray(chainOrEntry) : false)) {
      var entry = chainOrEntry;
      if ($this._equality_0.equals_1(entry._get_key__5(), key)) {
        return entry;
      } else {
        return null;
      }
    } else {
      {
        var chain = chainOrEntry;
        return findEntryInChain(chain, $this, key);
      }
    }
  }
  function findEntryInChain(_this_, $this, key) {
    var tmp$ret$0;
    l$ret$1: do {
      var indexedObject = _this_;
      var inductionVariable = 0;
      var last_2 = indexedObject.length;
      while (inductionVariable < last_2) {
        var element_2 = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if ($this._equality_0.equals_1(element_2._get_key__5(), key)) {
          tmp$ret$0 = element_2;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = null;
    }
     while (false);
    return tmp$ret$0;
  }
  function getChainOrEntryOrNull($this, hashCode_1) {
    var chainOrEntry = $this._backingMap[hashCode_1];
    return chainOrEntry === undefined ? null : chainOrEntry;
  }
  function _no_name_provided__7(this$0) {
    this._this$0_4 = this$0;
    this._state = -1;
    this._keys = Object.keys(this._this$0_4._backingMap);
    this._keyIndex = -1;
    this._chainOrEntry = null;
    this._isChain = false;
    this._itemIndex = -1;
    this._lastEntry = null;
  }
  _no_name_provided__7.prototype.hasNext_10 = function () {
    if (this._state === -1)
      this._state = computeNext(this);
    return this._state === 0;
  };
  _no_name_provided__7.prototype.next_10 = function () {
    if (!this.hasNext_10())
      throw NoSuchElementException_init_$Create$();
    var tmp;
    if (this._isChain) {
      var tmp0_unsafeCast_0 = this._chainOrEntry;
      tmp = tmp0_unsafeCast_0[this._itemIndex];
    } else {
      var tmp1_unsafeCast_0 = this._chainOrEntry;
      tmp = tmp1_unsafeCast_0;
    }
    var lastEntry = tmp;
    this._lastEntry = lastEntry;
    this._state = -1;
    return lastEntry;
  };
  _no_name_provided__7.$metadata$ = {
    kind: 'class',
    interfaces: [MutableIterator]
  };
  function InternalHashCodeMap(equality) {
    this._equality_0 = equality;
    this._backingMap = this.createJsMap_0();
    this._size = 0;
  }
  InternalHashCodeMap.prototype._get_equality__0 = function () {
    return this._equality_0;
  };
  InternalHashCodeMap.prototype._get_size__23 = function () {
    return this._size;
  };
  InternalHashCodeMap.prototype.put_2 = function (key, value) {
    var hashCode_1 = this._equality_0.getHashCode_0(key);
    var chainOrEntry = getChainOrEntryOrNull(this, hashCode_1);
    if (chainOrEntry == null) {
      this._backingMap[hashCode_1] = new SimpleEntry(key, value);
    } else {
      if (!(!(chainOrEntry == null) ? isArray(chainOrEntry) : false)) {
        var entry = chainOrEntry;
        if (this._equality_0.equals_1(entry._get_key__5(), key)) {
          return entry.setValue_0(value);
        } else {
          var tmp0_arrayOf_0 = [entry, new SimpleEntry(key, value)];
          this._backingMap[hashCode_1] = tmp0_arrayOf_0;
          var tmp0_this = this;
          var tmp1 = tmp0_this._size;
          tmp0_this._size = tmp1 + 1 | 0;
          Unit_getInstance();
          return null;
        }
      } else {
        {
          var chain = chainOrEntry;
          var entry_0 = findEntryInChain(chain, this, key);
          if (!(entry_0 == null)) {
            return entry_0.setValue_0(value);
          }chain.push(new SimpleEntry(key, value));
        }
      }
    }
    var tmp2_this = this;
    var tmp3 = tmp2_this._size;
    tmp2_this._size = tmp3 + 1 | 0;
    Unit_getInstance();
    return null;
  };
  InternalHashCodeMap.prototype.contains_12 = function (key) {
    return !(getEntry(this, key) == null);
  };
  InternalHashCodeMap.prototype.get_11 = function (key) {
    var tmp0_safe_receiver = getEntry(this, key);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_value__11();
  };
  InternalHashCodeMap.prototype.iterator_29 = function () {
    return new _no_name_provided__7(this);
  };
  InternalHashCodeMap.$metadata$ = {
    simpleName: 'InternalHashCodeMap',
    kind: 'class',
    interfaces: [InternalMap]
  };
  function InternalMap() {
  }
  InternalMap.prototype.createJsMap_0 = function () {
    var result = Object.create(null);
    result['foo'] = 1;
    jsDeleteProperty(result, 'foo');
    return result;
  };
  InternalMap.$metadata$ = {
    simpleName: 'InternalMap',
    kind: 'interface',
    interfaces: [MutableIterable]
  };
  function RandomAccess() {
  }
  RandomAccess.$metadata$ = {
    simpleName: 'RandomAccess',
    kind: 'interface',
    interfaces: []
  };
  var output;
  function BaseOutput() {
  }
  BaseOutput.prototype.println_5 = function () {
    this.print_3('\n');
  };
  BaseOutput.prototype.println_6 = function (message) {
    this.print_3(message);
    this.println_5();
  };
  BaseOutput.$metadata$ = {
    simpleName: 'BaseOutput',
    kind: 'class',
    interfaces: []
  };
  function NodeJsOutput_0(outputStream) {
    BaseOutput.call(this);
    this._outputStream = outputStream;
  }
  NodeJsOutput_0.prototype.print_3 = function (message) {
    var messageString = String(message);
    this._outputStream.write(messageString);
  };
  NodeJsOutput_0.$metadata$ = {
    simpleName: 'NodeJsOutput',
    kind: 'class',
    interfaces: []
  };
  function BufferedOutputToConsoleLog_0() {
    BufferedOutput_0.call(this);
  }
  BufferedOutputToConsoleLog_0.prototype.print_3 = function (message) {
    var s = String(message);
    var tmp0_nativeLastIndexOf_0 = s;
    var tmp1_nativeLastIndexOf_0 = '\n';
    var tmp2_nativeLastIndexOf_0 = 0;
    var i = tmp0_nativeLastIndexOf_0.lastIndexOf(tmp1_nativeLastIndexOf_0, tmp2_nativeLastIndexOf_0);
    if (i >= 0) {
      var tmp0_this = this;
      var tmp = tmp0_this._get_buffer__3();
      var tmp3_substring_0 = s;
      var tmp4_substring_0 = 0;
      tmp0_this._set_buffer__0(tmp + tmp3_substring_0.substring(tmp4_substring_0, i));
      this.flush();
      var tmp5_substring_0 = s;
      var tmp6_substring_0 = i + 1 | 0;
      s = tmp5_substring_0.substring(tmp6_substring_0);
    }var tmp1_this = this;
    tmp1_this._set_buffer__0(tmp1_this._get_buffer__3() + s);
  };
  BufferedOutputToConsoleLog_0.prototype.flush = function () {
    (function () {
      var $externalVarargReceiverTmp = console;
      return $externalVarargReceiverTmp.log.apply($externalVarargReceiverTmp, [].concat([this._get_buffer__3()]));
    }.call(this));
    this._set_buffer__0('');
  };
  BufferedOutputToConsoleLog_0.$metadata$ = {
    simpleName: 'BufferedOutputToConsoleLog',
    kind: 'class',
    interfaces: []
  };
  function BufferedOutput_0() {
    BaseOutput.call(this);
    this._buffer = '';
  }
  BufferedOutput_0.prototype._set_buffer__0 = function (_set___) {
    this._buffer = _set___;
  };
  BufferedOutput_0.prototype._get_buffer__3 = function () {
    return this._buffer;
  };
  BufferedOutput_0.prototype.print_3 = function (message) {
    var tmp0_this = this;
    var tmp = tmp0_this;
    var tmp_0 = tmp0_this._buffer;
    tmp._buffer = tmp_0 + String(message);
  };
  BufferedOutput_0.$metadata$ = {
    simpleName: 'BufferedOutput',
    kind: 'class',
    interfaces: []
  };
  function println(message) {
    output.println_6(message);
  }
  function output$init$() {
    var isNode_2 = typeof process !== 'undefined' && process.versions && !!process.versions.node;
    return isNode_2 ? new NodeJsOutput_0(process.stdout) : new BufferedOutputToConsoleLog_0();
  }
  function Serializable() {
  }
  Serializable.$metadata$ = {
    simpleName: 'Serializable',
    kind: 'interface',
    interfaces: []
  };
  function isNaN_0(_this_) {
    return !(_this_ === _this_);
  }
  function _get_js_(_this_) {
    return (_this_ instanceof KClassImpl ? _this_ : THROW_CCE())._get_jClass__2();
  }
  function KCallable() {
  }
  KCallable.$metadata$ = {
    simpleName: 'KCallable',
    kind: 'interface',
    interfaces: []
  };
  function KClass() {
  }
  KClass.$metadata$ = {
    simpleName: 'KClass',
    kind: 'interface',
    interfaces: [KClassifier]
  };
  function KClassImpl(jClass) {
    this._jClass = jClass;
  }
  KClassImpl.prototype._get_jClass__2 = function () {
    return this._jClass;
  };
  KClassImpl.prototype.equals = function (other) {
    var tmp;
    if (other instanceof KClassImpl) {
      tmp = equals_0(this._get_jClass__2(), other._get_jClass__2());
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  KClassImpl.prototype.hashCode = function () {
    var tmp0_safe_receiver = this._get_simpleName__2();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : getStringHashCode(tmp0_safe_receiver);
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  };
  KClassImpl.prototype.toString = function () {
    return '' + 'class ' + this._get_simpleName__2();
  };
  KClassImpl.$metadata$ = {
    simpleName: 'KClassImpl',
    kind: 'class',
    interfaces: [KClass]
  };
  function PrimitiveKClassImpl(jClass, givenSimpleName, isInstanceFunction) {
    KClassImpl.call(this, jClass);
    this._givenSimpleName = givenSimpleName;
    this._isInstanceFunction = isInstanceFunction;
  }
  PrimitiveKClassImpl.prototype.equals = function (other) {
    if (!(other instanceof PrimitiveKClassImpl))
      return false;
    else {
    }
    return KClassImpl.prototype.equals.call(this, other) ? this._givenSimpleName === other._givenSimpleName : false;
  };
  PrimitiveKClassImpl.prototype._get_simpleName__2 = function () {
    return this._givenSimpleName;
  };
  PrimitiveKClassImpl.$metadata$ = {
    simpleName: 'PrimitiveKClassImpl',
    kind: 'class',
    interfaces: []
  };
  function NothingKClassImpl() {
    NothingKClassImpl_instance = this;
    KClassImpl.call(this, Object);
    this._simpleName = 'Nothing';
  }
  NothingKClassImpl.prototype._get_simpleName__2 = function () {
    return this._simpleName;
  };
  NothingKClassImpl.prototype._get_jClass__2 = function () {
    throw UnsupportedOperationException_init_$Create$_0("There's no native JS class for Nothing type");
  };
  NothingKClassImpl.prototype.equals = function (other) {
    return other === this;
  };
  NothingKClassImpl.prototype.hashCode = function () {
    return 0;
  };
  NothingKClassImpl.$metadata$ = {
    simpleName: 'NothingKClassImpl',
    kind: 'object',
    interfaces: []
  };
  var NothingKClassImpl_instance;
  function NothingKClassImpl_getInstance() {
    if (NothingKClassImpl_instance == null)
      new NothingKClassImpl();
    return NothingKClassImpl_instance;
  }
  function ErrorKClass() {
  }
  ErrorKClass.prototype.equals = function (other) {
    return other === this;
  };
  ErrorKClass.prototype.hashCode = function () {
    return 0;
  };
  ErrorKClass.$metadata$ = {
    simpleName: 'ErrorKClass',
    kind: 'class',
    interfaces: [KClass]
  };
  function SimpleKClassImpl(jClass) {
    KClassImpl.call(this, jClass);
    var tmp = this;
    var tmp0_safe_receiver = jClass.$metadata$;
    var tmp0_unsafeCast_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.simpleName;
    tmp._simpleName_0 = tmp0_unsafeCast_0;
  }
  SimpleKClassImpl.prototype._get_simpleName__2 = function () {
    return this._simpleName_0;
  };
  SimpleKClassImpl.$metadata$ = {
    simpleName: 'SimpleKClassImpl',
    kind: 'class',
    interfaces: []
  };
  function KFunction() {
  }
  KFunction.$metadata$ = {
    simpleName: 'KFunction',
    kind: 'interface',
    interfaces: [KCallable]
  };
  var functionClasses;
  function _no_name_provided__8() {
  }
  _no_name_provided__8.prototype.invoke_47 = function (it) {
    return isObject(it);
  };
  _no_name_provided__8.prototype.invoke_213 = function (p1) {
    return this.invoke_47((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__8.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__9() {
  }
  _no_name_provided__9.prototype.invoke_47 = function (it) {
    return isNumber(it);
  };
  _no_name_provided__9.prototype.invoke_213 = function (p1) {
    return this.invoke_47((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__9.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__10() {
  }
  _no_name_provided__10.prototype.invoke_47 = function (it) {
    return !(it == null) ? typeof it === 'boolean' : false;
  };
  _no_name_provided__10.prototype.invoke_213 = function (p1) {
    return this.invoke_47((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__10.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__11() {
  }
  _no_name_provided__11.prototype.invoke_47 = function (it) {
    return !(it == null) ? typeof it === 'number' : false;
  };
  _no_name_provided__11.prototype.invoke_213 = function (p1) {
    return this.invoke_47((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__11.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__12() {
  }
  _no_name_provided__12.prototype.invoke_47 = function (it) {
    return !(it == null) ? typeof it === 'number' : false;
  };
  _no_name_provided__12.prototype.invoke_213 = function (p1) {
    return this.invoke_47((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__12.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__13() {
  }
  _no_name_provided__13.prototype.invoke_47 = function (it) {
    return !(it == null) ? typeof it === 'number' : false;
  };
  _no_name_provided__13.prototype.invoke_213 = function (p1) {
    return this.invoke_47((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__13.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__14() {
  }
  _no_name_provided__14.prototype.invoke_47 = function (it) {
    return !(it == null) ? typeof it === 'number' : false;
  };
  _no_name_provided__14.prototype.invoke_213 = function (p1) {
    return this.invoke_47((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__14.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__15() {
  }
  _no_name_provided__15.prototype.invoke_47 = function (it) {
    return !(it == null) ? typeof it === 'number' : false;
  };
  _no_name_provided__15.prototype.invoke_213 = function (p1) {
    return this.invoke_47((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__15.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__16() {
  }
  _no_name_provided__16.prototype.invoke_47 = function (it) {
    return !(it == null) ? isArray(it) : false;
  };
  _no_name_provided__16.prototype.invoke_213 = function (p1) {
    return this.invoke_47((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__16.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__17() {
  }
  _no_name_provided__17.prototype.invoke_47 = function (it) {
    return !(it == null) ? typeof it === 'string' : false;
  };
  _no_name_provided__17.prototype.invoke_213 = function (p1) {
    return this.invoke_47((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__17.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__18() {
  }
  _no_name_provided__18.prototype.invoke_47 = function (it) {
    return it instanceof Error;
  };
  _no_name_provided__18.prototype.invoke_213 = function (p1) {
    return this.invoke_47((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__18.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__19() {
  }
  _no_name_provided__19.prototype.invoke_47 = function (it) {
    return !(it == null) ? isBooleanArray(it) : false;
  };
  _no_name_provided__19.prototype.invoke_213 = function (p1) {
    return this.invoke_47((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__19.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__20() {
  }
  _no_name_provided__20.prototype.invoke_47 = function (it) {
    return !(it == null) ? isCharArray(it) : false;
  };
  _no_name_provided__20.prototype.invoke_213 = function (p1) {
    return this.invoke_47((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__20.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__21() {
  }
  _no_name_provided__21.prototype.invoke_47 = function (it) {
    return !(it == null) ? isByteArray(it) : false;
  };
  _no_name_provided__21.prototype.invoke_213 = function (p1) {
    return this.invoke_47((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__21.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__22() {
  }
  _no_name_provided__22.prototype.invoke_47 = function (it) {
    return !(it == null) ? isShortArray(it) : false;
  };
  _no_name_provided__22.prototype.invoke_213 = function (p1) {
    return this.invoke_47((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__22.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__23() {
  }
  _no_name_provided__23.prototype.invoke_47 = function (it) {
    return !(it == null) ? isIntArray(it) : false;
  };
  _no_name_provided__23.prototype.invoke_213 = function (p1) {
    return this.invoke_47((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__23.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__24() {
  }
  _no_name_provided__24.prototype.invoke_47 = function (it) {
    return !(it == null) ? isLongArray(it) : false;
  };
  _no_name_provided__24.prototype.invoke_213 = function (p1) {
    return this.invoke_47((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__24.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__25() {
  }
  _no_name_provided__25.prototype.invoke_47 = function (it) {
    return !(it == null) ? isFloatArray(it) : false;
  };
  _no_name_provided__25.prototype.invoke_213 = function (p1) {
    return this.invoke_47((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__25.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__26() {
  }
  _no_name_provided__26.prototype.invoke_47 = function (it) {
    return !(it == null) ? isDoubleArray(it) : false;
  };
  _no_name_provided__26.prototype.invoke_213 = function (p1) {
    return this.invoke_47((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__26.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__27($arity) {
    this._$arity = $arity;
  }
  _no_name_provided__27.prototype.invoke_47 = function (it) {
    var tmp;
    if (typeof it === 'function') {
      tmp = it.length === this._$arity;
    } else {
      tmp = false;
    }
    return tmp;
  };
  _no_name_provided__27.prototype.invoke_213 = function (p1) {
    return this.invoke_47((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__27.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function PrimitiveClasses_0() {
    PrimitiveClasses_instance = this;
    var tmp = this;
    var tmp0_unsafeCast_0 = Object;
    var tmp_0 = tmp0_unsafeCast_0;
    tmp._anyClass = new PrimitiveKClassImpl(tmp_0, 'Any', _no_name_provided_$factory_3());
    var tmp_1 = this;
    var tmp0_unsafeCast_0_0 = Number;
    var tmp_2 = tmp0_unsafeCast_0_0;
    tmp_1._numberClass = new PrimitiveKClassImpl(tmp_2, 'Number', _no_name_provided_$factory_4());
    this._nothingClass = NothingKClassImpl_getInstance();
    var tmp_3 = this;
    var tmp0_unsafeCast_0_1 = Boolean;
    var tmp_4 = tmp0_unsafeCast_0_1;
    tmp_3._booleanClass = new PrimitiveKClassImpl(tmp_4, 'Boolean', _no_name_provided_$factory_5());
    var tmp_5 = this;
    var tmp0_unsafeCast_0_2 = Number;
    var tmp_6 = tmp0_unsafeCast_0_2;
    tmp_5._byteClass = new PrimitiveKClassImpl(tmp_6, 'Byte', _no_name_provided_$factory_6());
    var tmp_7 = this;
    var tmp0_unsafeCast_0_3 = Number;
    var tmp_8 = tmp0_unsafeCast_0_3;
    tmp_7._shortClass = new PrimitiveKClassImpl(tmp_8, 'Short', _no_name_provided_$factory_7());
    var tmp_9 = this;
    var tmp0_unsafeCast_0_4 = Number;
    var tmp_10 = tmp0_unsafeCast_0_4;
    tmp_9._intClass = new PrimitiveKClassImpl(tmp_10, 'Int', _no_name_provided_$factory_8());
    var tmp_11 = this;
    var tmp0_unsafeCast_0_5 = Number;
    var tmp_12 = tmp0_unsafeCast_0_5;
    tmp_11._floatClass = new PrimitiveKClassImpl(tmp_12, 'Float', _no_name_provided_$factory_9());
    var tmp_13 = this;
    var tmp0_unsafeCast_0_6 = Number;
    var tmp_14 = tmp0_unsafeCast_0_6;
    tmp_13._doubleClass = new PrimitiveKClassImpl(tmp_14, 'Double', _no_name_provided_$factory_10());
    var tmp_15 = this;
    var tmp0_unsafeCast_0_7 = Array;
    var tmp_16 = tmp0_unsafeCast_0_7;
    tmp_15._arrayClass = new PrimitiveKClassImpl(tmp_16, 'Array', _no_name_provided_$factory_11());
    var tmp_17 = this;
    var tmp0_unsafeCast_0_8 = String;
    var tmp_18 = tmp0_unsafeCast_0_8;
    tmp_17._stringClass = new PrimitiveKClassImpl(tmp_18, 'String', _no_name_provided_$factory_12());
    var tmp_19 = this;
    var tmp0_unsafeCast_0_9 = Error;
    var tmp_20 = tmp0_unsafeCast_0_9;
    tmp_19._throwableClass = new PrimitiveKClassImpl(tmp_20, 'Throwable', _no_name_provided_$factory_13());
    var tmp_21 = this;
    var tmp0_unsafeCast_0_10 = Array;
    var tmp_22 = tmp0_unsafeCast_0_10;
    tmp_21._booleanArrayClass = new PrimitiveKClassImpl(tmp_22, 'BooleanArray', _no_name_provided_$factory_14());
    var tmp_23 = this;
    var tmp0_unsafeCast_0_11 = Uint16Array;
    var tmp_24 = tmp0_unsafeCast_0_11;
    tmp_23._charArrayClass = new PrimitiveKClassImpl(tmp_24, 'CharArray', _no_name_provided_$factory_15());
    var tmp_25 = this;
    var tmp0_unsafeCast_0_12 = Int8Array;
    var tmp_26 = tmp0_unsafeCast_0_12;
    tmp_25._byteArrayClass = new PrimitiveKClassImpl(tmp_26, 'ByteArray', _no_name_provided_$factory_16());
    var tmp_27 = this;
    var tmp0_unsafeCast_0_13 = Int16Array;
    var tmp_28 = tmp0_unsafeCast_0_13;
    tmp_27._shortArrayClass = new PrimitiveKClassImpl(tmp_28, 'ShortArray', _no_name_provided_$factory_17());
    var tmp_29 = this;
    var tmp0_unsafeCast_0_14 = Int32Array;
    var tmp_30 = tmp0_unsafeCast_0_14;
    tmp_29._intArrayClass = new PrimitiveKClassImpl(tmp_30, 'IntArray', _no_name_provided_$factory_18());
    var tmp_31 = this;
    var tmp0_unsafeCast_0_15 = Array;
    var tmp_32 = tmp0_unsafeCast_0_15;
    tmp_31._longArrayClass = new PrimitiveKClassImpl(tmp_32, 'LongArray', _no_name_provided_$factory_19());
    var tmp_33 = this;
    var tmp0_unsafeCast_0_16 = Float32Array;
    var tmp_34 = tmp0_unsafeCast_0_16;
    tmp_33._floatArrayClass = new PrimitiveKClassImpl(tmp_34, 'FloatArray', _no_name_provided_$factory_20());
    var tmp_35 = this;
    var tmp0_unsafeCast_0_17 = Float64Array;
    var tmp_36 = tmp0_unsafeCast_0_17;
    tmp_35._doubleArrayClass = new PrimitiveKClassImpl(tmp_36, 'DoubleArray', _no_name_provided_$factory_21());
  }
  PrimitiveClasses_0.prototype._get_anyClass_ = function () {
    return this._anyClass;
  };
  PrimitiveClasses_0.prototype._get_numberClass_ = function () {
    return this._numberClass;
  };
  PrimitiveClasses_0.prototype._get_nothingClass_ = function () {
    return this._nothingClass;
  };
  PrimitiveClasses_0.prototype._get_booleanClass_ = function () {
    return this._booleanClass;
  };
  PrimitiveClasses_0.prototype._get_byteClass_ = function () {
    return this._byteClass;
  };
  PrimitiveClasses_0.prototype._get_shortClass_ = function () {
    return this._shortClass;
  };
  PrimitiveClasses_0.prototype._get_intClass_ = function () {
    return this._intClass;
  };
  PrimitiveClasses_0.prototype._get_floatClass_ = function () {
    return this._floatClass;
  };
  PrimitiveClasses_0.prototype._get_doubleClass_ = function () {
    return this._doubleClass;
  };
  PrimitiveClasses_0.prototype._get_arrayClass_ = function () {
    return this._arrayClass;
  };
  PrimitiveClasses_0.prototype._get_stringClass_ = function () {
    return this._stringClass;
  };
  PrimitiveClasses_0.prototype._get_throwableClass_ = function () {
    return this._throwableClass;
  };
  PrimitiveClasses_0.prototype._get_booleanArrayClass_ = function () {
    return this._booleanArrayClass;
  };
  PrimitiveClasses_0.prototype._get_charArrayClass_ = function () {
    return this._charArrayClass;
  };
  PrimitiveClasses_0.prototype._get_byteArrayClass_ = function () {
    return this._byteArrayClass;
  };
  PrimitiveClasses_0.prototype._get_shortArrayClass_ = function () {
    return this._shortArrayClass;
  };
  PrimitiveClasses_0.prototype._get_intArrayClass_ = function () {
    return this._intArrayClass;
  };
  PrimitiveClasses_0.prototype._get_longArrayClass_ = function () {
    return this._longArrayClass;
  };
  PrimitiveClasses_0.prototype._get_floatArrayClass_ = function () {
    return this._floatArrayClass;
  };
  PrimitiveClasses_0.prototype._get_doubleArrayClass_ = function () {
    return this._doubleArrayClass;
  };
  PrimitiveClasses_0.prototype.functionClass = function (arity) {
    var tmp0_elvis_lhs = functionClasses[arity];
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp0_unsafeCast_0_3 = Function;
      var tmp_0 = tmp0_unsafeCast_0_3;
      var tmp_1 = '' + 'Function' + arity;
      var result_2 = new PrimitiveKClassImpl(tmp_0, tmp_1, _no_name_provided_$factory_22(arity));
      var tmp1_asDynamic_0_5 = functionClasses;
      tmp1_asDynamic_0_5[arity] = result_2;
      tmp = result_2;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  PrimitiveClasses_0.$metadata$ = {
    simpleName: 'PrimitiveClasses',
    kind: 'object',
    interfaces: []
  };
  Object.defineProperty(PrimitiveClasses_0.prototype, 'anyClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_anyClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'numberClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_numberClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'nothingClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_nothingClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'booleanClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_booleanClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'byteClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_byteClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'shortClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_shortClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'intClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_intClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'floatClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_floatClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'doubleClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_doubleClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'arrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_arrayClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'stringClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_stringClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'throwableClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_throwableClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'booleanArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_booleanArrayClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'charArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_charArrayClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'byteArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_byteArrayClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'shortArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_shortArrayClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'intArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_intArrayClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'longArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_longArrayClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'floatArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_floatArrayClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'doubleArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_doubleArrayClass_
  });
  var PrimitiveClasses_instance;
  function PrimitiveClasses_getInstance() {
    if (PrimitiveClasses_instance == null)
      new PrimitiveClasses_0();
    return PrimitiveClasses_instance;
  }
  function _no_name_provided_$factory_3() {
    var i = new _no_name_provided__8();
    return function (p1) {
      return i.invoke_47(p1);
    };
  }
  function _no_name_provided_$factory_4() {
    var i = new _no_name_provided__9();
    return function (p1) {
      return i.invoke_47(p1);
    };
  }
  function _no_name_provided_$factory_5() {
    var i = new _no_name_provided__10();
    return function (p1) {
      return i.invoke_47(p1);
    };
  }
  function _no_name_provided_$factory_6() {
    var i = new _no_name_provided__11();
    return function (p1) {
      return i.invoke_47(p1);
    };
  }
  function _no_name_provided_$factory_7() {
    var i = new _no_name_provided__12();
    return function (p1) {
      return i.invoke_47(p1);
    };
  }
  function _no_name_provided_$factory_8() {
    var i = new _no_name_provided__13();
    return function (p1) {
      return i.invoke_47(p1);
    };
  }
  function _no_name_provided_$factory_9() {
    var i = new _no_name_provided__14();
    return function (p1) {
      return i.invoke_47(p1);
    };
  }
  function _no_name_provided_$factory_10() {
    var i = new _no_name_provided__15();
    return function (p1) {
      return i.invoke_47(p1);
    };
  }
  function _no_name_provided_$factory_11() {
    var i = new _no_name_provided__16();
    return function (p1) {
      return i.invoke_47(p1);
    };
  }
  function _no_name_provided_$factory_12() {
    var i = new _no_name_provided__17();
    return function (p1) {
      return i.invoke_47(p1);
    };
  }
  function _no_name_provided_$factory_13() {
    var i = new _no_name_provided__18();
    return function (p1) {
      return i.invoke_47(p1);
    };
  }
  function _no_name_provided_$factory_14() {
    var i = new _no_name_provided__19();
    return function (p1) {
      return i.invoke_47(p1);
    };
  }
  function _no_name_provided_$factory_15() {
    var i = new _no_name_provided__20();
    return function (p1) {
      return i.invoke_47(p1);
    };
  }
  function _no_name_provided_$factory_16() {
    var i = new _no_name_provided__21();
    return function (p1) {
      return i.invoke_47(p1);
    };
  }
  function _no_name_provided_$factory_17() {
    var i = new _no_name_provided__22();
    return function (p1) {
      return i.invoke_47(p1);
    };
  }
  function _no_name_provided_$factory_18() {
    var i = new _no_name_provided__23();
    return function (p1) {
      return i.invoke_47(p1);
    };
  }
  function _no_name_provided_$factory_19() {
    var i = new _no_name_provided__24();
    return function (p1) {
      return i.invoke_47(p1);
    };
  }
  function _no_name_provided_$factory_20() {
    var i = new _no_name_provided__25();
    return function (p1) {
      return i.invoke_47(p1);
    };
  }
  function _no_name_provided_$factory_21() {
    var i = new _no_name_provided__26();
    return function (p1) {
      return i.invoke_47(p1);
    };
  }
  function _no_name_provided_$factory_22($arity) {
    var i = new _no_name_provided__27($arity);
    return function (p1) {
      return i.invoke_47(p1);
    };
  }
  function functionClasses$init$() {
    var tmp0_arrayOfNulls_0 = 0;
    return fillArrayVal(Array(tmp0_arrayOfNulls_0), null);
  }
  function getKClass_0(jClass) {
    var tmp;
    if (Array.isArray(jClass)) {
      tmp = getKClassM_0(jClass);
    } else {
      tmp = getKClass1_0(jClass);
    }
    return tmp;
  }
  function getKClassM_0(jClasses) {
    var tmp0_subject = jClasses.length;
    var tmp;
    switch (tmp0_subject) {
      case 1:
        tmp = getKClass1_0(jClasses[0]);
        break;
      case 0:
        var tmp0_unsafeCast_0 = NothingKClassImpl_getInstance();
        tmp = tmp0_unsafeCast_0;
        break;
      default:var tmp1_unsafeCast_0 = new ErrorKClass();
        tmp = tmp1_unsafeCast_0;
        break;
    }
    return tmp;
  }
  function getKClass1_0(jClass) {
    if (jClass === String) {
      var tmp0_unsafeCast_0 = PrimitiveClasses_getInstance()._stringClass;
      return tmp0_unsafeCast_0;
    }var metadata = jClass.$metadata$;
    var tmp;
    if (metadata != null) {
      var tmp_0;
      if (metadata.$kClass$ == null) {
        var kClass = new SimpleKClassImpl(jClass);
        metadata.$kClass$ = kClass;
        tmp_0 = kClass;
      } else {
        tmp_0 = metadata.$kClass$;
      }
      tmp = tmp_0;
    } else {
      tmp = new SimpleKClassImpl(jClass);
    }
    return tmp;
  }
  function Appendable() {
  }
  Appendable.$metadata$ = {
    simpleName: 'Appendable',
    kind: 'interface',
    interfaces: []
  };
  function StringBuilder_init_$Init$($this) {
    StringBuilder.call($this, '');
    return $this;
  }
  function StringBuilder_init_$Create$() {
    return StringBuilder_init_$Init$(Object.create(StringBuilder.prototype));
  }
  function StringBuilder(content) {
    this._string = !(content === undefined) ? content : '';
  }
  StringBuilder.prototype._get_length__32 = function () {
    var tmp0_asDynamic_0 = this._string;
    return tmp0_asDynamic_0.length;
  };
  StringBuilder.prototype.get_24 = function (index) {
    var tmp0_getOrElse_0 = this._string;
    var tmp;
    if (index >= 0 ? index <= _get_lastIndex__0(tmp0_getOrElse_0) : false) {
      tmp = charSequenceGet(tmp0_getOrElse_0, index);
    } else {
      throw IndexOutOfBoundsException_init_$Create$('' + 'index: ' + index + ', length: ' + this._get_length__32() + '}');
    }
    return tmp;
  };
  StringBuilder.prototype.subSequence_1 = function (startIndex, endIndex) {
    var tmp0_substring_0 = this._string;
    return tmp0_substring_0.substring(startIndex, endIndex);
  };
  StringBuilder.prototype.append_2 = function (value) {
    var tmp0_this = this;
    tmp0_this._string = tmp0_this._string + value;
    return this;
  };
  StringBuilder.prototype.append_3 = function (value) {
    var tmp0_this = this;
    tmp0_this._string = tmp0_this._string + toString_0(value);
    return this;
  };
  StringBuilder.prototype.append_4 = function (value) {
    var tmp0_this = this;
    var tmp = tmp0_this;
    var tmp_0 = tmp0_this._string;
    var tmp1_elvis_lhs = value;
    tmp._string = tmp_0 + (tmp1_elvis_lhs == null ? 'null' : tmp1_elvis_lhs);
    return this;
  };
  StringBuilder.prototype.toString = function () {
    return this._string;
  };
  StringBuilder.$metadata$ = {
    simpleName: 'StringBuilder',
    kind: 'class',
    interfaces: [Appendable, CharSequence]
  };
  function uppercaseChar(_this_) {
    var tmp0_asDynamic_0 = _this_.toString();
    var tmp1_unsafeCast_0 = tmp0_asDynamic_0.toUpperCase();
    var uppercase = tmp1_unsafeCast_0;
    return uppercase.length > 1 ? _this_ : charSequenceGet(uppercase, 0);
  }
  function checkRadix(radix) {
    if (!(2 <= radix ? radix <= 36 : false)) {
      throw IllegalArgumentException_init_$Create$('' + 'radix ' + radix + ' was not in valid range 2..36');
    }return radix;
  }
  function toInt(_this_) {
    var tmp0_elvis_lhs = toIntOrNull(_this_);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      numberFormatError(_this_);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function toLong(_this_) {
    var tmp0_elvis_lhs = toLongOrNull(_this_);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      numberFormatError(_this_);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function toLong_0(_this_, radix) {
    var tmp0_elvis_lhs = toLongOrNull_0(_this_, radix);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      numberFormatError(_this_);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function digitOf(char, radix) {
    var tmp0_let_0 = (char.compareTo_0(new Char(48)) >= 0 ? char.compareTo_0(new Char(57)) <= 0 : false) ? char.minus(new Char(48)) : (char.compareTo_0(new Char(65)) >= 0 ? char.compareTo_0(new Char(90)) <= 0 : false) ? char.minus(new Char(65)) + 10 | 0 : (char.compareTo_0(new Char(97)) >= 0 ? char.compareTo_0(new Char(122)) <= 0 : false) ? char.minus(new Char(97)) + 10 | 0 : -1;
    return tmp0_let_0 >= radix ? -1 : tmp0_let_0;
  }
  function startsWith_0(_this_, prefix, ignoreCase) {
    if (!ignoreCase) {
      var tmp0_nativeStartsWith_0 = 0;
      return _this_.startsWith(prefix, tmp0_nativeStartsWith_0);
    } else
      return regionMatches(_this_, 0, prefix, 0, prefix.length, ignoreCase);
  }
  function startsWith$default_0(_this_, prefix, ignoreCase, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      ignoreCase = false;
    return startsWith_0(_this_, prefix, ignoreCase);
  }
  function endsWith(_this_, suffix, ignoreCase) {
    if (!ignoreCase) {
      return _this_.endsWith(suffix);
    } else
      return regionMatches(_this_, _this_.length - suffix.length | 0, suffix, 0, suffix.length, ignoreCase);
  }
  function endsWith$default(_this_, suffix, ignoreCase, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      ignoreCase = false;
    return endsWith(_this_, suffix, ignoreCase);
  }
  function regionMatches(_this_, thisOffset, other, otherOffset, length, ignoreCase) {
    return regionMatchesImpl(_this_, thisOffset, other, otherOffset, length, ignoreCase);
  }
  function Companion_5() {
    Companion_instance_4 = this;
    this._MIN_VALUE_0 = new Char(0);
    this._MAX_VALUE_0 = new Char(65535);
    this._MIN_HIGH_SURROGATE = new Char(55296);
    this._MAX_HIGH_SURROGATE = new Char(56319);
    this._MIN_LOW_SURROGATE = new Char(56320);
    this._MAX_LOW_SURROGATE = new Char(57343);
    this._MIN_SURROGATE = new Char(55296);
    this._MAX_SURROGATE = new Char(57343);
    this._SIZE_BYTES_0 = 2;
    this._SIZE_BITS_0 = 16;
  }
  Companion_5.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_4;
  function Companion_getInstance_4() {
    if (Companion_instance_4 == null)
      new Companion_5();
    return Companion_instance_4;
  }
  function Char(code) {
    Companion_getInstance_4();
    var tmp = this;
    tmp._value = _UShort___get_data__impl_(code) & 65535;
  }
  Char.prototype.compareTo_0 = function (other) {
    return this._value - other._value | 0;
  };
  Char.prototype.compareTo_5 = function (other) {
    return this.compareTo_0(other instanceof Char ? other : THROW_CCE());
  };
  Char.prototype.minus = function (other) {
    return this._value - other._value | 0;
  };
  Char.prototype.toInt_5 = function () {
    return this._value;
  };
  Char.prototype.equals = function (other) {
    if (other === this)
      return true;
    if (!(other instanceof Char))
      return false;
    else {
    }
    return this._value === other._value;
  };
  Char.prototype.hashCode = function () {
    return this._value;
  };
  Char.prototype.toString = function () {
    var tmp0_unsafeCast_0 = String.fromCharCode(this._value);
    return tmp0_unsafeCast_0;
  };
  Char.$metadata$ = {
    simpleName: 'Char',
    kind: 'class',
    interfaces: [Comparable]
  };
  function Iterable() {
  }
  Iterable.$metadata$ = {
    simpleName: 'Iterable',
    kind: 'interface',
    interfaces: []
  };
  function List() {
  }
  List.$metadata$ = {
    simpleName: 'List',
    kind: 'interface',
    interfaces: [Collection]
  };
  function MutableEntry() {
  }
  MutableEntry.$metadata$ = {
    simpleName: 'MutableEntry',
    kind: 'interface',
    interfaces: [Entry]
  };
  function MutableMap() {
  }
  MutableMap.$metadata$ = {
    simpleName: 'MutableMap',
    kind: 'interface',
    interfaces: [Map_0]
  };
  function Collection() {
  }
  Collection.$metadata$ = {
    simpleName: 'Collection',
    kind: 'interface',
    interfaces: [Iterable]
  };
  function Entry() {
  }
  Entry.$metadata$ = {
    simpleName: 'Entry',
    kind: 'interface',
    interfaces: []
  };
  function Map_0() {
  }
  Map_0.$metadata$ = {
    simpleName: 'Map',
    kind: 'interface',
    interfaces: []
  };
  function MutableSet() {
  }
  MutableSet.$metadata$ = {
    simpleName: 'MutableSet',
    kind: 'interface',
    interfaces: [Set, MutableCollection]
  };
  function MutableCollection() {
  }
  MutableCollection.$metadata$ = {
    simpleName: 'MutableCollection',
    kind: 'interface',
    interfaces: [Collection, MutableIterable]
  };
  function Set() {
  }
  Set.$metadata$ = {
    simpleName: 'Set',
    kind: 'interface',
    interfaces: [Collection]
  };
  function MutableIterable() {
  }
  MutableIterable.$metadata$ = {
    simpleName: 'MutableIterable',
    kind: 'interface',
    interfaces: [Iterable]
  };
  function MutableList() {
  }
  MutableList.$metadata$ = {
    simpleName: 'MutableList',
    kind: 'interface',
    interfaces: [List, MutableCollection]
  };
  function Companion_6() {
    Companion_instance_5 = this;
  }
  Companion_6.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_5;
  function Companion_getInstance_5() {
    if (Companion_instance_5 == null)
      new Companion_6();
    return Companion_instance_5;
  }
  function Enum(name, ordinal) {
    Companion_getInstance_5();
    this._name = name;
    this._ordinal = ordinal;
  }
  Enum.prototype.compareTo_2 = function (other) {
    return compareTo(this._ordinal, other._ordinal);
  };
  Enum.prototype.compareTo_5 = function (other) {
    return this.compareTo_2(other instanceof Enum ? other : THROW_CCE());
  };
  Enum.prototype.equals = function (other) {
    return this === other;
  };
  Enum.prototype.hashCode = function () {
    return identityHashCode(this);
  };
  Enum.prototype.toString = function () {
    return this._name;
  };
  Enum.$metadata$ = {
    simpleName: 'Enum',
    kind: 'class',
    interfaces: [Comparable]
  };
  function toString_0(_this_) {
    var tmp0_safe_receiver = _this_;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : toString_1(tmp0_safe_receiver);
    return tmp1_elvis_lhs == null ? 'null' : tmp1_elvis_lhs;
  }
  function fillArrayVal(array, initValue) {
    var inductionVariable = 0;
    var last_2 = array.length - 1 | 0;
    if (inductionVariable <= last_2)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        array[i] = initValue;
      }
       while (!(i === last_2));
    return array;
  }
  function arrayIterator(array) {
    return new _no_name_provided__28(array);
  }
  function _no_name_provided__28($array) {
    this._$array = $array;
    this._index_0 = 0;
  }
  _no_name_provided__28.prototype.hasNext_10 = function () {
    return !(this._index_0 === this._$array.length);
  };
  _no_name_provided__28.prototype.next_10 = function () {
    var tmp;
    if (!(this._index_0 === this._$array.length)) {
      var tmp0_this = this;
      var tmp1 = tmp0_this._index_0;
      tmp0_this._index_0 = tmp1 + 1 | 0;
      tmp = this._$array[tmp1];
    } else {
      throw NoSuchElementException_init_$Create$_0('' + this._index_0);
    }
    return tmp;
  };
  _no_name_provided__28.$metadata$ = {
    kind: 'class',
    interfaces: [Iterator]
  };
  var buf;
  var bufFloat64;
  var bufInt32;
  var lowIndex;
  var highIndex;
  function getNumberHashCode(obj) {
    var tmp0_unsafeCast_0 = jsBitwiseOr(obj, 0);
    if (tmp0_unsafeCast_0 === obj) {
      return numberToInt(obj);
    } else {
    }
    bufFloat64[0] = obj;
    return imul(bufInt32[highIndex], 31) + bufInt32[lowIndex] | 0;
  }
  function bufFloat64$init$() {
    var tmp0_unsafeCast_0 = new Float64Array(buf);
    return tmp0_unsafeCast_0;
  }
  function bufInt32$init$() {
    var tmp0_unsafeCast_0 = new Int32Array(buf);
    return tmp0_unsafeCast_0;
  }
  function lowIndex$init$() {
    bufFloat64[0] = -1.0;
    return !(bufInt32[0] === 0) ? 1 : 0;
  }
  function charSequenceGet(a, index) {
    var tmp;
    if (isString(a)) {
      var tmp0_unsafeCast_0 = a.charCodeAt(index);
      var tmp1_Char_0 = tmp0_unsafeCast_0;
      var tmp_0;
      Companion_getInstance_4();
      var tmp0__get_code__0_1 = new Char(0);
      if (tmp1_Char_0 < tmp0__get_code__0_1.toInt_5()) {
        tmp_0 = true;
      } else {
        {
          Companion_getInstance_4();
          var tmp1__get_code__0_2 = new Char(65535);
          tmp_0 = tmp1_Char_0 > tmp1__get_code__0_2.toInt_5();
        }
      }
      if (tmp_0) {
        throw IllegalArgumentException_init_$Create$('' + 'Invalid Char code: ' + tmp1_Char_0);
      } else {
      }
      tmp = new Char(_UShort___init__impl_(toShort(tmp1_Char_0)));
    } else {
      tmp = a.get_24(index);
    }
    return tmp;
  }
  function isString(a) {
    return typeof a === 'string';
  }
  function charSequenceLength(a) {
    var tmp;
    if (isString(a)) {
      var tmp0_unsafeCast_0 = a.length;
      tmp = tmp0_unsafeCast_0;
    } else {
      tmp = a._get_length__32();
    }
    return tmp;
  }
  function charSequenceSubSequence(a, startIndex, endIndex) {
    var tmp;
    if (isString(a)) {
      var tmp0_unsafeCast_0 = a.substring(startIndex, endIndex);
      tmp = tmp0_unsafeCast_0;
    } else {
      tmp = a.subSequence_1(startIndex, endIndex);
    }
    return tmp;
  }
  function arrayToString(array) {
    return joinToString$default(array, ', ', '[', ']', 0, null, _no_name_provided_$factory_23(), 24, null);
  }
  function _no_name_provided__29() {
  }
  _no_name_provided__29.prototype.invoke_47 = function (it) {
    return toString_1(it);
  };
  _no_name_provided__29.prototype.invoke_213 = function (p1) {
    return this.invoke_47((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__29.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_23() {
    var i = new _no_name_provided__29();
    return function (p1) {
      return i.invoke_47(p1);
    };
  }
  function compareTo(a, b) {
    var tmp0_subject = typeof a;
    var tmp;
    switch (tmp0_subject) {
      case 'number':
        var tmp_0;
        if (typeof b === 'number') {
          tmp_0 = doubleCompareTo(a, b);
        } else {
          if (b instanceof Long) {
            tmp_0 = doubleCompareTo(a, b.toDouble_4());
          } else {
            {
              tmp_0 = primitiveCompareTo(a, b);
            }
          }
        }

        tmp = tmp_0;
        break;
      case 'string':
      case 'boolean':
        tmp = primitiveCompareTo(a, b);
        break;
      default:tmp = compareToDoNotIntrinsicify(a, b);
        break;
    }
    return tmp;
  }
  function doubleCompareTo(a, b) {
    var tmp;
    if (a < b) {
      tmp = -1;
    } else if (a > b) {
      tmp = 1;
    } else if (a === b) {
      var tmp_0;
      if (a !== 0) {
        tmp_0 = 0;
      } else {
        var tmp0_asDynamic_0 = 1;
        var ia = tmp0_asDynamic_0 / a;
        var tmp_1;
        var tmp1_asDynamic_0 = 1;
        if (ia === tmp1_asDynamic_0 / b) {
          tmp_1 = 0;
        } else {
          if (ia < 0) {
            tmp_1 = -1;
          } else {
            {
              tmp_1 = 1;
            }
          }
        }
        tmp_0 = tmp_1;
      }
      tmp = tmp_0;
    } else if (a !== a) {
      tmp = b !== b ? 0 : 1;
    } else {
      tmp = -1;
    }
    return tmp;
  }
  function primitiveCompareTo(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
  }
  function compareToDoNotIntrinsicify(a, b) {
    return a.compareTo_5(b);
  }
  function identityHashCode(obj) {
    return getObjectHashCode(obj);
  }
  function getObjectHashCode(obj) {
    if (!jsIn('kotlinHashCodeValue$', obj)) {
      var hash = jsBitwiseOr(Math.random() * 4.294967296E9, 0);
      var descriptor = new Object();
      descriptor.value = hash;
      descriptor.enumerable = false;
      Object.defineProperty(obj, 'kotlinHashCodeValue$', descriptor);
    }var tmp0_unsafeCast_0 = obj['kotlinHashCodeValue$'];
    return tmp0_unsafeCast_0;
  }
  function toString_1(o) {
    var tmp;
    if (o == null) {
      tmp = 'null';
    } else if (isArrayish(o)) {
      tmp = '[...]';
    } else {
      var tmp0_unsafeCast_0 = o.toString();
      tmp = tmp0_unsafeCast_0;
    }
    return tmp;
  }
  function hashCode(obj) {
    if (obj == null)
      return 0;
    var tmp0_subject = typeof obj;
    var tmp;
    switch (tmp0_subject) {
      case 'object':
        tmp = 'function' === typeof obj.hashCode ? obj.hashCode() : getObjectHashCode(obj);
        break;
      case 'function':
        tmp = getObjectHashCode(obj);
        break;
      case 'number':
        tmp = getNumberHashCode(obj);
        break;
      case 'boolean':
        var tmp_0;
        if (obj) {
          tmp_0 = 1;
        } else {
          {
            tmp_0 = 0;
          }
        }

        tmp = tmp_0;
        break;
      default:tmp = getStringHashCode(hashCode$outlinedJsCode$(obj));
        break;
    }
    return tmp;
  }
  function getStringHashCode(str) {
    var hash = 0;
    var length = str.length;
    var inductionVariable = 0;
    var last_2 = length - 1 | 0;
    if (inductionVariable <= last_2)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var code = str.charCodeAt(i);
        hash = imul(hash, 31) + code | 0;
      }
       while (!(i === last_2));
    return hash;
  }
  function equals_0(obj1, obj2) {
    if (obj1 == null) {
      return obj2 == null;
    }if (obj2 == null) {
      return false;
    }if (typeof obj1 === 'object' ? typeof obj1.equals === 'function' : false) {
      return obj1.equals(obj2);
    }if (obj1 !== obj1) {
      return obj2 !== obj2;
    }if (typeof obj1 === 'number' ? typeof obj2 === 'number' : false) {
      var tmp;
      if (obj1 === obj2) {
        var tmp_0;
        if (obj1 !== 0) {
          tmp_0 = true;
        } else {
          var tmp0_asDynamic_0 = 1;
          var tmp_1 = tmp0_asDynamic_0 / obj1;
          var tmp1_asDynamic_0 = 1;
          tmp_0 = tmp_1 === tmp1_asDynamic_0 / obj2;
        }
        tmp = tmp_0;
      } else {
        tmp = false;
      }
      return tmp;
    }return obj1 === obj2;
  }
  function captureStack(instance, constructorFunction) {
    if (Error.captureStackTrace != null) {
      Error.captureStackTrace(instance, constructorFunction);
    } else {
      instance.stack = (new Error()).stack;
    }
  }
  function extendThrowable(this_, message, cause) {
    Error.call(this_);
    setPropertiesToThrowableInstance(this_, message, cause);
  }
  function setPropertiesToThrowableInstance(this_, message, cause) {
    if (!hasOwnPrototypeProperty(this_, 'message')) {
      var tmp;
      if (message == null) {
        var tmp_0;
        if (!(message === null)) {
          var tmp0_safe_receiver = cause;
          var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.toString();
          tmp_0 = tmp1_elvis_lhs == null ? undefined : tmp1_elvis_lhs;
        } else {
          tmp_0 = undefined;
        }
        tmp = tmp_0;
      } else {
        tmp = message;
      }
      this_.message = tmp;
    }if (!hasOwnPrototypeProperty(this_, 'cause')) {
      this_.cause = cause;
    }this_.name = Object.getPrototypeOf(this_).constructor.name;
  }
  function hasOwnPrototypeProperty(o, name) {
    var tmp0_unsafeCast_0 = Object.getPrototypeOf(o).hasOwnProperty(name);
    return tmp0_unsafeCast_0;
  }
  function hashCode$outlinedJsCode$(obj) {
    return String(obj);
  }
  function ensureNotNull(v) {
    var tmp;
    if (v == null) {
      THROW_NPE();
    } else {
      tmp = v;
    }
    return tmp;
  }
  function THROW_NPE() {
    throw NullPointerException_init_$Create$();
  }
  function THROW_CCE() {
    throw ClassCastException_init_$Create$();
  }
  function throwUninitializedPropertyAccessException(name) {
    throw UninitializedPropertyAccessException_init_$Create$('' + 'lateinit property ' + name + ' has not been initialized');
  }
  function THROW_ISE() {
    throw IllegalStateException_init_$Create$();
  }
  function Companion_7() {
    Companion_instance_6 = this;
    this._MIN_VALUE_1 = new Long(0, -2147483648);
    this._MAX_VALUE_1 = new Long(-1, 2147483647);
    this._SIZE_BYTES_1 = 8;
    this._SIZE_BITS_1 = 64;
  }
  Companion_7.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_6;
  function Companion_getInstance_6() {
    if (Companion_instance_6 == null)
      new Companion_7();
    return Companion_instance_6;
  }
  function Long(low, high) {
    Companion_getInstance_6();
    Number_0.call(this);
    this._low = low;
    this._high = high;
  }
  Long.prototype.compareTo_36 = function (other) {
    return compare(this, other);
  };
  Long.prototype.compareTo_5 = function (other) {
    return this.compareTo_36(other instanceof Long ? other : THROW_CCE());
  };
  Long.prototype.plus_27 = function (other) {
    return add(this, other);
  };
  Long.prototype.minus_28 = function (other) {
    return subtract(this, other);
  };
  Long.prototype.times_27 = function (other) {
    return multiply(this, other);
  };
  Long.prototype.div_27 = function (other) {
    return divide(this, other);
  };
  Long.prototype.rem_27 = function (other) {
    return modulo(this, other);
  };
  Long.prototype.unaryMinus_4 = function () {
    return this.inv_0().plus_27(new Long(1, 0));
  };
  Long.prototype.shl_0 = function (bitCount) {
    return shiftLeft(this, bitCount);
  };
  Long.prototype.shr_0 = function (bitCount) {
    return shiftRight(this, bitCount);
  };
  Long.prototype.ushr_0 = function (bitCount) {
    return shiftRightUnsigned(this, bitCount);
  };
  Long.prototype.and = function (other) {
    return new Long(this._low & other._low, this._high & other._high);
  };
  Long.prototype.or = function (other) {
    return new Long(this._low | other._low, this._high | other._high);
  };
  Long.prototype.xor = function (other) {
    return new Long(this._low ^ other._low, this._high ^ other._high);
  };
  Long.prototype.inv_0 = function () {
    return new Long(~this._low, ~this._high);
  };
  Long.prototype.toInt_5 = function () {
    return this._low;
  };
  Long.prototype.toDouble_4 = function () {
    return toNumber(this);
  };
  Long.prototype.valueOf = function () {
    return this.toDouble_4();
  };
  Long.prototype.equals = function (other) {
    var tmp;
    if (other instanceof Long) {
      tmp = equalsLong(this, other);
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  Long.prototype.hashCode = function () {
    return hashCode_0(this);
  };
  Long.prototype.toString = function () {
    return toStringImpl(this, 10);
  };
  Long.$metadata$ = {
    simpleName: 'Long',
    kind: 'class',
    interfaces: [Comparable]
  };
  var ZERO;
  var ONE;
  var NEG_ONE;
  var MAX_VALUE;
  var MIN_VALUE;
  var TWO_PWR_24_;
  function compare(_this_, other) {
    if (equalsLong(_this_, other)) {
      return 0;
    }var thisNeg = isNegative(_this_);
    var otherNeg = isNegative(other);
    return (thisNeg ? !otherNeg : false) ? -1 : (!thisNeg ? otherNeg : false) ? 1 : isNegative(subtract(_this_, other)) ? -1 : 1;
  }
  function add(_this_, other) {
    var a48 = _this_._high >>> 16;
    var a32 = _this_._high & 65535;
    var a16 = _this_._low >>> 16;
    var a00 = _this_._low & 65535;
    var b48 = other._high >>> 16;
    var b32 = other._high & 65535;
    var b16 = other._low >>> 16;
    var b00 = other._low & 65535;
    var c48 = 0;
    var c32 = 0;
    var c16 = 0;
    var c00 = 0;
    c00 = c00 + (a00 + b00 | 0) | 0;
    c16 = c16 + (c00 >>> 16) | 0;
    c00 = c00 & 65535;
    c16 = c16 + (a16 + b16 | 0) | 0;
    c32 = c32 + (c16 >>> 16) | 0;
    c16 = c16 & 65535;
    c32 = c32 + (a32 + b32 | 0) | 0;
    c48 = c48 + (c32 >>> 16) | 0;
    c32 = c32 & 65535;
    c48 = c48 + (a48 + b48 | 0) | 0;
    c48 = c48 & 65535;
    return new Long(c16 << 16 | c00, c48 << 16 | c32);
  }
  function subtract(_this_, other) {
    return add(_this_, other.unaryMinus_4());
  }
  function multiply(_this_, other) {
    if (isZero(_this_)) {
      return ZERO;
    } else if (isZero(other)) {
      return ZERO;
    }if (equalsLong(_this_, MIN_VALUE)) {
      return isOdd(other) ? MIN_VALUE : ZERO;
    } else if (equalsLong(other, MIN_VALUE)) {
      return isOdd(_this_) ? MIN_VALUE : ZERO;
    }if (isNegative(_this_)) {
      var tmp;
      if (isNegative(other)) {
        tmp = multiply(negate(_this_), negate(other));
      } else {
        tmp = negate(multiply(negate(_this_), other));
      }
      return tmp;
    } else if (isNegative(other)) {
      return negate(multiply(_this_, negate(other)));
    }if (lessThan(_this_, TWO_PWR_24_) ? lessThan(other, TWO_PWR_24_) : false) {
      return fromNumber(toNumber(_this_) * toNumber(other));
    }var a48 = _this_._high >>> 16;
    var a32 = _this_._high & 65535;
    var a16 = _this_._low >>> 16;
    var a00 = _this_._low & 65535;
    var b48 = other._high >>> 16;
    var b32 = other._high & 65535;
    var b16 = other._low >>> 16;
    var b00 = other._low & 65535;
    var c48 = 0;
    var c32 = 0;
    var c16 = 0;
    var c00 = 0;
    c00 = c00 + imul(a00, b00) | 0;
    c16 = c16 + (c00 >>> 16) | 0;
    c00 = c00 & 65535;
    c16 = c16 + imul(a16, b00) | 0;
    c32 = c32 + (c16 >>> 16) | 0;
    c16 = c16 & 65535;
    c16 = c16 + imul(a00, b16) | 0;
    c32 = c32 + (c16 >>> 16) | 0;
    c16 = c16 & 65535;
    c32 = c32 + imul(a32, b00) | 0;
    c48 = c48 + (c32 >>> 16) | 0;
    c32 = c32 & 65535;
    c32 = c32 + imul(a16, b16) | 0;
    c48 = c48 + (c32 >>> 16) | 0;
    c32 = c32 & 65535;
    c32 = c32 + imul(a00, b32) | 0;
    c48 = c48 + (c32 >>> 16) | 0;
    c32 = c32 & 65535;
    c48 = c48 + (((imul(a48, b00) + imul(a32, b16) | 0) + imul(a16, b32) | 0) + imul(a00, b48) | 0) | 0;
    c48 = c48 & 65535;
    return new Long(c16 << 16 | c00, c48 << 16 | c32);
  }
  function divide(_this_, other) {
    if (isZero(other)) {
      throw Exception_init_$Create$('division by zero');
    } else if (isZero(_this_)) {
      return ZERO;
    }if (equalsLong(_this_, MIN_VALUE)) {
      if (equalsLong(other, ONE) ? true : equalsLong(other, NEG_ONE)) {
        return MIN_VALUE;
      } else if (equalsLong(other, MIN_VALUE)) {
        return ONE;
      } else {
        var halfThis = shiftRight(_this_, 1);
        var approx = shiftLeft(halfThis.div_27(other), 1);
        if (equalsLong(approx, ZERO)) {
          return isNegative(other) ? ONE : NEG_ONE;
        } else {
          var rem_0 = subtract(_this_, multiply(other, approx));
          return add(approx, rem_0.div_27(other));
        }
      }
    } else if (equalsLong(other, MIN_VALUE)) {
      return ZERO;
    }if (isNegative(_this_)) {
      var tmp;
      if (isNegative(other)) {
        tmp = negate(_this_).div_27(negate(other));
      } else {
        tmp = negate(negate(_this_).div_27(other));
      }
      return tmp;
    } else if (isNegative(other)) {
      return negate(_this_.div_27(negate(other)));
    }var res = ZERO;
    var rem_1 = _this_;
    while (greaterThanOrEqual(rem_1, other)) {
      var approxDouble = toNumber(rem_1) / toNumber(other);
      var approx2 = function () {
        var $externalVarargReceiverTmp = Math;
        return $externalVarargReceiverTmp.max.apply($externalVarargReceiverTmp, [].concat([].slice.call(new Float64Array([1.0, Math.floor(approxDouble)]))));
      }.call(this);
      var log2 = Math.ceil(Math.log(approx2) / Math.LN2);
      var delta = log2 <= 48.0 ? 1.0 : Math.pow(2.0, log2 - 48);
      var approxRes = fromNumber(approx2);
      var approxRem = multiply(approxRes, other);
      while (isNegative(approxRem) ? true : greaterThan(approxRem, rem_1)) {
        approx2 = approx2 - delta;
        approxRes = fromNumber(approx2);
        approxRem = multiply(approxRes, other);
      }
      if (isZero(approxRes)) {
        approxRes = ONE;
      }res = add(res, approxRes);
      rem_1 = subtract(rem_1, approxRem);
    }
    return res;
  }
  function modulo(_this_, other) {
    return subtract(_this_, multiply(_this_.div_27(other), other));
  }
  function shiftLeft(_this_, numBits) {
    var numBits_0 = numBits & 63;
    if (numBits_0 === 0) {
      return _this_;
    } else {
      if (numBits_0 < 32) {
        return new Long(_this_._low << numBits_0, _this_._high << numBits_0 | _this_._low >>> (32 - numBits_0 | 0));
      } else {
        return new Long(0, _this_._low << (numBits_0 - 32 | 0));
      }
    }
  }
  function shiftRight(_this_, numBits) {
    var numBits_0 = numBits & 63;
    if (numBits_0 === 0) {
      return _this_;
    } else {
      if (numBits_0 < 32) {
        return new Long(_this_._low >>> numBits_0 | _this_._high << (32 - numBits_0 | 0), _this_._high >> numBits_0);
      } else {
        return new Long(_this_._high >> (numBits_0 - 32 | 0), _this_._high >= 0 ? 0 : -1);
      }
    }
  }
  function shiftRightUnsigned(_this_, numBits) {
    var numBits_0 = numBits & 63;
    if (numBits_0 === 0) {
      return _this_;
    } else {
      if (numBits_0 < 32) {
        return new Long(_this_._low >>> numBits_0 | _this_._high << (32 - numBits_0 | 0), _this_._high >>> numBits_0);
      } else {
        var tmp;
        if (numBits_0 === 32) {
          tmp = new Long(_this_._high, 0);
        } else {
          tmp = new Long(_this_._high >>> (numBits_0 - 32 | 0), 0);
        }
        return tmp;
      }
    }
  }
  function toNumber(_this_) {
    return _this_._high * 4.294967296E9 + getLowBitsUnsigned(_this_);
  }
  function equalsLong(_this_, other) {
    return _this_._high === other._high ? _this_._low === other._low : false;
  }
  function hashCode_0(l) {
    return l._low ^ l._high;
  }
  function toStringImpl(_this_, radix) {
    if (radix < 2 ? true : 36 < radix) {
      throw Exception_init_$Create$('' + 'radix out of range: ' + radix);
    }if (isZero(_this_)) {
      return '0';
    }if (isNegative(_this_)) {
      if (equalsLong(_this_, MIN_VALUE)) {
        var radixLong = fromInt(radix);
        var div_0 = _this_.div_27(radixLong);
        var rem_0 = subtract(multiply(div_0, radixLong), _this_).toInt_5();
        var tmp = toStringImpl(div_0, radix);
        var tmp0_unsafeCast_0 = rem_0.toString(radix);
        return tmp + tmp0_unsafeCast_0;
      } else {
        return '' + '-' + toStringImpl(negate(_this_), radix);
      }
    }var radixToPower = fromNumber(Math.pow(radix, 6.0));
    var rem_1 = _this_;
    var result = '';
    while (true) {
      var remDiv = rem_1.div_27(radixToPower);
      var intval = subtract(rem_1, multiply(remDiv, radixToPower)).toInt_5();
      var tmp1_unsafeCast_0 = intval.toString(radix);
      var digits = tmp1_unsafeCast_0;
      rem_1 = remDiv;
      if (isZero(rem_1)) {
        return digits + result;
      } else {
        while (digits.length < 6) {
          digits = '0' + digits;
        }
        result = digits + result;
      }
    }
  }
  function fromInt(value) {
    return new Long(value, value < 0 ? -1 : 0);
  }
  function isNegative(_this_) {
    return _this_._high < 0;
  }
  function isZero(_this_) {
    return _this_._high === 0 ? _this_._low === 0 : false;
  }
  function isOdd(_this_) {
    return (_this_._low & 1) === 1;
  }
  function negate(_this_) {
    return _this_.unaryMinus_4();
  }
  function lessThan(_this_, other) {
    return compare(_this_, other) < 0;
  }
  function fromNumber(value) {
    if (isNaN_0(value)) {
      return ZERO;
    } else if (value <= -9.223372036854776E18) {
      return MIN_VALUE;
    } else if (value + 1 >= 9.223372036854776E18) {
      return MAX_VALUE;
    } else if (value < 0.0) {
      return negate(fromNumber(-value));
    } else {
      var twoPwr32 = 4.294967296E9;
      return new Long(jsBitwiseOr(value % twoPwr32, 0), jsBitwiseOr(value / twoPwr32, 0));
    }
  }
  function greaterThan(_this_, other) {
    return compare(_this_, other) > 0;
  }
  function greaterThanOrEqual(_this_, other) {
    return compare(_this_, other) >= 0;
  }
  function getLowBitsUnsigned(_this_) {
    return _this_._low >= 0 ? _this_._low : 4.294967296E9 + _this_._low;
  }
  function imul(a_local, b_local) {
    var lhs = jsBitwiseAnd(a_local, 4.29490176E9) * jsBitwiseAnd(b_local, 65535);
    var rhs = jsBitwiseAnd(a_local, 65535) * b_local;
    return jsBitwiseOr(lhs + rhs, 0);
  }
  function toByte(a) {
    var tmp0_unsafeCast_0 = toByte$outlinedJsCode$(a);
    return tmp0_unsafeCast_0;
  }
  function numberToInt(a) {
    var tmp;
    if (a instanceof Long) {
      tmp = a.toInt_5();
    } else {
      {
        tmp = doubleToInt(a);
      }
    }
    return tmp;
  }
  function doubleToInt(a) {
    return a > 2.147483647E9 ? 2147483647 : a < -2.147483648E9 ? -2147483648 : jsBitwiseOr(a, 0);
  }
  function toShort(a) {
    var tmp0_unsafeCast_0 = toShort$outlinedJsCode$_1(a);
    return tmp0_unsafeCast_0;
  }
  function numberToLong(a) {
    var tmp;
    if (a instanceof Long) {
      tmp = a;
    } else {
      {
        tmp = fromNumber(a);
      }
    }
    return tmp;
  }
  function numberToChar(a) {
    var tmp0_Char_0 = numberToInt(a) & 65535;
    var tmp;
    Companion_getInstance_4();
    var tmp0__get_code__0_1 = new Char(0);
    if (tmp0_Char_0 < tmp0__get_code__0_1.toInt_5()) {
      tmp = true;
    } else {
      {
        Companion_getInstance_4();
        var tmp1__get_code__0_2 = new Char(65535);
        tmp = tmp0_Char_0 > tmp1__get_code__0_2.toInt_5();
      }
    }
    if (tmp) {
      throw IllegalArgumentException_init_$Create$('' + 'Invalid Char code: ' + tmp0_Char_0);
    } else {
    }
    return new Char(_UShort___init__impl_(toShort(tmp0_Char_0)));
  }
  function toLong_1(a) {
    return fromInt(a);
  }
  function toByte$outlinedJsCode$(a) {
    return a << 24 >> 24;
  }
  function toShort$outlinedJsCode$_1(a) {
    return a << 16 >> 16;
  }
  function numberRangeToNumber(start, endInclusive) {
    return new IntRange(start, endInclusive);
  }
  function isArrayish(o) {
    var tmp;
    if (isJsArray(o)) {
      tmp = true;
    } else {
      var tmp0_unsafeCast_0 = ArrayBuffer.isView(o);
      tmp = tmp0_unsafeCast_0;
    }
    return tmp;
  }
  function isJsArray(obj) {
    var tmp0_unsafeCast_0 = Array.isArray(obj);
    return tmp0_unsafeCast_0;
  }
  function isInterface(obj, iface) {
    var tmp0_elvis_lhs = obj.constructor;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var ctor = tmp;
    return isInterfaceImpl(ctor, iface);
  }
  function isInterfaceImpl(ctor, iface) {
    if (ctor === iface)
      return true;
    var metadata = ctor.$metadata$;
    if (!(metadata == null)) {
      var interfaces = metadata.interfaces;
      var indexedObject = interfaces;
      var inductionVariable = 0;
      var last_2 = indexedObject.length;
      while (inductionVariable < last_2) {
        var i = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (isInterfaceImpl(i, iface)) {
          return true;
        }}
    }var superPrototype = !(ctor.prototype == null) ? Object.getPrototypeOf(ctor.prototype) : null;
    var superConstructor = superPrototype != null ? superPrototype.constructor : null;
    return !(superConstructor == null) ? isInterfaceImpl(superConstructor, iface) : false;
  }
  function isArray(obj) {
    var tmp;
    if (isJsArray(obj)) {
      tmp = !obj.$type$;
    } else {
      tmp = false;
    }
    return tmp;
  }
  function isObject(obj) {
    var objTypeOf = typeof obj;
    var tmp0_subject = objTypeOf;
    switch (tmp0_subject) {
      case 'string':
        return true;
      case 'number':
        return true;
      case 'boolean':
        return true;
      case 'function':
        return true;
      default:return jsInstanceOf(obj, Object);
    }
  }
  function isNumber(a) {
    var tmp;
    if (typeof a === 'number') {
      tmp = true;
    } else {
      tmp = a instanceof Long;
    }
    return tmp;
  }
  function isCharSequence(value) {
    return typeof value === 'string' ? true : isInterface(value, _get_js_(getKClass_0(CharSequence)));
  }
  function isBooleanArray(a) {
    return isJsArray(a) ? a.$type$ === 'BooleanArray' : false;
  }
  function isByteArray(a) {
    return jsInstanceOf(a, Int8Array);
  }
  function isShortArray(a) {
    return jsInstanceOf(a, Int16Array);
  }
  function isCharArray(a) {
    return isJsArray(a) ? a.$type$ === 'CharArray' : false;
  }
  function isIntArray(a) {
    return jsInstanceOf(a, Int32Array);
  }
  function isFloatArray(a) {
    return jsInstanceOf(a, Float32Array);
  }
  function isLongArray(a) {
    return isJsArray(a) ? a.$type$ === 'LongArray' : false;
  }
  function isDoubleArray(a) {
    return jsInstanceOf(a, Float64Array);
  }
  function asList(_this_) {
    return new ArrayList(_this_);
  }
  function Exception_init_$Init$($this) {
    extendThrowable($this, void 1, void 1);
    Exception.call($this);
    return $this;
  }
  function Exception_init_$Init$_0(message, $this) {
    extendThrowable($this, message, void 1);
    Exception.call($this);
    return $this;
  }
  function Exception_init_$Create$(message) {
    var tmp = Exception_init_$Init$_0(message, Object.create(Exception.prototype));
    captureStack(tmp, Exception_init_$Create$);
    return tmp;
  }
  function Exception() {
    captureStack(this, Exception);
  }
  Exception.$metadata$ = {
    simpleName: 'Exception',
    kind: 'class',
    interfaces: []
  };
  function Error_init_$Init$(message, $this) {
    extendThrowable($this, message, void 1);
    Error_0.call($this);
    return $this;
  }
  function Error_0() {
    captureStack(this, Error_0);
  }
  Error_0.$metadata$ = {
    simpleName: 'Error',
    kind: 'class',
    interfaces: []
  };
  function IllegalArgumentException_init_$Init$(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    IllegalArgumentException.call($this);
    return $this;
  }
  function IllegalArgumentException_init_$Create$(message) {
    var tmp = IllegalArgumentException_init_$Init$(message, Object.create(IllegalArgumentException.prototype));
    captureStack(tmp, IllegalArgumentException_init_$Create$);
    return tmp;
  }
  function IllegalArgumentException() {
    captureStack(this, IllegalArgumentException);
  }
  IllegalArgumentException.$metadata$ = {
    simpleName: 'IllegalArgumentException',
    kind: 'class',
    interfaces: []
  };
  function RuntimeException_init_$Init$($this) {
    Exception_init_$Init$($this);
    RuntimeException.call($this);
    return $this;
  }
  function RuntimeException_init_$Init$_0(message, $this) {
    Exception_init_$Init$_0(message, $this);
    RuntimeException.call($this);
    return $this;
  }
  function RuntimeException() {
    captureStack(this, RuntimeException);
  }
  RuntimeException.$metadata$ = {
    simpleName: 'RuntimeException',
    kind: 'class',
    interfaces: []
  };
  function NoSuchElementException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    NoSuchElementException.call($this);
    return $this;
  }
  function NoSuchElementException_init_$Create$() {
    var tmp = NoSuchElementException_init_$Init$(Object.create(NoSuchElementException.prototype));
    captureStack(tmp, NoSuchElementException_init_$Create$);
    return tmp;
  }
  function NoSuchElementException_init_$Init$_0(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    NoSuchElementException.call($this);
    return $this;
  }
  function NoSuchElementException_init_$Create$_0(message) {
    var tmp = NoSuchElementException_init_$Init$_0(message, Object.create(NoSuchElementException.prototype));
    captureStack(tmp, NoSuchElementException_init_$Create$_0);
    return tmp;
  }
  function NoSuchElementException() {
    captureStack(this, NoSuchElementException);
  }
  NoSuchElementException.$metadata$ = {
    simpleName: 'NoSuchElementException',
    kind: 'class',
    interfaces: []
  };
  function IllegalStateException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    IllegalStateException.call($this);
    return $this;
  }
  function IllegalStateException_init_$Create$() {
    var tmp = IllegalStateException_init_$Init$(Object.create(IllegalStateException.prototype));
    captureStack(tmp, IllegalStateException_init_$Create$);
    return tmp;
  }
  function IllegalStateException() {
    captureStack(this, IllegalStateException);
  }
  IllegalStateException.$metadata$ = {
    simpleName: 'IllegalStateException',
    kind: 'class',
    interfaces: []
  };
  function NumberFormatException_init_$Init$(message, $this) {
    IllegalArgumentException_init_$Init$(message, $this);
    NumberFormatException.call($this);
    return $this;
  }
  function NumberFormatException_init_$Create$(message) {
    var tmp = NumberFormatException_init_$Init$(message, Object.create(NumberFormatException.prototype));
    captureStack(tmp, NumberFormatException_init_$Create$);
    return tmp;
  }
  function NumberFormatException() {
    captureStack(this, NumberFormatException);
  }
  NumberFormatException.$metadata$ = {
    simpleName: 'NumberFormatException',
    kind: 'class',
    interfaces: []
  };
  function IndexOutOfBoundsException_init_$Init$(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    IndexOutOfBoundsException.call($this);
    return $this;
  }
  function IndexOutOfBoundsException_init_$Create$(message) {
    var tmp = IndexOutOfBoundsException_init_$Init$(message, Object.create(IndexOutOfBoundsException.prototype));
    captureStack(tmp, IndexOutOfBoundsException_init_$Create$);
    return tmp;
  }
  function IndexOutOfBoundsException() {
    captureStack(this, IndexOutOfBoundsException);
  }
  IndexOutOfBoundsException.$metadata$ = {
    simpleName: 'IndexOutOfBoundsException',
    kind: 'class',
    interfaces: []
  };
  function UnsupportedOperationException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    UnsupportedOperationException.call($this);
    return $this;
  }
  function UnsupportedOperationException_init_$Create$() {
    var tmp = UnsupportedOperationException_init_$Init$(Object.create(UnsupportedOperationException.prototype));
    captureStack(tmp, UnsupportedOperationException_init_$Create$);
    return tmp;
  }
  function UnsupportedOperationException_init_$Init$_0(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    UnsupportedOperationException.call($this);
    return $this;
  }
  function UnsupportedOperationException_init_$Create$_0(message) {
    var tmp = UnsupportedOperationException_init_$Init$_0(message, Object.create(UnsupportedOperationException.prototype));
    captureStack(tmp, UnsupportedOperationException_init_$Create$_0);
    return tmp;
  }
  function UnsupportedOperationException() {
    captureStack(this, UnsupportedOperationException);
  }
  UnsupportedOperationException.$metadata$ = {
    simpleName: 'UnsupportedOperationException',
    kind: 'class',
    interfaces: []
  };
  function NullPointerException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    NullPointerException.call($this);
    return $this;
  }
  function NullPointerException_init_$Create$() {
    var tmp = NullPointerException_init_$Init$(Object.create(NullPointerException.prototype));
    captureStack(tmp, NullPointerException_init_$Create$);
    return tmp;
  }
  function NullPointerException() {
    captureStack(this, NullPointerException);
  }
  NullPointerException.$metadata$ = {
    simpleName: 'NullPointerException',
    kind: 'class',
    interfaces: []
  };
  function ClassCastException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    ClassCastException.call($this);
    return $this;
  }
  function ClassCastException_init_$Create$() {
    var tmp = ClassCastException_init_$Init$(Object.create(ClassCastException.prototype));
    captureStack(tmp, ClassCastException_init_$Create$);
    return tmp;
  }
  function ClassCastException() {
    captureStack(this, ClassCastException);
  }
  ClassCastException.$metadata$ = {
    simpleName: 'ClassCastException',
    kind: 'class',
    interfaces: []
  };
  function UninitializedPropertyAccessException_init_$Init$(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    UninitializedPropertyAccessException.call($this);
    return $this;
  }
  function UninitializedPropertyAccessException_init_$Create$(message) {
    var tmp = UninitializedPropertyAccessException_init_$Init$(message, Object.create(UninitializedPropertyAccessException.prototype));
    captureStack(tmp, UninitializedPropertyAccessException_init_$Create$);
    return tmp;
  }
  function UninitializedPropertyAccessException() {
    captureStack(this, UninitializedPropertyAccessException);
  }
  UninitializedPropertyAccessException.$metadata$ = {
    simpleName: 'UninitializedPropertyAccessException',
    kind: 'class',
    interfaces: []
  };
  function jsIn(lhs_hack, rhs_hack) {
    var tmp0_unsafeCast_0 = jsIn$outlinedJsCode$(lhs_hack, rhs_hack);
    return tmp0_unsafeCast_0;
  }
  function jsBitwiseOr(lhs_hack, rhs_hack) {
    var tmp0_unsafeCast_0 = jsBitwiseOr$outlinedJsCode$_0(lhs_hack, rhs_hack);
    return tmp0_unsafeCast_0;
  }
  function jsDeleteProperty(obj_hack, property_hack) {
    jsDeleteProperty$outlinedJsCode$_1(obj_hack, property_hack);
  }
  function jsTypeOf(value_hack) {
    var tmp0_unsafeCast_0 = jsTypeOf$outlinedJsCode$_2(value_hack);
    return tmp0_unsafeCast_0;
  }
  function jsInstanceOf(obj_hack, jsClass_hack) {
    var tmp0_unsafeCast_0 = jsInstanceOf$outlinedJsCode$_3(obj_hack, jsClass_hack);
    return tmp0_unsafeCast_0;
  }
  function jsBitwiseAnd(lhs_hack, rhs_hack) {
    var tmp0_unsafeCast_0 = jsBitwiseAnd$outlinedJsCode$_4(lhs_hack, rhs_hack);
    return tmp0_unsafeCast_0;
  }
  function jsIn$outlinedJsCode$(lhs_hack, rhs_hack) {
    return lhs_hack in rhs_hack;
  }
  function jsBitwiseOr$outlinedJsCode$_0(lhs_hack, rhs_hack) {
    return lhs_hack | rhs_hack;
  }
  function jsDeleteProperty$outlinedJsCode$_1(obj_hack, property_hack) {
    return delete obj_hack[property_hack];
  }
  function jsTypeOf$outlinedJsCode$_2(value_hack) {
    return typeof value_hack;
  }
  function jsInstanceOf$outlinedJsCode$_3(obj_hack, jsClass_hack) {
    return obj_hack instanceof jsClass_hack;
  }
  function jsBitwiseAnd$outlinedJsCode$_4(lhs_hack, rhs_hack) {
    return lhs_hack & rhs_hack;
  }
  function Assembler() {
    Assembler_instance = this;
  }
  Assembler.prototype.assemble_0 = function (text) {
    var tmp0_container = (new AssemblerPassOne(text)).run_1();
    var passOneProg = tmp0_container.component1_5();
    var talInstructions = tmp0_container.component2_6();
    var passOneErrors = tmp0_container.component3_0();
    if (!passOneErrors.isEmpty_16()) {
      return new AssemblerOutput(passOneProg, passOneErrors);
    } else {
    }
    var passTwoOutput = (new AssemblerPassTwo(passOneProg, talInstructions)).run_1();
    return passTwoOutput;
  };
  Assembler.$metadata$ = {
    simpleName: 'Assembler',
    kind: 'object',
    interfaces: []
  };
  var Assembler_instance;
  function Assembler_getInstance() {
    if (Assembler_instance == null)
      new Assembler();
    return Assembler_instance;
  }
  function DebugInfo(lineNo, line) {
    this._lineNo = lineNo;
    this._line = line;
  }
  DebugInfo.prototype.component1_5 = function () {
    return this._lineNo;
  };
  DebugInfo.prototype.component2_6 = function () {
    return this._line;
  };
  DebugInfo.prototype.toString = function () {
    return '' + 'DebugInfo(lineNo=' + this._lineNo + ', line=' + this._line + ')';
  };
  DebugInfo.prototype.hashCode = function () {
    var result = this._lineNo;
    result = imul(result, 31) + getStringHashCode(this._line) | 0;
    return result;
  };
  DebugInfo.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DebugInfo))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof DebugInfo ? other : THROW_CCE();
    if (!(this._lineNo === tmp0_other_with_cast._lineNo))
      return false;
    if (!(this._line === tmp0_other_with_cast._line))
      return false;
    return true;
  };
  DebugInfo.$metadata$ = {
    simpleName: 'DebugInfo',
    kind: 'class',
    interfaces: []
  };
  function DebugInstruction(debug, LineTokens) {
    this._debug = debug;
    this._LineTokens = LineTokens;
  }
  DebugInstruction.prototype.component1_5 = function () {
    return this._debug;
  };
  DebugInstruction.prototype.component2_6 = function () {
    return this._LineTokens;
  };
  DebugInstruction.prototype.toString = function () {
    return '' + 'DebugInstruction(debug=' + this._debug + ', LineTokens=' + this._LineTokens + ')';
  };
  DebugInstruction.prototype.hashCode = function () {
    var result = this._debug.hashCode();
    result = imul(result, 31) + hashCode(this._LineTokens) | 0;
    return result;
  };
  DebugInstruction.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DebugInstruction))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof DebugInstruction ? other : THROW_CCE();
    if (!this._debug.equals(tmp0_other_with_cast._debug))
      return false;
    if (!equals_0(this._LineTokens, tmp0_other_with_cast._LineTokens))
      return false;
    return true;
  };
  DebugInstruction.$metadata$ = {
    simpleName: 'DebugInstruction',
    kind: 'class',
    interfaces: []
  };
  function PassOneOutput(prog, talInstructions, errors) {
    this._prog = prog;
    this._talInstructions = talInstructions;
    this._errors = errors;
  }
  PassOneOutput.prototype.component1_5 = function () {
    return this._prog;
  };
  PassOneOutput.prototype.component2_6 = function () {
    return this._talInstructions;
  };
  PassOneOutput.prototype.component3_0 = function () {
    return this._errors;
  };
  PassOneOutput.prototype.toString = function () {
    return '' + 'PassOneOutput(prog=' + this._prog + ', talInstructions=' + this._talInstructions + ', errors=' + this._errors + ')';
  };
  PassOneOutput.prototype.hashCode = function () {
    var result = hashCode(this._prog);
    result = imul(result, 31) + hashCode(this._talInstructions) | 0;
    result = imul(result, 31) + hashCode(this._errors) | 0;
    return result;
  };
  PassOneOutput.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PassOneOutput))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof PassOneOutput ? other : THROW_CCE();
    if (!equals_0(this._prog, tmp0_other_with_cast._prog))
      return false;
    if (!equals_0(this._talInstructions, tmp0_other_with_cast._talInstructions))
      return false;
    if (!equals_0(this._errors, tmp0_other_with_cast._errors))
      return false;
    return true;
  };
  PassOneOutput.$metadata$ = {
    simpleName: 'PassOneOutput',
    kind: 'class',
    interfaces: []
  };
  function AssemblerOutput(prog, errors) {
    this._prog_0 = prog;
    this._errors_0 = errors;
  }
  AssemblerOutput.prototype.component1_5 = function () {
    return this._prog_0;
  };
  AssemblerOutput.prototype.component2_6 = function () {
    return this._errors_0;
  };
  AssemblerOutput.prototype.toString = function () {
    return '' + 'AssemblerOutput(prog=' + this._prog_0 + ', errors=' + this._errors_0 + ')';
  };
  AssemblerOutput.prototype.hashCode = function () {
    var result = hashCode(this._prog_0);
    result = imul(result, 31) + hashCode(this._errors_0) | 0;
    return result;
  };
  AssemblerOutput.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AssemblerOutput))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof AssemblerOutput ? other : THROW_CCE();
    if (!equals_0(this._prog_0, tmp0_other_with_cast._prog_0))
      return false;
    if (!equals_0(this._errors_0, tmp0_other_with_cast._errors_0))
      return false;
    return true;
  };
  AssemblerOutput.$metadata$ = {
    simpleName: 'AssemblerOutput',
    kind: 'class',
    interfaces: []
  };
  function doPassOne($this) {
    var tmp0_iterator = lines($this._text).iterator_29();
    while (tmp0_iterator.hasNext_10()) {
      var line = tmp0_iterator.next_10();
      try {
        var tmp1_this = $this;
        var tmp2 = tmp1_this._currentLineNumber;
        tmp1_this._currentLineNumber = tmp2 + 1 | 0;
        Unit_getInstance();
        var offset = $this.getOffset();
        var tmp3_container = Lexer_getInstance().lexLine(line);
        var labels = tmp3_container.component1_5();
        var args = tmp3_container.component2_6();
        var tmp4_iterator = labels.iterator_29();
        while (tmp4_iterator.hasNext_10()) {
          var label = tmp4_iterator.next_10();
          var oldOffset = $this._prog_1.addLabel(label, offset);
          if (!(oldOffset == null)) {
            throw AssemblerError_init_$Create$('' + 'label ' + label + ' defined twice');
          }}
        var tmp;
        if (args.isEmpty_16()) {
          tmp = true;
        } else {
          var tmp0_isEmpty_0 = args.get_24(0);
          tmp = charSequenceLength(tmp0_isEmpty_0) === 0;
        }
        if (tmp)
          continue;
        else {
        }
        if (isAssemblerDirective($this, args.get_24(0))) {
          parseAssemblerDirective($this, args.get_24(0), drop(args, 1), line);
        } else {
          var expandedInsts = replacePseudoInstructions($this, args);
          var tmp5_iterator = expandedInsts.iterator_29();
          while (tmp5_iterator.hasNext_10()) {
            var inst = tmp5_iterator.next_10();
            var dbg = new DebugInfo($this._currentLineNumber, line);
            $this._talInstructions_0.add_12(new DebugInstruction(dbg, inst));
            Unit_getInstance();
            var tmp6_this = $this;
            tmp6_this._currentTextOffset = tmp6_this._currentTextOffset + 4 | 0;
          }
        }
      } catch ($p) {
        if ($p instanceof AssemblerError) {
          $this._errors_1.add_12(AssemblerError_init_$Create$_0($this._currentLineNumber, $p));
          Unit_getInstance();
        } else {
          {
            throw $p;
          }
        }
      }
    }
  }
  function isAssemblerDirective($this, cmd) {
    return startsWith$default_0(cmd, '.', false, 2, null);
  }
  function replacePseudoInstructions($this, tokens) {
    try {
      var cmd = getInstruction(tokens);
      var pw = valueOf(cmd)._pw;
      return pw.invoke_83(tokens, $this);
    } catch ($p) {
      if ($p instanceof Error) {
        return listOf_0(tokens);
      } else {
        {
          throw $p;
        }
      }
    }
  }
  function parseAssemblerDirective($this, directive, args, line) {
    var tmp0_subject = directive;
    switch (tmp0_subject) {
      case '.data':
        $this._inTextSegment = false;
        break;
      case '.text':
        $this._inTextSegment = true;
        break;
      case '.byte':
        var tmp1_iterator = args.iterator_29();
        while (tmp1_iterator.hasNext_10()) {
          var arg = tmp1_iterator.next_10();
          var byte = userStringToInt(arg);
          if (!(-127 <= byte ? byte <= 255 : false)) {
            throw AssemblerError_init_$Create$('' + 'invalid byte ' + byte + ' too big');
          }$this._prog_1.addToData(toByte(byte));
          var tmp2_this = $this;
          var tmp3 = tmp2_this._currentDataOffset;
          tmp2_this._currentDataOffset = tmp3 + 1 | 0;
          Unit_getInstance();
        }

        break;
      case '.asciiz':
        checkArgsLength(args, 1);
        var tmp;
        try {
          tmp = JSON.parse(args.get_24(0));
        } catch ($p) {
          var tmp_0;
          if ($p instanceof Error) {
            throw AssemblerError_init_$Create$('' + "couldn't parse " + args.get_24(0) + ' as a string');
          } else {
            {
              throw $p;
            }
          }
          tmp = tmp_0;
        }

        var ascii = tmp;
        var indexedObject = ascii;
        var inductionVariable = 0;
        var last_2 = indexedObject.length;
        while (inductionVariable < last_2) {
          var c = charSequenceGet(indexedObject, inductionVariable);
          inductionVariable = inductionVariable + 1 | 0;
          var containsArg = c.toInt_5();
          if (!(0 <= containsArg ? containsArg <= 127 : false)) {
            throw AssemblerError_init_$Create$('' + 'unexpected non-ascii character: ' + c);
          } else {
          }
          $this._prog_1.addToData(toByte(c.toInt_5()));
          var tmp5_this = $this;
          var tmp6 = tmp5_this._currentDataOffset;
          tmp5_this._currentDataOffset = tmp6 + 1 | 0;
          Unit_getInstance();
        }

        $this._prog_1.addToData(0);
        var tmp7_this = $this;
        var tmp8 = tmp7_this._currentDataOffset;
        tmp7_this._currentDataOffset = tmp8 + 1 | 0;
        Unit_getInstance();
        break;
      case '.word':
        var tmp9_iterator = args.iterator_29();
        while (tmp9_iterator.hasNext_10()) {
          var arg_0 = tmp9_iterator.next_10();
          var word = userStringToInt(arg_0);
          $this._prog_1.addToData(toByte(word));
          $this._prog_1.addToData(toByte(word >> 8));
          $this._prog_1.addToData(toByte(word >> 16));
          $this._prog_1.addToData(toByte(word >> 24));
          var tmp10_this = $this;
          tmp10_this._currentDataOffset = tmp10_this._currentDataOffset + 4 | 0;
        }

        break;
      case '.globl':
        var tmp0_forEach = $this._prog_1;
        var tmp0_iterator_1 = args.iterator_29();
        while (tmp0_iterator_1.hasNext_10()) {
          var element_2 = tmp0_iterator_1.next_10();
          tmp0_forEach.makeLabelGlobal(element_2);
        }

        break;
      case '.float':
      case '.double':
      case '.align':
        println('' + 'Warning: ' + directive + ' not currently supported!');
        break;
      default:throw AssemblerError_init_$Create$('' + 'unknown assembler directive ' + directive);
    }
  }
  function AssemblerPassOne(text) {
    this._text = text;
    var tmp = this;
    tmp._prog_1 = Program_init_$Create$(null, 1, null);
    var tmp_0 = this;
    MemorySegments_getInstance();
    tmp_0._currentTextOffset = 0;
    var tmp_1 = this;
    MemorySegments_getInstance();
    tmp_1._currentDataOffset = 268435456;
    this._inTextSegment = true;
    this._talInstructions_0 = ArrayList_init_$Create$();
    this._currentLineNumber = 0;
    this._errors_1 = ArrayList_init_$Create$();
  }
  AssemblerPassOne.prototype.run_1 = function () {
    doPassOne(this);
    return new PassOneOutput(this._prog_1, this._talInstructions_0, this._errors_1);
  };
  AssemblerPassOne.prototype.getOffset = function () {
    return this._inTextSegment ? this._currentTextOffset : this._currentDataOffset;
  };
  AssemblerPassOne.prototype.addRelocation = function (relocator, offset, label) {
    return this._prog_1.addRelocation_0(relocator, label, offset);
  };
  AssemblerPassOne.$metadata$ = {
    simpleName: 'AssemblerPassOne',
    kind: 'class',
    interfaces: []
  };
  function addInstruction($this, tokens) {
    var tmp;
    if (tokens.isEmpty_16()) {
      tmp = true;
    } else {
      var tmp0_isEmpty_0 = tokens.get_24(0);
      tmp = charSequenceLength(tmp0_isEmpty_0) === 0;
    }
    if (tmp)
      return Unit_getInstance();
    else {
    }
    var cmd = getInstruction(tokens);
    var inst = Companion_getInstance_7().get_14(cmd);
    var mcode = inst._format.fill_7();
    inst._parser.invoke_198($this._prog_2, mcode, drop(tokens, 1));
    $this._prog_2.add_13(mcode);
  }
  function AssemblerPassTwo(prog, talInstructions) {
    this._prog_2 = prog;
    this._talInstructions_1 = talInstructions;
    this._errors_2 = ArrayList_init_$Create$();
  }
  AssemblerPassTwo.prototype.run_1 = function () {
    var tmp0_iterator = this._talInstructions_1.iterator_29();
    while (tmp0_iterator.hasNext_10()) {
      var tmp1_loop_parameter = tmp0_iterator.next_10();
      var dbg = tmp1_loop_parameter.component1_5();
      var inst = tmp1_loop_parameter.component2_6();
      try {
        addInstruction(this, inst);
        this._prog_2.addDebugInfo(dbg);
      } catch ($p) {
        if ($p instanceof AssemblerError) {
          var tmp2_container = dbg;
          var lineNumber = tmp2_container.component1_5();
          this._errors_2.add_12(AssemblerError_init_$Create$_0(lineNumber, $p));
          Unit_getInstance();
        } else {
          {
            throw $p;
          }
        }
      }
    }
    return new AssemblerOutput(this._prog_2, this._errors_2);
  };
  AssemblerPassTwo.$metadata$ = {
    simpleName: 'AssemblerPassTwo',
    kind: 'class',
    interfaces: []
  };
  function getInstruction(tokens) {
    var tmp0_lowercase_0 = tokens.get_24(0);
    return tmp0_lowercase_0.toLowerCase();
  }
  function AssemblerError_init_$Init$(msg, $this) {
    extendThrowable($this, msg, void 1);
    AssemblerError.call($this);
    return $this;
  }
  function AssemblerError_init_$Create$(msg) {
    var tmp = AssemblerError_init_$Init$(msg, Object.create(AssemblerError.prototype));
    captureStack(tmp, AssemblerError_init_$Create$);
    return tmp;
  }
  function AssemblerError_init_$Init$_0(errorLine, e, $this) {
    AssemblerError_init_$Init$(e.message, $this);
    $this._line_0 = errorLine;
    return $this;
  }
  function AssemblerError_init_$Create$_0(errorLine, e) {
    var tmp = AssemblerError_init_$Init$_0(errorLine, e, Object.create(AssemblerError.prototype));
    captureStack(tmp, AssemblerError_init_$Create$_0);
    return tmp;
  }
  AssemblerError.prototype.toString = function () {
    return this._line_0 == null ? Error.prototype.toString.call(this) : '' + Error.prototype.toString.call(this) + ' on line ' + this._line_0;
  };
  function AssemblerError() {
    this._line_0 = null;
    captureStack(this, AssemblerError);
  }
  AssemblerError.$metadata$ = {
    simpleName: 'AssemblerError',
    kind: 'class',
    interfaces: []
  };
  function addNonemptyWord($this, previous, next) {
    var word = next.toString();
    if (charSequenceLength(word) > 0) {
      previous.add_12(word);
      Unit_getInstance();
    } else {
    }
  }
  function Lexer() {
    Lexer_instance = this;
  }
  Lexer.prototype.lexLine = function (line) {
    var currentWord = new StringBuilder('');
    var previousWords = ArrayList_init_$Create$();
    var labels = ArrayList_init_$Create$();
    var escaped = false;
    var inCharacter = false;
    var inString = false;
    var foundComment = false;
    var indexedObject = line;
    var inductionVariable = 0;
    var last_2 = indexedObject.length;
    $l$break: while (inductionVariable < last_2) {
      var ch = charSequenceGet(indexedObject, inductionVariable);
      inductionVariable = inductionVariable + 1 | 0;
      var wasDelimiter = false;
      var wasLabel = false;
      var tmp1_subject = ch;
      if (tmp1_subject.equals(new Char(35)))
        foundComment = !inString ? !inCharacter : false;
      else if (tmp1_subject.equals(new Char(39)))
        inCharacter = !!!(escaped ^ inCharacter) ? !inString : false;
      else if (tmp1_subject.equals(new Char(34)))
        inString = !!!(escaped ^ inString) ? !inCharacter : false;
      else if (tmp1_subject.equals(new Char(58))) {
        if (!inString ? !inCharacter : false) {
          wasLabel = true;
          if (!previousWords.isEmpty_16()) {
            throw AssemblerError_init_$Create$('' + 'label ' + currentWord + ' in the middle of an instruction');
          } else {
          }
        }} else if ((((tmp1_subject.equals(new Char(32)) ? true : tmp1_subject.equals(new Char(9))) ? true : tmp1_subject.equals(new Char(40))) ? true : tmp1_subject.equals(new Char(41))) ? true : tmp1_subject.equals(new Char(44)))
        wasDelimiter = !inString ? !inCharacter : false;
      escaped = !escaped ? ch.equals(new Char(92)) : false;
      if (foundComment)
        break $l$break;
      if (wasDelimiter) {
        addNonemptyWord(this, previousWords, currentWord);
        currentWord = new StringBuilder('');
      } else if (wasLabel) {
        addNonemptyWord(this, labels, currentWord);
        currentWord = new StringBuilder('');
      } else {
        currentWord.append_2(ch);
        Unit_getInstance();
      }
    }
    addNonemptyWord(this, previousWords, currentWord);
    return new Pair(labels, previousWords);
  };
  Lexer.$metadata$ = {
    simpleName: 'Lexer',
    kind: 'object',
    interfaces: []
  };
  var Lexer_instance;
  function Lexer_getInstance() {
    if (Lexer_instance == null)
      new Lexer();
    return Lexer_instance;
  }
  function Linter_0() {
    Linter_instance = this;
  }
  Linter_0.prototype.lint = function (text) {
    var tmp0_container = Assembler_getInstance().assemble_0(text);
    var errors = tmp0_container.component2_6();
    var linterErrors = ArrayList_init_$Create$();
    var tmp1_iterator = errors.iterator_29();
    while (tmp1_iterator.hasNext_10()) {
      var error = tmp1_iterator.next_10();
      var tmp2_elvis_lhs = error._line_0;
      var tmp = tmp2_elvis_lhs == null ? -1 : tmp2_elvis_lhs;
      var tmp3_elvis_lhs = error.message;
      linterErrors.add_12(new LintError_0(tmp, tmp3_elvis_lhs == null ? '' : tmp3_elvis_lhs));
      Unit_getInstance();
    }
    return copyToArray_0(linterErrors);
  };
  Linter_0.$metadata$ = {
    simpleName: 'Linter',
    kind: 'object',
    interfaces: []
  };
  var Linter_instance;
  function Linter_getInstance() {
    if (Linter_instance == null)
      new Linter_0();
    return Linter_instance;
  }
  function LintError_0(lineNumber, message) {
    this._lineNumber = lineNumber;
    this._message = message;
  }
  LintError_0.prototype.toString = function () {
    return '' + 'LintError(lineNumber=' + this._lineNumber + ', message=' + this._message + ')';
  };
  LintError_0.prototype.hashCode = function () {
    var result = this._lineNumber;
    result = imul(result, 31) + getStringHashCode(this._message) | 0;
    return result;
  };
  LintError_0.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof LintError_0))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof LintError_0 ? other : THROW_CCE();
    if (!(this._lineNumber === tmp0_other_with_cast._lineNumber))
      return false;
    if (!(this._message === tmp0_other_with_cast._message))
      return false;
    return true;
  };
  LintError_0.$metadata$ = {
    simpleName: 'LintError',
    kind: 'class',
    interfaces: []
  };
  var PseudoDispatcher_beqz_instance;
  var PseudoDispatcher_bgez_instance;
  var PseudoDispatcher_bgt_instance;
  var PseudoDispatcher_bgtu_instance;
  var PseudoDispatcher_bgtz_instance;
  var PseudoDispatcher_ble_instance;
  var PseudoDispatcher_bleu_instance;
  var PseudoDispatcher_blez_instance;
  var PseudoDispatcher_bltz_instance;
  var PseudoDispatcher_bnez_instance;
  var PseudoDispatcher_call_instance;
  var PseudoDispatcher_jal_instance;
  var PseudoDispatcher_jalr_instance;
  var PseudoDispatcher_j_instance;
  var PseudoDispatcher_jr_instance;
  var PseudoDispatcher_la_instance;
  var PseudoDispatcher_lb_instance;
  var PseudoDispatcher_lbu_instance;
  var PseudoDispatcher_lh_instance;
  var PseudoDispatcher_lhu_instance;
  var PseudoDispatcher_li_instance;
  var PseudoDispatcher_lw_instance;
  var PseudoDispatcher_mv_instance;
  var PseudoDispatcher_neg_instance;
  var PseudoDispatcher_nop_instance;
  var PseudoDispatcher_not_instance;
  var PseudoDispatcher_ret_instance;
  var PseudoDispatcher_sb_instance;
  var PseudoDispatcher_seqz_instance;
  var PseudoDispatcher_sgtz_instance;
  var PseudoDispatcher_sh_instance;
  var PseudoDispatcher_sltz_instance;
  var PseudoDispatcher_snez_instance;
  var PseudoDispatcher_sw_instance;
  var PseudoDispatcher_tail_instance;
  var PseudoDispatcher_seq_instance;
  var PseudoDispatcher_sge_instance;
  var PseudoDispatcher_sgeu_instance;
  var PseudoDispatcher_sgt_instance;
  var PseudoDispatcher_sgtu_instance;
  var PseudoDispatcher_sle_instance;
  var PseudoDispatcher_sleu_instance;
  var PseudoDispatcher_sne_instance;
  function valueOf(value) {
    switch (value) {
      case 'beqz':
        return PseudoDispatcher_beqz_getInstance();
      case 'bgez':
        return PseudoDispatcher_bgez_getInstance();
      case 'bgt':
        return PseudoDispatcher_bgt_getInstance();
      case 'bgtu':
        return PseudoDispatcher_bgtu_getInstance();
      case 'bgtz':
        return PseudoDispatcher_bgtz_getInstance();
      case 'ble':
        return PseudoDispatcher_ble_getInstance();
      case 'bleu':
        return PseudoDispatcher_bleu_getInstance();
      case 'blez':
        return PseudoDispatcher_blez_getInstance();
      case 'bltz':
        return PseudoDispatcher_bltz_getInstance();
      case 'bnez':
        return PseudoDispatcher_bnez_getInstance();
      case 'call':
        return PseudoDispatcher_call_getInstance();
      case 'jal':
        return PseudoDispatcher_jal_getInstance();
      case 'jalr':
        return PseudoDispatcher_jalr_getInstance();
      case 'j':
        return PseudoDispatcher_j_getInstance();
      case 'jr':
        return PseudoDispatcher_jr_getInstance();
      case 'la':
        return PseudoDispatcher_la_getInstance();
      case 'lb':
        return PseudoDispatcher_lb_getInstance();
      case 'lbu':
        return PseudoDispatcher_lbu_getInstance();
      case 'lh':
        return PseudoDispatcher_lh_getInstance();
      case 'lhu':
        return PseudoDispatcher_lhu_getInstance();
      case 'li':
        return PseudoDispatcher_li_getInstance();
      case 'lw':
        return PseudoDispatcher_lw_getInstance();
      case 'mv':
        return PseudoDispatcher_mv_getInstance();
      case 'neg':
        return PseudoDispatcher_neg_getInstance();
      case 'nop':
        return PseudoDispatcher_nop_getInstance();
      case 'not':
        return PseudoDispatcher_not_getInstance();
      case 'ret':
        return PseudoDispatcher_ret_getInstance();
      case 'sb':
        return PseudoDispatcher_sb_getInstance();
      case 'seqz':
        return PseudoDispatcher_seqz_getInstance();
      case 'sgtz':
        return PseudoDispatcher_sgtz_getInstance();
      case 'sh':
        return PseudoDispatcher_sh_getInstance();
      case 'sltz':
        return PseudoDispatcher_sltz_getInstance();
      case 'snez':
        return PseudoDispatcher_snez_getInstance();
      case 'sw':
        return PseudoDispatcher_sw_getInstance();
      case 'tail':
        return PseudoDispatcher_tail_getInstance();
      case 'seq':
        return PseudoDispatcher_seq_getInstance();
      case 'sge':
        return PseudoDispatcher_sge_getInstance();
      case 'sgeu':
        return PseudoDispatcher_sgeu_getInstance();
      case 'sgt':
        return PseudoDispatcher_sgt_getInstance();
      case 'sgtu':
        return PseudoDispatcher_sgtu_getInstance();
      case 'sle':
        return PseudoDispatcher_sle_getInstance();
      case 'sleu':
        return PseudoDispatcher_sleu_getInstance();
      case 'sne':
        return PseudoDispatcher_sne_getInstance();
      default:PseudoDispatcher_initEntries();
        THROW_ISE();
        break;
    }
  }
  var PseudoDispatcher_entriesInitialized;
  function PseudoDispatcher_initEntries() {
    if (PseudoDispatcher_entriesInitialized)
      return Unit_getInstance();
    PseudoDispatcher_entriesInitialized = true;
    PseudoDispatcher_beqz_instance = new PseudoDispatcher('beqz', 0, BEQZ_getInstance());
    PseudoDispatcher_bgez_instance = new PseudoDispatcher('bgez', 1, BGEZ_getInstance());
    PseudoDispatcher_bgt_instance = new PseudoDispatcher('bgt', 2, BGT_getInstance());
    PseudoDispatcher_bgtu_instance = new PseudoDispatcher('bgtu', 3, BGTU_getInstance());
    PseudoDispatcher_bgtz_instance = new PseudoDispatcher('bgtz', 4, BGTZ_getInstance());
    PseudoDispatcher_ble_instance = new PseudoDispatcher('ble', 5, BLE_getInstance());
    PseudoDispatcher_bleu_instance = new PseudoDispatcher('bleu', 6, BLEU_getInstance());
    PseudoDispatcher_blez_instance = new PseudoDispatcher('blez', 7, BLEZ_getInstance());
    PseudoDispatcher_bltz_instance = new PseudoDispatcher('bltz', 8, BLTZ_getInstance());
    PseudoDispatcher_bnez_instance = new PseudoDispatcher('bnez', 9, BNEZ_getInstance());
    PseudoDispatcher_call_instance = new PseudoDispatcher('call', 10, CALL_getInstance());
    PseudoDispatcher_jal_instance = new PseudoDispatcher('jal', 11, JAL_getInstance());
    PseudoDispatcher_jalr_instance = new PseudoDispatcher('jalr', 12, JALR_getInstance());
    PseudoDispatcher_j_instance = new PseudoDispatcher('j', 13, J_getInstance());
    PseudoDispatcher_jr_instance = new PseudoDispatcher('jr', 14, JR_getInstance());
    PseudoDispatcher_la_instance = new PseudoDispatcher('la', 15, LA_getInstance());
    PseudoDispatcher_lb_instance = new PseudoDispatcher('lb', 16, Load_getInstance());
    PseudoDispatcher_lbu_instance = new PseudoDispatcher('lbu', 17, Load_getInstance());
    PseudoDispatcher_lh_instance = new PseudoDispatcher('lh', 18, Load_getInstance());
    PseudoDispatcher_lhu_instance = new PseudoDispatcher('lhu', 19, Load_getInstance());
    PseudoDispatcher_li_instance = new PseudoDispatcher('li', 20, LI_getInstance());
    PseudoDispatcher_lw_instance = new PseudoDispatcher('lw', 21, Load_getInstance());
    PseudoDispatcher_mv_instance = new PseudoDispatcher('mv', 22, MV_getInstance());
    PseudoDispatcher_neg_instance = new PseudoDispatcher('neg', 23, NEG_getInstance());
    PseudoDispatcher_nop_instance = new PseudoDispatcher('nop', 24, NOP_getInstance());
    PseudoDispatcher_not_instance = new PseudoDispatcher('not', 25, NOT_getInstance());
    PseudoDispatcher_ret_instance = new PseudoDispatcher('ret', 26, RET_getInstance());
    PseudoDispatcher_sb_instance = new PseudoDispatcher('sb', 27, Store_getInstance());
    PseudoDispatcher_seqz_instance = new PseudoDispatcher('seqz', 28, SEQZ_getInstance());
    PseudoDispatcher_sgtz_instance = new PseudoDispatcher('sgtz', 29, SGTZ_getInstance());
    PseudoDispatcher_sh_instance = new PseudoDispatcher('sh', 30, Store_getInstance());
    PseudoDispatcher_sltz_instance = new PseudoDispatcher('sltz', 31, SLTZ_getInstance());
    PseudoDispatcher_snez_instance = new PseudoDispatcher('snez', 32, SNEZ_getInstance());
    PseudoDispatcher_sw_instance = new PseudoDispatcher('sw', 33, Store_getInstance());
    PseudoDispatcher_tail_instance = new PseudoDispatcher('tail', 34, TAIL_getInstance());
    PseudoDispatcher_seq_instance = new PseudoDispatcher('seq', 35, SEQ_getInstance());
    PseudoDispatcher_sge_instance = new PseudoDispatcher('sge', 36, SGE_getInstance());
    PseudoDispatcher_sgeu_instance = new PseudoDispatcher('sgeu', 37, SGE_getInstance());
    PseudoDispatcher_sgt_instance = new PseudoDispatcher('sgt', 38, SGT_getInstance());
    PseudoDispatcher_sgtu_instance = new PseudoDispatcher('sgtu', 39, SGT_getInstance());
    PseudoDispatcher_sle_instance = new PseudoDispatcher('sle', 40, SLE_getInstance());
    PseudoDispatcher_sleu_instance = new PseudoDispatcher('sleu', 41, SLE_getInstance());
    PseudoDispatcher_sne_instance = new PseudoDispatcher('sne', 42, SNE_getInstance());
  }
  function PseudoDispatcher(name, ordinal, pw) {
    Enum.call(this, name, ordinal);
    this._pw = pw;
  }
  PseudoDispatcher.$metadata$ = {
    simpleName: 'PseudoDispatcher',
    kind: 'class',
    interfaces: []
  };
  function PseudoDispatcher_beqz_getInstance() {
    PseudoDispatcher_initEntries();
    return PseudoDispatcher_beqz_instance;
  }
  function PseudoDispatcher_bgez_getInstance() {
    PseudoDispatcher_initEntries();
    return PseudoDispatcher_bgez_instance;
  }
  function PseudoDispatcher_bgt_getInstance() {
    PseudoDispatcher_initEntries();
    return PseudoDispatcher_bgt_instance;
  }
  function PseudoDispatcher_bgtu_getInstance() {
    PseudoDispatcher_initEntries();
    return PseudoDispatcher_bgtu_instance;
  }
  function PseudoDispatcher_bgtz_getInstance() {
    PseudoDispatcher_initEntries();
    return PseudoDispatcher_bgtz_instance;
  }
  function PseudoDispatcher_ble_getInstance() {
    PseudoDispatcher_initEntries();
    return PseudoDispatcher_ble_instance;
  }
  function PseudoDispatcher_bleu_getInstance() {
    PseudoDispatcher_initEntries();
    return PseudoDispatcher_bleu_instance;
  }
  function PseudoDispatcher_blez_getInstance() {
    PseudoDispatcher_initEntries();
    return PseudoDispatcher_blez_instance;
  }
  function PseudoDispatcher_bltz_getInstance() {
    PseudoDispatcher_initEntries();
    return PseudoDispatcher_bltz_instance;
  }
  function PseudoDispatcher_bnez_getInstance() {
    PseudoDispatcher_initEntries();
    return PseudoDispatcher_bnez_instance;
  }
  function PseudoDispatcher_call_getInstance() {
    PseudoDispatcher_initEntries();
    return PseudoDispatcher_call_instance;
  }
  function PseudoDispatcher_jal_getInstance() {
    PseudoDispatcher_initEntries();
    return PseudoDispatcher_jal_instance;
  }
  function PseudoDispatcher_jalr_getInstance() {
    PseudoDispatcher_initEntries();
    return PseudoDispatcher_jalr_instance;
  }
  function PseudoDispatcher_j_getInstance() {
    PseudoDispatcher_initEntries();
    return PseudoDispatcher_j_instance;
  }
  function PseudoDispatcher_jr_getInstance() {
    PseudoDispatcher_initEntries();
    return PseudoDispatcher_jr_instance;
  }
  function PseudoDispatcher_la_getInstance() {
    PseudoDispatcher_initEntries();
    return PseudoDispatcher_la_instance;
  }
  function PseudoDispatcher_lb_getInstance() {
    PseudoDispatcher_initEntries();
    return PseudoDispatcher_lb_instance;
  }
  function PseudoDispatcher_lbu_getInstance() {
    PseudoDispatcher_initEntries();
    return PseudoDispatcher_lbu_instance;
  }
  function PseudoDispatcher_lh_getInstance() {
    PseudoDispatcher_initEntries();
    return PseudoDispatcher_lh_instance;
  }
  function PseudoDispatcher_lhu_getInstance() {
    PseudoDispatcher_initEntries();
    return PseudoDispatcher_lhu_instance;
  }
  function PseudoDispatcher_li_getInstance() {
    PseudoDispatcher_initEntries();
    return PseudoDispatcher_li_instance;
  }
  function PseudoDispatcher_lw_getInstance() {
    PseudoDispatcher_initEntries();
    return PseudoDispatcher_lw_instance;
  }
  function PseudoDispatcher_mv_getInstance() {
    PseudoDispatcher_initEntries();
    return PseudoDispatcher_mv_instance;
  }
  function PseudoDispatcher_neg_getInstance() {
    PseudoDispatcher_initEntries();
    return PseudoDispatcher_neg_instance;
  }
  function PseudoDispatcher_nop_getInstance() {
    PseudoDispatcher_initEntries();
    return PseudoDispatcher_nop_instance;
  }
  function PseudoDispatcher_not_getInstance() {
    PseudoDispatcher_initEntries();
    return PseudoDispatcher_not_instance;
  }
  function PseudoDispatcher_ret_getInstance() {
    PseudoDispatcher_initEntries();
    return PseudoDispatcher_ret_instance;
  }
  function PseudoDispatcher_sb_getInstance() {
    PseudoDispatcher_initEntries();
    return PseudoDispatcher_sb_instance;
  }
  function PseudoDispatcher_seqz_getInstance() {
    PseudoDispatcher_initEntries();
    return PseudoDispatcher_seqz_instance;
  }
  function PseudoDispatcher_sgtz_getInstance() {
    PseudoDispatcher_initEntries();
    return PseudoDispatcher_sgtz_instance;
  }
  function PseudoDispatcher_sh_getInstance() {
    PseudoDispatcher_initEntries();
    return PseudoDispatcher_sh_instance;
  }
  function PseudoDispatcher_sltz_getInstance() {
    PseudoDispatcher_initEntries();
    return PseudoDispatcher_sltz_instance;
  }
  function PseudoDispatcher_snez_getInstance() {
    PseudoDispatcher_initEntries();
    return PseudoDispatcher_snez_instance;
  }
  function PseudoDispatcher_sw_getInstance() {
    PseudoDispatcher_initEntries();
    return PseudoDispatcher_sw_instance;
  }
  function PseudoDispatcher_tail_getInstance() {
    PseudoDispatcher_initEntries();
    return PseudoDispatcher_tail_instance;
  }
  function PseudoDispatcher_seq_getInstance() {
    PseudoDispatcher_initEntries();
    return PseudoDispatcher_seq_instance;
  }
  function PseudoDispatcher_sge_getInstance() {
    PseudoDispatcher_initEntries();
    return PseudoDispatcher_sge_instance;
  }
  function PseudoDispatcher_sgeu_getInstance() {
    PseudoDispatcher_initEntries();
    return PseudoDispatcher_sgeu_instance;
  }
  function PseudoDispatcher_sgt_getInstance() {
    PseudoDispatcher_initEntries();
    return PseudoDispatcher_sgt_instance;
  }
  function PseudoDispatcher_sgtu_getInstance() {
    PseudoDispatcher_initEntries();
    return PseudoDispatcher_sgtu_instance;
  }
  function PseudoDispatcher_sle_getInstance() {
    PseudoDispatcher_initEntries();
    return PseudoDispatcher_sle_instance;
  }
  function PseudoDispatcher_sleu_getInstance() {
    PseudoDispatcher_initEntries();
    return PseudoDispatcher_sleu_instance;
  }
  function PseudoDispatcher_sne_getInstance() {
    PseudoDispatcher_initEntries();
    return PseudoDispatcher_sne_instance;
  }
  function PseudoWriter() {
  }
  PseudoWriter.$metadata$ = {
    simpleName: 'PseudoWriter',
    kind: 'class',
    interfaces: []
  };
  function BEQZ() {
    BEQZ_instance = this;
    PseudoWriter.call(this);
  }
  BEQZ.prototype.invoke_83 = function (args, state) {
    checkArgsLength(args, 3);
    return listOf_0(listOf(['beq', args.get_24(1), 'x0', args.get_24(2)]));
  };
  BEQZ.$metadata$ = {
    simpleName: 'BEQZ',
    kind: 'object',
    interfaces: []
  };
  var BEQZ_instance;
  function BEQZ_getInstance() {
    if (BEQZ_instance == null)
      new BEQZ();
    return BEQZ_instance;
  }
  function BGEZ() {
    BGEZ_instance = this;
    PseudoWriter.call(this);
  }
  BGEZ.prototype.invoke_83 = function (args, state) {
    checkArgsLength(args, 3);
    return listOf_0(listOf(['bge', args.get_24(1), 'x0', args.get_24(2)]));
  };
  BGEZ.$metadata$ = {
    simpleName: 'BGEZ',
    kind: 'object',
    interfaces: []
  };
  var BGEZ_instance;
  function BGEZ_getInstance() {
    if (BGEZ_instance == null)
      new BGEZ();
    return BGEZ_instance;
  }
  function BGT() {
    BGT_instance = this;
    PseudoWriter.call(this);
  }
  BGT.prototype.invoke_83 = function (args, state) {
    checkArgsLength(args, 4);
    return listOf_0(listOf(['blt', args.get_24(2), args.get_24(1), args.get_24(3)]));
  };
  BGT.$metadata$ = {
    simpleName: 'BGT',
    kind: 'object',
    interfaces: []
  };
  var BGT_instance;
  function BGT_getInstance() {
    if (BGT_instance == null)
      new BGT();
    return BGT_instance;
  }
  function BGTU() {
    BGTU_instance = this;
    PseudoWriter.call(this);
  }
  BGTU.prototype.invoke_83 = function (args, state) {
    checkArgsLength(args, 4);
    return listOf_0(listOf(['bltu', args.get_24(2), args.get_24(1), args.get_24(3)]));
  };
  BGTU.$metadata$ = {
    simpleName: 'BGTU',
    kind: 'object',
    interfaces: []
  };
  var BGTU_instance;
  function BGTU_getInstance() {
    if (BGTU_instance == null)
      new BGTU();
    return BGTU_instance;
  }
  function BGTZ() {
    BGTZ_instance = this;
    PseudoWriter.call(this);
  }
  BGTZ.prototype.invoke_83 = function (args, state) {
    checkArgsLength(args, 3);
    return listOf_0(listOf(['blt', 'x0', args.get_24(1), args.get_24(2)]));
  };
  BGTZ.$metadata$ = {
    simpleName: 'BGTZ',
    kind: 'object',
    interfaces: []
  };
  var BGTZ_instance;
  function BGTZ_getInstance() {
    if (BGTZ_instance == null)
      new BGTZ();
    return BGTZ_instance;
  }
  function BLE() {
    BLE_instance = this;
    PseudoWriter.call(this);
  }
  BLE.prototype.invoke_83 = function (args, state) {
    checkArgsLength(args, 4);
    return listOf_0(listOf(['bge', args.get_24(2), args.get_24(1), args.get_24(3)]));
  };
  BLE.$metadata$ = {
    simpleName: 'BLE',
    kind: 'object',
    interfaces: []
  };
  var BLE_instance;
  function BLE_getInstance() {
    if (BLE_instance == null)
      new BLE();
    return BLE_instance;
  }
  function BLEU() {
    BLEU_instance = this;
    PseudoWriter.call(this);
  }
  BLEU.prototype.invoke_83 = function (args, state) {
    checkArgsLength(args, 4);
    return listOf_0(listOf(['bgeu', args.get_24(2), args.get_24(1), args.get_24(3)]));
  };
  BLEU.$metadata$ = {
    simpleName: 'BLEU',
    kind: 'object',
    interfaces: []
  };
  var BLEU_instance;
  function BLEU_getInstance() {
    if (BLEU_instance == null)
      new BLEU();
    return BLEU_instance;
  }
  function BLEZ() {
    BLEZ_instance = this;
    PseudoWriter.call(this);
  }
  BLEZ.prototype.invoke_83 = function (args, state) {
    checkArgsLength(args, 3);
    return listOf_0(listOf(['bge', 'x0', args.get_24(1), args.get_24(2)]));
  };
  BLEZ.$metadata$ = {
    simpleName: 'BLEZ',
    kind: 'object',
    interfaces: []
  };
  var BLEZ_instance;
  function BLEZ_getInstance() {
    if (BLEZ_instance == null)
      new BLEZ();
    return BLEZ_instance;
  }
  function BLTZ() {
    BLTZ_instance = this;
    PseudoWriter.call(this);
  }
  BLTZ.prototype.invoke_83 = function (args, state) {
    checkArgsLength(args, 3);
    return listOf_0(listOf(['blt', args.get_24(1), 'x0', args.get_24(2)]));
  };
  BLTZ.$metadata$ = {
    simpleName: 'BLTZ',
    kind: 'object',
    interfaces: []
  };
  var BLTZ_instance;
  function BLTZ_getInstance() {
    if (BLTZ_instance == null)
      new BLTZ();
    return BLTZ_instance;
  }
  function BNEZ() {
    BNEZ_instance = this;
    PseudoWriter.call(this);
  }
  BNEZ.prototype.invoke_83 = function (args, state) {
    checkArgsLength(args, 3);
    return listOf_0(listOf(['bne', args.get_24(1), 'x0', args.get_24(2)]));
  };
  BNEZ.$metadata$ = {
    simpleName: 'BNEZ',
    kind: 'object',
    interfaces: []
  };
  var BNEZ_instance;
  function BNEZ_getInstance() {
    if (BNEZ_instance == null)
      new BNEZ();
    return BNEZ_instance;
  }
  function CALL() {
    CALL_instance = this;
    PseudoWriter.call(this);
  }
  CALL.prototype.invoke_83 = function (args, state) {
    checkArgsLength(args, 2);
    var auipc_0 = listOf(['auipc', 'x6', '0']);
    state.addRelocation(PCRelHiRelocator, state.getOffset(), args.get_24(1));
    Unit_getInstance();
    var jalr_0 = listOf(['jalr', 'x1', 'x6', '0']);
    state.addRelocation(PCRelLoRelocator, state.getOffset() + 4 | 0, args.get_24(1));
    Unit_getInstance();
    return listOf([auipc_0, jalr_0]);
  };
  CALL.$metadata$ = {
    simpleName: 'CALL',
    kind: 'object',
    interfaces: []
  };
  var CALL_instance;
  function CALL_getInstance() {
    if (CALL_instance == null)
      new CALL();
    return CALL_instance;
  }
  function J() {
    J_instance = this;
    PseudoWriter.call(this);
  }
  J.prototype.invoke_83 = function (args, state) {
    checkArgsLength(args, 2);
    return listOf_0(listOf(['jal', 'x0', args.get_24(1)]));
  };
  J.$metadata$ = {
    simpleName: 'J',
    kind: 'object',
    interfaces: []
  };
  var J_instance;
  function J_getInstance() {
    if (J_instance == null)
      new J();
    return J_instance;
  }
  function JAL() {
    JAL_instance = this;
    PseudoWriter.call(this);
  }
  JAL.prototype.invoke_83 = function (args, state) {
    checkArgsLength(args, 2);
    return listOf_0(listOf(['jal', 'x1', args.get_24(1)]));
  };
  JAL.$metadata$ = {
    simpleName: 'JAL',
    kind: 'object',
    interfaces: []
  };
  var JAL_instance;
  function JAL_getInstance() {
    if (JAL_instance == null)
      new JAL();
    return JAL_instance;
  }
  function JALR() {
    JALR_instance = this;
    PseudoWriter.call(this);
  }
  JALR.prototype.invoke_83 = function (args, state) {
    checkArgsLength(args, 2);
    return listOf_0(listOf(['jalr', 'x1', args.get_24(1), '0']));
  };
  JALR.$metadata$ = {
    simpleName: 'JALR',
    kind: 'object',
    interfaces: []
  };
  var JALR_instance;
  function JALR_getInstance() {
    if (JALR_instance == null)
      new JALR();
    return JALR_instance;
  }
  function JR() {
    JR_instance = this;
    PseudoWriter.call(this);
  }
  JR.prototype.invoke_83 = function (args, state) {
    checkArgsLength(args, 2);
    return listOf_0(listOf(['jalr', 'x0', args.get_24(1), '0']));
  };
  JR.$metadata$ = {
    simpleName: 'JR',
    kind: 'object',
    interfaces: []
  };
  var JR_instance;
  function JR_getInstance() {
    if (JR_instance == null)
      new JR();
    return JR_instance;
  }
  function LA() {
    LA_instance = this;
    PseudoWriter.call(this);
  }
  LA.prototype.invoke_83 = function (args, state) {
    checkArgsLength(args, 3);
    var auipc_0 = listOf(['auipc', args.get_24(1), '0']);
    state.addRelocation(PCRelHiRelocator, state.getOffset(), args.get_24(2));
    Unit_getInstance();
    var addi_0 = listOf(['addi', args.get_24(1), args.get_24(1), '0']);
    state.addRelocation(PCRelLoRelocator, state.getOffset() + 4 | 0, args.get_24(2));
    Unit_getInstance();
    return listOf([auipc_0, addi_0]);
  };
  LA.$metadata$ = {
    simpleName: 'LA',
    kind: 'object',
    interfaces: []
  };
  var LA_instance;
  function LA_getInstance() {
    if (LA_instance == null)
      new LA();
    return LA_instance;
  }
  function LI() {
    LI_instance = this;
    PseudoWriter.call(this);
  }
  LI.prototype.invoke_83 = function (args, state) {
    checkArgsLength(args, 3);
    var tmp;
    try {
      tmp = userStringToInt(args.get_24(2));
    } catch ($p) {
      var tmp_0;
      if ($p instanceof NumberFormatException) {
        throw AssemblerError_init_$Create$('immediate to li too large or NaN');
      } else {
        {
          throw $p;
        }
      }
      tmp = tmp_0;
    }
    var imm = tmp;
    if (-2048 <= imm ? imm <= 2047 : false) {
      return listOf_0(listOf(['addi', args.get_24(1), 'x0', args.get_24(2)]));
    } else {
      var imm_hi = (imm + 2048 | 0) >>> 12;
      var imm_lo = imm - (imm_hi << 12) | 0;
      var lui_0 = listOf(['lui', args.get_24(1), imm_hi.toString()]);
      var addi_0 = listOf(['addi', args.get_24(1), args.get_24(1), imm_lo.toString()]);
      return listOf([lui_0, addi_0]);
    }
  };
  LI.$metadata$ = {
    simpleName: 'LI',
    kind: 'object',
    interfaces: []
  };
  var LI_instance;
  function LI_getInstance() {
    if (LI_instance == null)
      new LI();
    return LI_instance;
  }
  function Load() {
    Load_instance = this;
    PseudoWriter.call(this);
  }
  Load.prototype.invoke_83 = function (args, state) {
    checkArgsLength(args, 3);
    var auipc_0 = listOf(['auipc', args.get_24(1), '0']);
    state.addRelocation(PCRelHiRelocator, state.getOffset(), args.get_24(2));
    Unit_getInstance();
    var load = listOf([args.get_24(0), args.get_24(1), '0', args.get_24(1)]);
    state.addRelocation(PCRelLoRelocator, state.getOffset() + 4 | 0, args.get_24(2));
    Unit_getInstance();
    return listOf([auipc_0, load]);
  };
  Load.$metadata$ = {
    simpleName: 'Load',
    kind: 'object',
    interfaces: []
  };
  var Load_instance;
  function Load_getInstance() {
    if (Load_instance == null)
      new Load();
    return Load_instance;
  }
  function MV() {
    MV_instance = this;
    PseudoWriter.call(this);
  }
  MV.prototype.invoke_83 = function (args, state) {
    checkArgsLength(args, 3);
    return listOf_0(listOf(['addi', args.get_24(1), args.get_24(2), '0']));
  };
  MV.$metadata$ = {
    simpleName: 'MV',
    kind: 'object',
    interfaces: []
  };
  var MV_instance;
  function MV_getInstance() {
    if (MV_instance == null)
      new MV();
    return MV_instance;
  }
  function NEG() {
    NEG_instance = this;
    PseudoWriter.call(this);
  }
  NEG.prototype.invoke_83 = function (args, state) {
    checkArgsLength(args, 3);
    return listOf_0(listOf(['sub', args.get_24(1), 'x0', args.get_24(2)]));
  };
  NEG.$metadata$ = {
    simpleName: 'NEG',
    kind: 'object',
    interfaces: []
  };
  var NEG_instance;
  function NEG_getInstance() {
    if (NEG_instance == null)
      new NEG();
    return NEG_instance;
  }
  function NOP() {
    NOP_instance = this;
    PseudoWriter.call(this);
  }
  NOP.prototype.invoke_83 = function (args, state) {
    checkArgsLength(args, 1);
    return listOf_0(listOf(['addi', 'x0', 'x0', '0']));
  };
  NOP.$metadata$ = {
    simpleName: 'NOP',
    kind: 'object',
    interfaces: []
  };
  var NOP_instance;
  function NOP_getInstance() {
    if (NOP_instance == null)
      new NOP();
    return NOP_instance;
  }
  function NOT() {
    NOT_instance = this;
    PseudoWriter.call(this);
  }
  NOT.prototype.invoke_83 = function (args, state) {
    checkArgsLength(args, 3);
    return listOf_0(listOf(['xori', args.get_24(1), args.get_24(2), '-1']));
  };
  NOT.$metadata$ = {
    simpleName: 'NOT',
    kind: 'object',
    interfaces: []
  };
  var NOT_instance;
  function NOT_getInstance() {
    if (NOT_instance == null)
      new NOT();
    return NOT_instance;
  }
  function RET() {
    RET_instance = this;
    PseudoWriter.call(this);
  }
  RET.prototype.invoke_83 = function (args, state) {
    checkArgsLength(args, 1);
    return listOf_0(listOf(['jalr', 'x0', 'x1', '0']));
  };
  RET.$metadata$ = {
    simpleName: 'RET',
    kind: 'object',
    interfaces: []
  };
  var RET_instance;
  function RET_getInstance() {
    if (RET_instance == null)
      new RET();
    return RET_instance;
  }
  function SEQ() {
    SEQ_instance = this;
    PseudoWriter.call(this);
  }
  SEQ.prototype.invoke_83 = function (args, state) {
    checkArgsLength(args, 4);
    checkStrictMode();
    var subtract_0 = listOf(['sub', args.get_24(1), args.get_24(2), args.get_24(3)]);
    var checkZero = listOf(['sltiu', args.get_24(1), args.get_24(1), '1']);
    return listOf([subtract_0, checkZero]);
  };
  SEQ.$metadata$ = {
    simpleName: 'SEQ',
    kind: 'object',
    interfaces: []
  };
  var SEQ_instance;
  function SEQ_getInstance() {
    if (SEQ_instance == null)
      new SEQ();
    return SEQ_instance;
  }
  function SEQZ() {
    SEQZ_instance = this;
    PseudoWriter.call(this);
  }
  SEQZ.prototype.invoke_83 = function (args, state) {
    checkArgsLength(args, 3);
    return listOf_0(listOf(['sltiu', args.get_24(1), args.get_24(2), '1']));
  };
  SEQZ.$metadata$ = {
    simpleName: 'SEQZ',
    kind: 'object',
    interfaces: []
  };
  var SEQZ_instance;
  function SEQZ_getInstance() {
    if (SEQZ_instance == null)
      new SEQZ();
    return SEQZ_instance;
  }
  function SGE() {
    SGE_instance = this;
    PseudoWriter.call(this);
  }
  SGE.prototype.invoke_83 = function (args, state) {
    checkArgsLength(args, 4);
    checkStrictMode();
    var tmp;
    var tmp_0 = args.get_24(0);
    if (endsWith$default(tmp_0, 'u', false, 2, null)) {
      tmp = 'u';
    } else {
      {
        tmp = '';
      }
    }
    var unsigned = tmp;
    var set = listOf(['' + 'slt' + unsigned, args.get_24(1), args.get_24(2), args.get_24(3)]);
    var invert = listOf(['xori', args.get_24(1), args.get_24(1), '1']);
    return listOf([set, invert]);
  };
  SGE.$metadata$ = {
    simpleName: 'SGE',
    kind: 'object',
    interfaces: []
  };
  var SGE_instance;
  function SGE_getInstance() {
    if (SGE_instance == null)
      new SGE();
    return SGE_instance;
  }
  function SGT() {
    SGT_instance = this;
    PseudoWriter.call(this);
  }
  SGT.prototype.invoke_83 = function (args, state) {
    checkArgsLength(args, 4);
    checkStrictMode();
    var tmp;
    var tmp_0 = args.get_24(0);
    if (endsWith$default(tmp_0, 'u', false, 2, null)) {
      tmp = 'u';
    } else {
      {
        tmp = '';
      }
    }
    var unsigned = tmp;
    return listOf_0(listOf(['' + 'slt' + unsigned, args.get_24(1), args.get_24(3), args.get_24(2)]));
  };
  SGT.$metadata$ = {
    simpleName: 'SGT',
    kind: 'object',
    interfaces: []
  };
  var SGT_instance;
  function SGT_getInstance() {
    if (SGT_instance == null)
      new SGT();
    return SGT_instance;
  }
  function SGTZ() {
    SGTZ_instance = this;
    PseudoWriter.call(this);
  }
  SGTZ.prototype.invoke_83 = function (args, state) {
    checkArgsLength(args, 3);
    return listOf_0(listOf(['slt', args.get_24(1), 'x0', args.get_24(2)]));
  };
  SGTZ.$metadata$ = {
    simpleName: 'SGTZ',
    kind: 'object',
    interfaces: []
  };
  var SGTZ_instance;
  function SGTZ_getInstance() {
    if (SGTZ_instance == null)
      new SGTZ();
    return SGTZ_instance;
  }
  function SLE() {
    SLE_instance = this;
    PseudoWriter.call(this);
  }
  SLE.prototype.invoke_83 = function (args, state) {
    checkArgsLength(args, 4);
    checkStrictMode();
    var tmp;
    var tmp_0 = args.get_24(0);
    if (endsWith$default(tmp_0, 'u', false, 2, null)) {
      tmp = 'u';
    } else {
      {
        tmp = '';
      }
    }
    var unsigned = tmp;
    var set = listOf(['' + 'slt' + unsigned, args.get_24(1), args.get_24(3), args.get_24(2)]);
    var invert = listOf(['xori', args.get_24(1), args.get_24(1), '1']);
    return listOf([set, invert]);
  };
  SLE.$metadata$ = {
    simpleName: 'SLE',
    kind: 'object',
    interfaces: []
  };
  var SLE_instance;
  function SLE_getInstance() {
    if (SLE_instance == null)
      new SLE();
    return SLE_instance;
  }
  function SLTZ() {
    SLTZ_instance = this;
    PseudoWriter.call(this);
  }
  SLTZ.prototype.invoke_83 = function (args, state) {
    checkArgsLength(args, 3);
    return listOf_0(listOf(['slt', args.get_24(1), args.get_24(2), 'x0']));
  };
  SLTZ.$metadata$ = {
    simpleName: 'SLTZ',
    kind: 'object',
    interfaces: []
  };
  var SLTZ_instance;
  function SLTZ_getInstance() {
    if (SLTZ_instance == null)
      new SLTZ();
    return SLTZ_instance;
  }
  function SNE() {
    SNE_instance = this;
    PseudoWriter.call(this);
  }
  SNE.prototype.invoke_83 = function (args, state) {
    checkArgsLength(args, 4);
    checkStrictMode();
    var subtract_0 = listOf(['sub', args.get_24(1), args.get_24(2), args.get_24(3)]);
    var checkNonZero = listOf(['sltu', args.get_24(1), 'x0', args.get_24(1)]);
    return listOf([subtract_0, checkNonZero]);
  };
  SNE.$metadata$ = {
    simpleName: 'SNE',
    kind: 'object',
    interfaces: []
  };
  var SNE_instance;
  function SNE_getInstance() {
    if (SNE_instance == null)
      new SNE();
    return SNE_instance;
  }
  function SNEZ() {
    SNEZ_instance = this;
    PseudoWriter.call(this);
  }
  SNEZ.prototype.invoke_83 = function (args, state) {
    checkArgsLength(args, 3);
    return listOf_0(listOf(['sltu', args.get_24(1), 'x0', args.get_24(2)]));
  };
  SNEZ.$metadata$ = {
    simpleName: 'SNEZ',
    kind: 'object',
    interfaces: []
  };
  var SNEZ_instance;
  function SNEZ_getInstance() {
    if (SNEZ_instance == null)
      new SNEZ();
    return SNEZ_instance;
  }
  function Store() {
    Store_instance = this;
    PseudoWriter.call(this);
  }
  Store.prototype.invoke_83 = function (args, state) {
    checkArgsLength(args, 4);
    var label = args.get_24(2);
    try {
      userStringToInt(label);
      Unit_getInstance();
      return listOf_0(args);
    } catch ($p) {
      if ($p instanceof NumberFormatException) {
      } else {
        {
          throw $p;
        }
      }
    }
    var auipc_0 = listOf(['auipc', args.get_24(3), '0']);
    state.addRelocation(PCRelHiRelocator, state.getOffset(), label);
    Unit_getInstance();
    var store = listOf([args.get_24(0), args.get_24(1), '0', args.get_24(3)]);
    state.addRelocation(PCRelLoStoreRelocator, state.getOffset() + 4 | 0, label);
    Unit_getInstance();
    return listOf([auipc_0, store]);
  };
  Store.$metadata$ = {
    simpleName: 'Store',
    kind: 'object',
    interfaces: []
  };
  var Store_instance;
  function Store_getInstance() {
    if (Store_instance == null)
      new Store();
    return Store_instance;
  }
  function TAIL() {
    TAIL_instance = this;
    PseudoWriter.call(this);
  }
  TAIL.prototype.invoke_83 = function (args, state) {
    checkArgsLength(args, 2);
    var auipc_0 = listOf(['auipc', 'x6', '0']);
    state.addRelocation(PCRelHiRelocator, state.getOffset(), args.get_24(1));
    Unit_getInstance();
    var jalr_0 = listOf(['jalr', 'x0', 'x6', '0']);
    state.addRelocation(PCRelLoRelocator, state.getOffset() + 4 | 0, args.get_24(1));
    Unit_getInstance();
    return listOf([auipc_0, jalr_0]);
  };
  TAIL.$metadata$ = {
    simpleName: 'TAIL',
    kind: 'object',
    interfaces: []
  };
  var TAIL_instance;
  function TAIL_getInstance() {
    if (TAIL_instance == null)
      new TAIL();
    return TAIL_instance;
  }
  function checkArgsLength(args, required) {
    if (!(args._get_size__23() === required))
      throw AssemblerError_init_$Create$('wrong # of arguments');
  }
  function checkStrictMode() {
    if (Settings_getInstance()._strict)
      throw AssemblerError_init_$Create$("can't use this instruction in strict mode");
  }
  function _no_name_provided__30($boundThis) {
    this._$boundThis = $boundThis;
  }
  _no_name_provided__30.prototype.invoke_85 = function () {
    return this._$boundThis.runStart();
  };
  _no_name_provided__30.prototype._get_name__20 = function () {
    return 'runStart';
  };
  _no_name_provided__30.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__31($boundThis) {
    this._$boundThis_0 = $boundThis;
  }
  _no_name_provided__31.prototype.invoke_85 = function () {
    return this._$boundThis_0.runStart();
  };
  _no_name_provided__31.prototype._get_name__20 = function () {
    return 'runStart';
  };
  _no_name_provided__31.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Driver_0() {
    Driver_instance = this;
    this._timer = null;
    this._TIMEOUT_CYCLES = 100;
    this._TIMEOUT_TIME = 10;
  }
  Driver_0.prototype._set_sim_ = function (_set___) {
    this._sim = _set___;
  };
  Driver_0.prototype._get_sim_ = function () {
    var tmp = this._sim;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('sim');
    }
  };
  Driver_0.prototype.openSimulator = function () {
    var success = this.assemble_0(this.getText());
    if (success)
      Renderer_getInstance().renderSimulator(this._get_sim_());
  };
  Driver_0.prototype.openEditor = function () {
    this.runEnd();
    Renderer_getInstance().renderEditor();
  };
  Driver_0.prototype.getText = function () {
    var tmp = document.getElementById('asm-editor');
    var editor = tmp instanceof HTMLTextAreaElement ? tmp : THROW_CCE();
    return editor.value;
  };
  Driver_0.prototype.assemble_0 = function (text) {
    var tmp0_container = Assembler_getInstance().assemble_0(text);
    var prog = tmp0_container.component1_5();
    var errors = tmp0_container.component2_6();
    if (!errors.isEmpty_16()) {
      Renderer_getInstance().displayError(first(errors));
      return false;
    } else {
    }
    try {
      var linked = Linker_getInstance().link(listOf_0(prog));
      this._sim = new Simulator(linked);
      return true;
    } catch ($p) {
      if ($p instanceof AssemblerError) {
        Renderer_getInstance().displayError($p);
        return false;
      } else {
        {
          throw $p;
        }
      }
    }
  };
  Driver_0.prototype.run = function () {
    if (this.currentlyRunning()) {
      this.runEnd();
    } else {
      Renderer_getInstance().setRunButtonSpinning(true);
      var tmp = this;
      var tmp_0 = window;
      tmp._timer = function () {
        var $externalVarargReceiverTmp = tmp_0;
        return $externalVarargReceiverTmp.setTimeout.apply($externalVarargReceiverTmp, [_no_name_provided_$factory_24(Driver_getInstance()), 10]);
      }.call(this);
      this._get_sim_().step_0();
      Unit_getInstance();
    }
  };
  Driver_0.prototype.reset = function () {
    this.openSimulator();
  };
  Driver_0.prototype.toggleBreakpoint = function (idx) {
    var isBreakpoint = this._get_sim_().toggleBreakpointAt(idx);
    Renderer_getInstance().renderBreakpointAt(idx, isBreakpoint);
  };
  Driver_0.prototype._get_TIMEOUT_CYCLES_ = function () {
    return this._TIMEOUT_CYCLES;
  };
  Driver_0.prototype._get_TIMEOUT_TIME_ = function () {
    return this._TIMEOUT_TIME;
  };
  Driver_0.prototype.runStart = function () {
    var cycles = 0;
    while (cycles < 100) {
      if (this._get_sim_().isDone() ? true : this._get_sim_().atBreakpoint()) {
        this.runEnd();
        Renderer_getInstance().updateAll();
        return Unit_getInstance();
      }this._get_sim_().step_0();
      Unit_getInstance();
      var tmp0 = cycles;
      cycles = tmp0 + 1 | 0;
      Unit_getInstance();
    }
    var tmp = this;
    var tmp_0 = window;
    tmp._timer = function () {
      var $externalVarargReceiverTmp = tmp_0;
      return $externalVarargReceiverTmp.setTimeout.apply($externalVarargReceiverTmp, [_no_name_provided_$factory_25(Driver_getInstance()), 10]);
    }.call(this);
  };
  Driver_0.prototype.runEnd = function () {
    Renderer_getInstance().setRunButtonSpinning(false);
    var tmp0_safe_receiver = this._timer;
    if (tmp0_safe_receiver == null)
      null;
    else {
      var tmp0_let = window;
      tmp0_let.clearTimeout(tmp0_safe_receiver);
      Unit_getInstance();
    }
    Unit_getInstance();
    this._timer = null;
  };
  Driver_0.prototype.step = function () {
    var diffs = this._get_sim_().step_0();
    Renderer_getInstance().updateFromDiffs(diffs);
    Renderer_getInstance().updateControlButtons();
  };
  Driver_0.prototype.undo = function () {
    var diffs = this._get_sim_().undo_0();
    Renderer_getInstance().updateFromDiffs(diffs);
    Renderer_getInstance().updateControlButtons();
  };
  Driver_0.prototype.openMemoryTab = function () {
    Renderer_getInstance().renderMemoryTab();
  };
  Driver_0.prototype.openRegisterTab = function () {
    Renderer_getInstance().renderRegisterTab();
  };
  Driver_0.prototype.currentlyRunning = function () {
    return !(this._timer == null);
  };
  Driver_0.prototype.saveRegister = function (reg, id) {
    if (!this.currentlyRunning()) {
      try {
        var input = reg.value;
        this._get_sim_().setRegNoUndo(id, userStringToInt(input));
      } catch ($p) {
        if ($p instanceof NumberFormatException) {
        } else {
          {
            throw $p;
          }
        }
      }
    }var tmp = Renderer_getInstance();
    var tmp_0 = this._get_sim_().getReg_0(id);
    tmp.updateRegister$default(id, tmp_0, false, 4, null);
  };
  Driver_0.prototype.updateRegMemDisplay = function () {
    Renderer_getInstance().updateRegMemDisplay_0();
  };
  Driver_0.prototype.moveMemoryJump = function () {
    return Renderer_getInstance().moveMemoryJump_0();
  };
  Driver_0.prototype.moveMemoryUp = function () {
    return Renderer_getInstance().moveMemoryUp_0();
  };
  Driver_0.prototype.moveMemoryDown = function () {
    return Renderer_getInstance().moveMemoryDown_0();
  };
  Driver_0.prototype.getInstructionDump = function () {
    var sb_0 = StringBuilder_init_$Create$();
    var inductionVariable = 0;
    var last_2 = this._get_sim_()._linkedProgram._prog_3._insts._get_size__23();
    if (inductionVariable < last_2)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var mcode = this._get_sim_()._linkedProgram._prog_3._insts.get_24(i);
        var hexRepresentation = Renderer_getInstance().toHex(mcode.get_12(InstructionField_ENTIRE_getInstance()));
        sb_0.append_4(removePrefix(hexRepresentation, '0x'));
        Unit_getInstance();
        sb_0.append_4('\n');
        Unit_getInstance();
      }
       while (inductionVariable < last_2);
    return sb_0.toString();
  };
  Driver_0.prototype.dump = function () {
    Renderer_getInstance().clearConsole();
    Renderer_getInstance().printConsole(this.getInstructionDump());
    var tmp = document.getElementById('console-output');
    var ta = tmp instanceof HTMLTextAreaElement ? tmp : THROW_CCE();
    ta.select();
    var success = document.execCommand('copy');
    if (success) {
      window.alert('Successfully copied machine code to clipboard');
    }};
  Driver_0.$metadata$ = {
    simpleName: 'Driver',
    kind: 'object',
    interfaces: []
  };
  Object.defineProperty(Driver_0.prototype, 'sim', {
    configurable: true,
    get: Driver_0.prototype._get_sim_,
    set: Driver_0.prototype._set_sim_
  });
  var Driver_instance;
  function Driver_getInstance() {
    if (Driver_instance == null)
      new Driver_0();
    return Driver_instance;
  }
  function _no_name_provided_$factory_24($boundThis) {
    var i = new _no_name_provided__30($boundThis);
    var l = function () {
      i.invoke_85();
      return Unit_getInstance();
    };
    l.callableName = i._get_name__20();
    return l;
  }
  function _no_name_provided_$factory_25($boundThis) {
    var i = new _no_name_provided__31($boundThis);
    var l = function () {
      i.invoke_85();
      return Unit_getInstance();
    };
    l.callableName = i._get_name__20();
    return l;
  }
  function _get_sim_($this) {
    var tmp = $this._sim_0;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('sim');
    }
  }
  function tabSetVisibility($this, tab, display) {
    var tmp = document.getElementById('' + tab + '-tab-view');
    var tabView = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    var tmp_0 = document.getElementById('' + tab + '-tab');
    var tabDisplay = tmp_0 instanceof HTMLElement ? tmp_0 : THROW_CCE();
    tabView.style.display = display;
    if (display === 'none') {
      (function () {
        var $externalVarargReceiverTmp = tabDisplay.classList;
        return $externalVarargReceiverTmp.remove.apply($externalVarargReceiverTmp, [].concat(['is-active']));
      }.call(this));
    } else {
      (function () {
        var $externalVarargReceiverTmp = tabDisplay.classList;
        return $externalVarargReceiverTmp.add.apply($externalVarargReceiverTmp, [].concat(['is-active']));
      }.call(this));
    }
  }
  function renderProgramListing($this) {
    $this.clearProgramListing();
    var inductionVariable = 0;
    var last_2 = _get_sim_($this)._linkedProgram._prog_3._insts._get_size__23();
    if (inductionVariable < last_2)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var programDebug = _get_sim_($this)._linkedProgram._dbg_0.get_24(i);
        var tmp1_container = programDebug;
        var dbg = tmp1_container.component2_6();
        var tmp2_container = dbg;
        var line = tmp2_container.component2_6();
        var mcode = _get_sim_($this)._linkedProgram._prog_3._insts.get_24(i);
        $this.addToProgramListing(i, mcode, line);
      }
       while (inductionVariable < last_2);
  }
  function setButtonDisabled($this, id, disabled) {
    var tmp = $this.getElement(id);
    var button = tmp instanceof HTMLButtonElement ? tmp : THROW_CCE();
    button.disabled = disabled;
  }
  function updateMemory($this, addr) {
    var wordAddress = addr >> 2 << 2;
    if (mustMoveMemoryDisplay($this, wordAddress)) {
      $this._activeMemoryAddress = wordAddress;
    }var inductionVariable = -6;
    var last_2 = 6;
    if (inductionVariable <= last_2)
      do {
        var rowIdx = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var row = $this.getElement('' + 'mem-row-' + rowIdx);
        var rowAddr = $this._activeMemoryAddress + imul(4, rowIdx) | 0;
        renderMemoryRow($this, row, rowAddr);
      }
       while (!(rowIdx === last_2));
  }
  function mustMoveMemoryDisplay($this, wordAddress) {
    var containsLower = -6;
    var containsUpper = 6;
    var containsArg = ($this._activeMemoryAddress - wordAddress | 0) >> 2;
    return !(containsLower <= containsArg ? containsArg <= containsUpper : false);
  }
  function renderMemoryRow($this, row, rowAddr) {
    var rowElement = row instanceof HTMLTableRowElement ? row : THROW_CCE();
    var tmp0_get_0 = rowElement.cells;
    var tmp1_get_0 = 0;
    var tmp = tmp0_get_0[tmp1_get_0];
    var tdAddress = tmp instanceof HTMLTableCellElement ? tmp : THROW_CCE();
    if (rowAddr >= 0) {
      tdAddress.innerText = $this.toHex(rowAddr);
      var inductionVariable = 1;
      if (inductionVariable <= 4)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp2_get_0 = rowElement.cells;
          var tmp_0 = tmp2_get_0[i];
          var tdByte = tmp_0 instanceof HTMLTableCellElement ? tmp_0 : THROW_CCE();
          var byte = _get_sim_($this).loadByte_0((rowAddr + i | 0) - 1 | 0);
          var tmp1_subject = $this._displayType;
          tdByte.innerText = tmp1_subject === 'Hex' ? byteToHex($this, byte) : tmp1_subject === 'Decimal' ? byteToDec($this, byte) : tmp1_subject === 'Unsigned' ? byteToUnsign($this, byte) : tmp1_subject === 'ASCII' ? toAscii($this, byte) : byteToHex($this, byte);
        }
         while (inductionVariable <= 4);
    } else {
      tdAddress.textContent = '----------';
      var inductionVariable_0 = 1;
      if (inductionVariable_0 <= 4)
        do {
          var i_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var tmp3_get_0 = row.cells;
          var tmp_1 = tmp3_get_0[i_0];
          var tdByte_0 = tmp_1 instanceof HTMLTableCellElement ? tmp_1 : THROW_CCE();
          tdByte_0.innerText = '--';
        }
         while (inductionVariable_0 <= 4);
    }
  }
  function byteToHex($this, b) {
    var leftNibble = $this._hexMap.get_24(b >>> 4);
    var rightNibble = $this._hexMap.get_24(b & 15);
    return '' + leftNibble + rightNibble;
  }
  function byteToDec($this, b) {
    return toByte(b).toString();
  }
  function byteToUnsign($this, b) {
    return b.toString();
  }
  function toUnsigned($this, value) {
    return value >= 0 ? value.toString() : numberToLong(value).plus_27(new Long(0, 1)).toString();
  }
  function toAscii($this, value) {
    var tmp0_subject = value;
    return !(0 <= tmp0_subject ? tmp0_subject <= 255 : false) ? $this.toHex(value) : !(32 <= tmp0_subject ? tmp0_subject <= 126 : false) ? '\uFFFD' : '' + "'" + numberToChar(value) + "'";
  }
  function moveMemoryBy($this, rows) {
    var bytes = imul(4, rows);
    if (($this._activeMemoryAddress + bytes | 0) < 0)
      return Unit_getInstance();
    var tmp0_this = $this;
    tmp0_this._activeMemoryAddress = tmp0_this._activeMemoryAddress + bytes | 0;
    updateMemory($this, $this._activeMemoryAddress);
  }
  function displayError$outlinedJsCode$(e) {
    return alert(e.message);
  }
  function _no_name_provided__32($idx) {
    this._$idx = $idx;
  }
  _no_name_provided__32.prototype.invoke_86 = function (it) {
    Driver_getInstance().toggleBreakpoint(this._$idx);
  };
  _no_name_provided__32.prototype.invoke_213 = function (p1) {
    this.invoke_86(p1 instanceof MouseEvent ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__32.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Renderer() {
    Renderer_instance = this;
    this._activeRegister = null;
    this._activeInstruction = null;
    this._activeMemoryAddress = 0;
    this._displayType = 'hex';
    this._MEMORY_CONTEXT = 6;
    this._hexMap = listOf([new Char(48), new Char(49), new Char(50), new Char(51), new Char(52), new Char(53), new Char(54), new Char(55), new Char(56), new Char(57), new Char(97), new Char(98), new Char(99), new Char(100), new Char(101), new Char(102)]);
  }
  Renderer.prototype.renderSimulator = function (displaySim) {
    tabSetVisibility(this, 'simulator', 'block');
    tabSetVisibility(this, 'editor', 'none');
    this._sim_0 = displaySim;
    this.setRunButtonSpinning(false);
    renderProgramListing(this);
    this.clearConsole();
    this.updateAll();
  };
  Renderer.prototype.renderEditor = function () {
    tabSetVisibility(this, 'simulator', 'none');
    tabSetVisibility(this, 'editor', 'block');
  };
  Renderer.prototype.displayError = function (e) {
    displayError$outlinedJsCode$(e);
  };
  Renderer.prototype.updateAll = function () {
    this.updatePC(_get_sim_(this).getPC());
    updateMemory(this, this._activeMemoryAddress);
    this.updateControlButtons();
    var inductionVariable = 0;
    if (inductionVariable <= 31)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = _get_sim_(this).getReg_0(i);
        this.updateRegister$default(i, tmp, false, 4, null);
      }
       while (inductionVariable <= 31);
  };
  Renderer.prototype.updateFromDiffs = function (diffs) {
    var tmp0_iterator = diffs.iterator_29();
    while (tmp0_iterator.hasNext_10()) {
      var diff = tmp0_iterator.next_10();
      var tmp1_subject = diff;
      if (tmp1_subject instanceof RegisterDiff)
        this.updateRegister(diff._id, diff._v, true);
      else {
        if (tmp1_subject instanceof PCDiff)
          this.updatePC(diff._pc);
        else {
          if (tmp1_subject instanceof MemoryDiff)
            updateMemory(this, diff._addr);
          else {
            if (tmp1_subject instanceof HeapSpaceDiff) {
            } else {
            }
          }
        }
      }
    }
  };
  Renderer.prototype.clearProgramListing = function () {
    this.getElement('program-listing-body').innerHTML = '';
  };
  Renderer.prototype.addToProgramListing = function (idx, mcode, progLine) {
    var tmp = this.getElement('program-listing-body');
    var programTable = tmp instanceof HTMLTableSectionElement ? tmp : THROW_CCE();
    var tmp_0 = programTable.insertRow();
    var newRow = tmp_0 instanceof HTMLTableRowElement ? tmp_0 : THROW_CCE();
    newRow.id = '' + 'instruction-' + idx;
    newRow.onclick = _no_name_provided_$factory_26(idx);
    var hexRepresention = this.toHex(mcode.get_12(InstructionField_ENTIRE_getInstance()));
    var machineCode = newRow.insertCell(0);
    var machineCodeText = document.createTextNode(hexRepresention);
    machineCode.appendChild(machineCodeText);
    Unit_getInstance();
    var basicCode = newRow.insertCell(1);
    var basicCodeText = document.createTextNode(Companion_getInstance_7().get_13(mcode)._disasm.invoke_202(mcode));
    basicCode.appendChild(basicCodeText);
    Unit_getInstance();
    var line = newRow.insertCell(2);
    var lineText = document.createTextNode(progLine);
    line.appendChild(lineText);
    Unit_getInstance();
  };
  Renderer.prototype.getElement = function (id) {
    var tmp = document.getElementById(id);
    return tmp instanceof HTMLElement ? tmp : THROW_CCE();
  };
  Renderer.prototype.updateRegister = function (id, value, setActive) {
    var tmp = this.getElement('' + 'reg-' + id + '-val');
    var register = tmp instanceof HTMLInputElement ? tmp : THROW_CCE();
    var tmp0_subject = this._displayType;
    register.value = tmp0_subject === 'Hex' ? this.toHex(value) : tmp0_subject === 'Decimal' ? value.toString() : tmp0_subject === 'Unsigned' ? toUnsigned(this, value) : tmp0_subject === 'ASCII' ? toAscii(this, value) : this.toHex(value);
    if (setActive) {
      var tmp1_safe_receiver = this._activeRegister;
      var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.classList;
      if (tmp2_safe_receiver == null)
        null;
      else {
        (function () {
          var $externalVarargReceiverTmp = tmp2_safe_receiver;
          return $externalVarargReceiverTmp.remove.apply($externalVarargReceiverTmp, [].concat(['is-modified']));
        }.call(this));
        Unit_getInstance();
      }
      Unit_getInstance();
      (function () {
        var $externalVarargReceiverTmp = register.classList;
        return $externalVarargReceiverTmp.add.apply($externalVarargReceiverTmp, [].concat(['is-modified']));
      }.call(this));
      this._activeRegister = register;
    }};
  Renderer.prototype.updateRegister$default = function (id, value, setActive, $mask0, $handler) {
    if (!(($mask0 & 4) === 0))
      setActive = false;
    return this.updateRegister(id, value, setActive);
  };
  Renderer.prototype.updatePC = function (pc) {
    var idx = pc / 4 | 0;
    var tmp0_safe_receiver = this._activeInstruction;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.classList;
    if (tmp1_safe_receiver == null)
      null;
    else {
      (function () {
        var $externalVarargReceiverTmp = tmp1_safe_receiver;
        return $externalVarargReceiverTmp.remove.apply($externalVarargReceiverTmp, [].concat(['is-selected']));
      }.call(this));
      Unit_getInstance();
    }
    Unit_getInstance();
    var tmp = document.getElementById('' + 'instruction-' + idx);
    var newActiveInstruction = (tmp == null ? true : tmp instanceof HTMLElement) ? tmp : THROW_CCE();
    var tmp2_safe_receiver = newActiveInstruction;
    var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.classList;
    if (tmp3_safe_receiver == null)
      null;
    else {
      (function () {
        var $externalVarargReceiverTmp = tmp3_safe_receiver;
        return $externalVarargReceiverTmp.add.apply($externalVarargReceiverTmp, [].concat(['is-selected']));
      }.call(this));
      Unit_getInstance();
    }
    Unit_getInstance();
    var tmp4_safe_receiver = newActiveInstruction;
    if (tmp4_safe_receiver == null)
      null;
    else {
      tmp4_safe_receiver.scrollIntoView(false);
      Unit_getInstance();
    }
    Unit_getInstance();
    this._activeInstruction = newActiveInstruction;
  };
  Renderer.prototype.printConsole = function (thing) {
    var tmp = this.getElement('console-output');
    var console_0 = tmp instanceof HTMLTextAreaElement ? tmp : THROW_CCE();
    var tmp0_this = console_0;
    tmp0_this.value = tmp0_this.value + toString_1(thing);
  };
  Renderer.prototype.clearConsole = function () {
    var tmp = this.getElement('console-output');
    var console_0 = tmp instanceof HTMLTextAreaElement ? tmp : THROW_CCE();
    console_0.value = '';
  };
  Renderer.prototype.setRunButtonSpinning = function (spinning) {
    var runButton = this.getElement('simulator-run');
    if (spinning) {
      (function () {
        var $externalVarargReceiverTmp = runButton.classList;
        return $externalVarargReceiverTmp.add.apply($externalVarargReceiverTmp, [].concat(['is-loading']));
      }.call(this));
      this.disableControlButtons();
    } else {
      (function () {
        var $externalVarargReceiverTmp = runButton.classList;
        return $externalVarargReceiverTmp.remove.apply($externalVarargReceiverTmp, [].concat(['is-loading']));
      }.call(this));
      this.updateControlButtons();
    }
  };
  Renderer.prototype.updateControlButtons = function () {
    setButtonDisabled(this, 'simulator-reset', !_get_sim_(this).canUndo());
    setButtonDisabled(this, 'simulator-undo', !_get_sim_(this).canUndo());
    setButtonDisabled(this, 'simulator-step', _get_sim_(this).isDone());
    setButtonDisabled(this, 'simulator-run', _get_sim_(this).isDone());
  };
  Renderer.prototype.disableControlButtons = function () {
    setButtonDisabled(this, 'simulator-reset', true);
    setButtonDisabled(this, 'simulator-undo', true);
    setButtonDisabled(this, 'simulator-step', true);
  };
  Renderer.prototype.renderBreakpointAt = function (idx, state) {
    var row = this.getElement('' + 'instruction-' + idx);
    if (state) {
      (function () {
        var $externalVarargReceiverTmp = row.classList;
        return $externalVarargReceiverTmp.add.apply($externalVarargReceiverTmp, [].concat(['is-breakpoint']));
      }.call(this));
    } else {
      (function () {
        var $externalVarargReceiverTmp = row.classList;
        return $externalVarargReceiverTmp.remove.apply($externalVarargReceiverTmp, [].concat(['is-breakpoint']));
      }.call(this));
    }
  };
  Renderer.prototype.renderMemoryTab = function () {
    tabSetVisibility(this, 'memory', 'block');
    tabSetVisibility(this, 'register', 'none');
  };
  Renderer.prototype.renderRegisterTab = function () {
    tabSetVisibility(this, 'register', 'block');
    tabSetVisibility(this, 'memory', 'none');
  };
  Renderer.prototype.toHex = function (value) {
    var remainder = toLong_1(value);
    var suffix = '';
    var tmp0_repeat_0 = 8;
    var inductionVariable = 0;
    if (inductionVariable < tmp0_repeat_0)
      do {
        var index_2 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var hexDigit_4 = Renderer_getInstance()._hexMap.get_24(remainder.and(new Long(15, 0)).toInt_5());
        var tmp0_plus_0_5 = suffix;
        suffix = hexDigit_4.toString() + tmp0_plus_0_5;
        remainder = remainder.ushr_0(4);
      }
       while (inductionVariable < tmp0_repeat_0);
    return '0x' + suffix;
  };
  Renderer.prototype.updateRegMemDisplay_0 = function () {
    var tmp = this.getElement('display-settings');
    var displaySelect = tmp instanceof HTMLSelectElement ? tmp : THROW_CCE();
    this._displayType = displaySelect.value;
    this.updateAll();
  };
  Renderer.prototype.moveMemoryJump_0 = function () {
    var tmp = this.getElement('address-jump');
    var jumpSelect = tmp instanceof HTMLSelectElement ? tmp : THROW_CCE();
    var where = jumpSelect.value;
    var tmp_0 = this;
    var tmp0_subject = where;
    var tmp_1;
    switch (tmp0_subject) {
      case 'Text':
        MemorySegments_getInstance();
        tmp_1 = 0;
        break;
      case 'Data':
        MemorySegments_getInstance();
        tmp_1 = 268435456;
        break;
      case 'Heap':
        MemorySegments_getInstance();
        tmp_1 = 268468224;
        break;
      case 'Stack':
        MemorySegments_getInstance();
        tmp_1 = 2147483632;
        break;
      default:MemorySegments_getInstance();
        tmp_1 = 0;
        break;
    }
    tmp_0._activeMemoryAddress = tmp_1;
    updateMemory(this, this._activeMemoryAddress);
    jumpSelect.selectedIndex = 0;
  };
  Renderer.prototype.moveMemoryUp_0 = function () {
    return moveMemoryBy(this, 6);
  };
  Renderer.prototype.moveMemoryDown_0 = function () {
    return moveMemoryBy(this, -6);
  };
  Renderer.$metadata$ = {
    simpleName: 'Renderer',
    kind: 'object',
    interfaces: []
  };
  var Renderer_instance;
  function Renderer_getInstance() {
    if (Renderer_instance == null)
      new Renderer();
    return Renderer_instance;
  }
  function _no_name_provided_$factory_26($idx) {
    var i = new _no_name_provided__32($idx);
    return function (p1) {
      i.invoke_86(p1);
      return Unit_getInstance();
    };
  }
  function ProgramDebugInfo(programName, dbg) {
    this._programName = programName;
    this._dbg = dbg;
  }
  ProgramDebugInfo.prototype.component2_6 = function () {
    return this._dbg;
  };
  ProgramDebugInfo.prototype.toString = function () {
    return '' + 'ProgramDebugInfo(programName=' + this._programName + ', dbg=' + this._dbg + ')';
  };
  ProgramDebugInfo.prototype.hashCode = function () {
    var result = getStringHashCode(this._programName);
    result = imul(result, 31) + this._dbg.hashCode() | 0;
    return result;
  };
  ProgramDebugInfo.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProgramDebugInfo))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof ProgramDebugInfo ? other : THROW_CCE();
    if (!(this._programName === tmp0_other_with_cast._programName))
      return false;
    if (!this._dbg.equals(tmp0_other_with_cast._dbg))
      return false;
    return true;
  };
  ProgramDebugInfo.$metadata$ = {
    simpleName: 'ProgramDebugInfo',
    kind: 'class',
    interfaces: []
  };
  function LinkedProgram() {
    var tmp = this;
    tmp._prog_3 = Program_init_$Create$(null, 1, null);
    this._dbg_0 = ArrayList_init_$Create$();
    this._startPC = null;
  }
  LinkedProgram.$metadata$ = {
    simpleName: 'LinkedProgram',
    kind: 'class',
    interfaces: []
  };
  function RelocationInfo(relocator, offset, label) {
    this._relocator = relocator;
    this._offset = offset;
    this._label = label;
  }
  RelocationInfo.prototype.component1_5 = function () {
    return this._relocator;
  };
  RelocationInfo.prototype.component2_6 = function () {
    return this._offset;
  };
  RelocationInfo.prototype.component3_0 = function () {
    return this._label;
  };
  RelocationInfo.prototype.toString = function () {
    return '' + 'RelocationInfo(relocator=' + this._relocator + ', offset=' + this._offset + ', label=' + this._label + ')';
  };
  RelocationInfo.prototype.hashCode = function () {
    var result = hashCode(this._relocator);
    result = imul(result, 31) + this._offset | 0;
    result = imul(result, 31) + getStringHashCode(this._label) | 0;
    return result;
  };
  RelocationInfo.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RelocationInfo))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof RelocationInfo ? other : THROW_CCE();
    if (!equals_0(this._relocator, tmp0_other_with_cast._relocator))
      return false;
    if (!(this._offset === tmp0_other_with_cast._offset))
      return false;
    if (!(this._label === tmp0_other_with_cast._label))
      return false;
    return true;
  };
  RelocationInfo.$metadata$ = {
    simpleName: 'RelocationInfo',
    kind: 'class',
    interfaces: []
  };
  function Linker() {
    Linker_instance = this;
  }
  Linker.prototype.link = function (progs) {
    var linkedProgram = new LinkedProgram();
    var globalTable = HashMap_init_$Create$();
    var toRelocate = ArrayList_init_$Create$();
    var textTotalOffset = 0;
    var dataTotalOffset = 0;
    var tmp0_iterator = progs.iterator_29();
    while (tmp0_iterator.hasNext_10()) {
      var prog = tmp0_iterator.next_10();
      var tmp0_iterator_0 = prog._labels;
      var tmp1_iterator = tmp0_iterator_0._get_entries__3().iterator_29();
      while (tmp1_iterator.hasNext_10()) {
        var tmp2_loop_parameter = tmp1_iterator.next_10();
        var label = tmp2_loop_parameter._get_key__5();
        var offset = tmp2_loop_parameter._get_value__11();
        var tmp;
        MemorySegments_getInstance();
        if (offset >= 268435456) {
          tmp = dataTotalOffset;
        } else {
          {
            tmp = textTotalOffset;
          }
        }
        var start = tmp;
        var location = start + offset | 0;
        if (prog.isGlobalLabel(label)) {
          var previousValue = globalTable.put_2(label, location);
          if (!(previousValue == null)) {
            throw AssemblerError_init_$Create$('' + 'label ' + label + ' defined global in two different files');
          }if (label === 'main') {
            linkedProgram._startPC = location;
          }}}
      var tmp1_forEach_0 = prog._insts;
      var tmp2_forEach = linkedProgram._prog_3;
      var tmp0_iterator_1 = tmp1_forEach_0.iterator_29();
      while (tmp0_iterator_1.hasNext_10()) {
        var element_2 = tmp0_iterator_1.next_10();
        tmp2_forEach.add_13(element_2);
      }
      var tmp3_forEach_0 = prog._debugInfo;
      var tmp0_iterator_1_0 = tmp3_forEach_0.iterator_29();
      while (tmp0_iterator_1_0.hasNext_10()) {
        var element_2_0 = tmp0_iterator_1_0.next_10();
        linkedProgram._dbg_0.add_12(new ProgramDebugInfo(prog._name_0, element_2_0));
        Unit_getInstance();
      }
      var tmp4_forEach_0 = prog._dataSegment;
      var tmp5_forEach = linkedProgram._prog_3;
      var tmp0_iterator_1_1 = tmp4_forEach_0.iterator_29();
      while (tmp0_iterator_1_1.hasNext_10()) {
        var element_2_1 = tmp0_iterator_1_1.next_10();
        tmp5_forEach.addToData(element_2_1);
      }
      var tmp3_iterator = prog._relocationTable.iterator_29();
      while (tmp3_iterator.hasNext_10()) {
        var tmp4_loop_parameter = tmp3_iterator.next_10();
        var relocator = tmp4_loop_parameter.component1_5();
        var offset_0 = tmp4_loop_parameter.component2_6();
        var label_0 = tmp4_loop_parameter.component3_0();
        var toAddress = prog._labels.get_11(label_0);
        var location_0 = textTotalOffset + offset_0 | 0;
        if (!(toAddress == null)) {
          var mcode = linkedProgram._prog_3._insts.get_24(location_0 / 4 | 0);
          relocator.invoke$default(mcode, location_0, toAddress, false, 8, null);
        } else {
          toRelocate.add_12(new RelocationInfo(relocator, location_0, label_0));
          Unit_getInstance();
        }
      }
      textTotalOffset = textTotalOffset + prog._textSize | 0;
      dataTotalOffset = dataTotalOffset + prog._dataSize | 0;
    }
    var tmp5_iterator = toRelocate.iterator_29();
    while (tmp5_iterator.hasNext_10()) {
      var tmp6_loop_parameter = tmp5_iterator.next_10();
      var relocator_0 = tmp6_loop_parameter.component1_5();
      var offset_1 = tmp6_loop_parameter.component2_6();
      var label_1 = tmp6_loop_parameter.component3_0();
      var tmp7_elvis_lhs = globalTable.get_11(label_1);
      var tmp_0;
      if (tmp7_elvis_lhs == null) {
        throw AssemblerError_init_$Create$('' + 'label ' + label_1 + ' used but not defined');
      } else {
        tmp_0 = tmp7_elvis_lhs;
      }
      var toAddress_0 = tmp_0;
      var mcode_0 = linkedProgram._prog_3._insts.get_24(offset_1 / 4 | 0);
      relocator_0.invoke$default(mcode_0, offset_1, toAddress_0, false, 8, null);
    }
    return linkedProgram;
  };
  Linker.$metadata$ = {
    simpleName: 'Linker',
    kind: 'object',
    interfaces: []
  };
  var Linker_instance;
  function Linker_getInstance() {
    if (Linker_instance == null)
      new Linker();
    return Linker_instance;
  }
  var InstructionField_ENTIRE_instance;
  var InstructionField_OPCODE_instance;
  var InstructionField_RD_instance;
  var InstructionField_FUNCT3_instance;
  var InstructionField_RS1_instance;
  var InstructionField_RS2_instance;
  var InstructionField_FUNCT7_instance;
  var InstructionField_IMM_11_0_instance;
  var InstructionField_IMM_4_0_instance;
  var InstructionField_IMM_11_5_instance;
  var InstructionField_IMM_11_B_instance;
  var InstructionField_IMM_4_1_instance;
  var InstructionField_IMM_10_5_instance;
  var InstructionField_IMM_12_instance;
  var InstructionField_IMM_31_12_instance;
  var InstructionField_IMM_19_12_instance;
  var InstructionField_IMM_11_J_instance;
  var InstructionField_IMM_10_1_instance;
  var InstructionField_IMM_20_instance;
  var InstructionField_SHAMT_instance;
  var InstructionField_entriesInitialized;
  function InstructionField_initEntries() {
    if (InstructionField_entriesInitialized)
      return Unit_getInstance();
    InstructionField_entriesInitialized = true;
    InstructionField_ENTIRE_instance = new InstructionField('ENTIRE', 0, 0, 32);
    InstructionField_OPCODE_instance = new InstructionField('OPCODE', 1, 0, 7);
    InstructionField_RD_instance = new InstructionField('RD', 2, 7, 12);
    InstructionField_FUNCT3_instance = new InstructionField('FUNCT3', 3, 12, 15);
    InstructionField_RS1_instance = new InstructionField('RS1', 4, 15, 20);
    InstructionField_RS2_instance = new InstructionField('RS2', 5, 20, 25);
    InstructionField_FUNCT7_instance = new InstructionField('FUNCT7', 6, 25, 32);
    InstructionField_IMM_11_0_instance = new InstructionField('IMM_11_0', 7, 20, 32);
    InstructionField_IMM_4_0_instance = new InstructionField('IMM_4_0', 8, 7, 12);
    InstructionField_IMM_11_5_instance = new InstructionField('IMM_11_5', 9, 25, 32);
    InstructionField_IMM_11_B_instance = new InstructionField('IMM_11_B', 10, 7, 8);
    InstructionField_IMM_4_1_instance = new InstructionField('IMM_4_1', 11, 8, 12);
    InstructionField_IMM_10_5_instance = new InstructionField('IMM_10_5', 12, 25, 31);
    InstructionField_IMM_12_instance = new InstructionField('IMM_12', 13, 31, 32);
    InstructionField_IMM_31_12_instance = new InstructionField('IMM_31_12', 14, 12, 32);
    InstructionField_IMM_19_12_instance = new InstructionField('IMM_19_12', 15, 12, 20);
    InstructionField_IMM_11_J_instance = new InstructionField('IMM_11_J', 16, 20, 21);
    InstructionField_IMM_10_1_instance = new InstructionField('IMM_10_1', 17, 21, 31);
    InstructionField_IMM_20_instance = new InstructionField('IMM_20', 18, 31, 32);
    InstructionField_SHAMT_instance = new InstructionField('SHAMT', 19, 20, 25);
  }
  function InstructionField(name, ordinal, lo, hi) {
    Enum.call(this, name, ordinal);
    this._lo = lo;
    this._hi = hi;
  }
  InstructionField.$metadata$ = {
    simpleName: 'InstructionField',
    kind: 'class',
    interfaces: []
  };
  function InstructionField_ENTIRE_getInstance() {
    InstructionField_initEntries();
    return InstructionField_ENTIRE_instance;
  }
  function InstructionField_OPCODE_getInstance() {
    InstructionField_initEntries();
    return InstructionField_OPCODE_instance;
  }
  function InstructionField_RD_getInstance() {
    InstructionField_initEntries();
    return InstructionField_RD_instance;
  }
  function InstructionField_FUNCT3_getInstance() {
    InstructionField_initEntries();
    return InstructionField_FUNCT3_instance;
  }
  function InstructionField_RS1_getInstance() {
    InstructionField_initEntries();
    return InstructionField_RS1_instance;
  }
  function InstructionField_RS2_getInstance() {
    InstructionField_initEntries();
    return InstructionField_RS2_instance;
  }
  function InstructionField_FUNCT7_getInstance() {
    InstructionField_initEntries();
    return InstructionField_FUNCT7_instance;
  }
  function InstructionField_IMM_11_0_getInstance() {
    InstructionField_initEntries();
    return InstructionField_IMM_11_0_instance;
  }
  function InstructionField_IMM_4_0_getInstance() {
    InstructionField_initEntries();
    return InstructionField_IMM_4_0_instance;
  }
  function InstructionField_IMM_11_5_getInstance() {
    InstructionField_initEntries();
    return InstructionField_IMM_11_5_instance;
  }
  function InstructionField_IMM_11_B_getInstance() {
    InstructionField_initEntries();
    return InstructionField_IMM_11_B_instance;
  }
  function InstructionField_IMM_4_1_getInstance() {
    InstructionField_initEntries();
    return InstructionField_IMM_4_1_instance;
  }
  function InstructionField_IMM_10_5_getInstance() {
    InstructionField_initEntries();
    return InstructionField_IMM_10_5_instance;
  }
  function InstructionField_IMM_12_getInstance() {
    InstructionField_initEntries();
    return InstructionField_IMM_12_instance;
  }
  function InstructionField_IMM_31_12_getInstance() {
    InstructionField_initEntries();
    return InstructionField_IMM_31_12_instance;
  }
  function InstructionField_IMM_19_12_getInstance() {
    InstructionField_initEntries();
    return InstructionField_IMM_19_12_instance;
  }
  function InstructionField_IMM_11_J_getInstance() {
    InstructionField_initEntries();
    return InstructionField_IMM_11_J_instance;
  }
  function InstructionField_IMM_10_1_getInstance() {
    InstructionField_initEntries();
    return InstructionField_IMM_10_1_instance;
  }
  function InstructionField_IMM_20_getInstance() {
    InstructionField_initEntries();
    return InstructionField_IMM_20_instance;
  }
  function InstructionField_SHAMT_getInstance() {
    InstructionField_initEntries();
    return InstructionField_SHAMT_instance;
  }
  function MachineCode(encoding) {
    this._encoding = encoding;
    this._length = 4;
  }
  MachineCode.prototype.get_12 = function (ifield) {
    var mask = (new Long(1, 0)).shl_0(ifield._hi).minus_28((new Long(1, 0)).shl_0(ifield._lo)).toInt_5();
    return (this._encoding & mask) >>> ifield._lo;
  };
  MachineCode.prototype.set_0 = function (ifield, value) {
    var mask = (new Long(1, 0)).shl_0(ifield._hi).minus_28((new Long(1, 0)).shl_0(ifield._lo)).toInt_5();
    this._encoding = this._encoding & ~mask;
    this._encoding = this._encoding | value << ifield._lo & mask;
  };
  MachineCode.prototype.toString = function () {
    return this._encoding.toString();
  };
  MachineCode.$metadata$ = {
    simpleName: 'MachineCode',
    kind: 'class',
    interfaces: []
  };
  function MemorySegments() {
    MemorySegments_instance = this;
    this._STACK_BEGIN = 2147483632;
    this._HEAP_BEGIN = 268468224;
    this._STATIC_BEGIN = 268435456;
    this._TEXT_BEGIN = 0;
  }
  MemorySegments.$metadata$ = {
    simpleName: 'MemorySegments',
    kind: 'object',
    interfaces: []
  };
  var MemorySegments_instance;
  function MemorySegments_getInstance() {
    if (MemorySegments_instance == null)
      new MemorySegments();
    return MemorySegments_instance;
  }
  function Program_init_$Init$(name, $mask0, $marker, $this) {
    if (!(($mask0 & 1) === 0))
      name = 'anonymous';
    Program.call($this, name);
    return $this;
  }
  function Program_init_$Create$(name, $mask0, $marker) {
    return Program_init_$Init$(name, $mask0, $marker, Object.create(Program.prototype));
  }
  function Program(name) {
    this._name_0 = name;
    this._insts = ArrayList_init_$Create$();
    this._debugInfo = ArrayList_init_$Create$();
    this._labels = HashMap_init_$Create$();
    this._relocationTable = ArrayList_init_$Create$();
    this._dataSegment = ArrayList_init_$Create$();
    this._textSize = 0;
    this._dataSize = 0;
    this._globalLabels = HashSet_init_$Create$();
  }
  Program.prototype.add_13 = function (mcode) {
    this._insts.add_12(mcode);
    Unit_getInstance();
    var tmp0_this = this;
    tmp0_this._textSize = tmp0_this._textSize + mcode._length | 0;
  };
  Program.prototype.addToData = function (byte) {
    this._dataSegment.add_12(byte);
    Unit_getInstance();
    var tmp0_this = this;
    var tmp1 = tmp0_this._dataSize;
    tmp0_this._dataSize = tmp1 + 1 | 0;
    Unit_getInstance();
  };
  Program.prototype.addDebugInfo = function (dbg) {
    while (this._debugInfo._get_size__23() < this._insts._get_size__23()) {
      this._debugInfo.add_12(dbg);
      Unit_getInstance();
    }
  };
  Program.prototype.addLabel = function (label, offset) {
    return this._labels.put_2(label, offset);
  };
  Program.prototype.getLabelOffset = function (label) {
    var loc = this._labels.get_11(label);
    var tmp0_safe_receiver = loc;
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver - this._textSize | 0;
  };
  Program.prototype.addRelocation_0 = function (relocator, label, offset) {
    return this._relocationTable.add_12(new RelocationInfo(relocator, offset, label));
  };
  Program.prototype.addRelocation$default = function (relocator, label, offset, $mask0, $handler) {
    if (!(($mask0 & 4) === 0))
      offset = this._textSize;
    return this.addRelocation_0(relocator, label, offset);
  };
  Program.prototype.makeLabelGlobal = function (label) {
    this._globalLabels.add_12(label);
    Unit_getInstance();
  };
  Program.prototype.isGlobalLabel = function (label) {
    return this._globalLabels.contains_10(label);
  };
  Program.$metadata$ = {
    simpleName: 'Program',
    kind: 'class',
    interfaces: []
  };
  function Settings() {
    Settings_instance = this;
    this._strict = false;
  }
  Settings.$metadata$ = {
    simpleName: 'Settings',
    kind: 'object',
    interfaces: []
  };
  var Settings_instance;
  function Settings_getInstance() {
    if (Settings_instance == null)
      new Settings();
    return Settings_instance;
  }
  var add_0;
  function _no_name_provided__33() {
  }
  _no_name_provided__33.prototype.invoke_290 = function (a, b) {
    return a + b | 0;
  };
  _no_name_provided__33.prototype.invoke_293 = function (p1, p2) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    return this.invoke_290(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__33.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__34() {
  }
  _no_name_provided__34.prototype.invoke_292 = function (a, b) {
    return a.plus_27(b);
  };
  _no_name_provided__34.prototype.invoke_293 = function (p1, p2) {
    var tmp = p1 instanceof Long ? p1 : THROW_CCE();
    return this.invoke_292(tmp, p2 instanceof Long ? p2 : THROW_CCE());
  };
  _no_name_provided__34.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_27() {
    var i = new _no_name_provided__33();
    return function (p1, p2) {
      return i.invoke_290(p1, p2);
    };
  }
  function _no_name_provided_$factory_28() {
    var i = new _no_name_provided__34();
    return function (p1, p2) {
      return i.invoke_292(p1, p2);
    };
  }
  function add$init$() {
    var tmp = _no_name_provided_$factory_27();
    return new RTypeInstruction('add', 51, 0, 0, tmp, _no_name_provided_$factory_28());
  }
  var addi;
  function _no_name_provided__35() {
  }
  _no_name_provided__35.prototype.invoke_290 = function (a, b) {
    return a + b | 0;
  };
  _no_name_provided__35.prototype.invoke_293 = function (p1, p2) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    return this.invoke_290(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__35.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__36() {
  }
  _no_name_provided__36.prototype.invoke_292 = function (a, b) {
    return a.plus_27(b);
  };
  _no_name_provided__36.prototype.invoke_293 = function (p1, p2) {
    var tmp = p1 instanceof Long ? p1 : THROW_CCE();
    return this.invoke_292(tmp, p2 instanceof Long ? p2 : THROW_CCE());
  };
  _no_name_provided__36.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_29() {
    var i = new _no_name_provided__35();
    return function (p1, p2) {
      return i.invoke_290(p1, p2);
    };
  }
  function _no_name_provided_$factory_30() {
    var i = new _no_name_provided__36();
    return function (p1, p2) {
      return i.invoke_292(p1, p2);
    };
  }
  function addi$init$() {
    var tmp = _no_name_provided_$factory_29();
    return new ITypeInstruction('addi', 19, 0, tmp, _no_name_provided_$factory_30());
  }
  var and;
  function _no_name_provided__37() {
  }
  _no_name_provided__37.prototype.invoke_290 = function (a, b) {
    return a & b;
  };
  _no_name_provided__37.prototype.invoke_293 = function (p1, p2) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    return this.invoke_290(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__37.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__38() {
  }
  _no_name_provided__38.prototype.invoke_292 = function (a, b) {
    return a.and(b);
  };
  _no_name_provided__38.prototype.invoke_293 = function (p1, p2) {
    var tmp = p1 instanceof Long ? p1 : THROW_CCE();
    return this.invoke_292(tmp, p2 instanceof Long ? p2 : THROW_CCE());
  };
  _no_name_provided__38.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_31() {
    var i = new _no_name_provided__37();
    return function (p1, p2) {
      return i.invoke_290(p1, p2);
    };
  }
  function _no_name_provided_$factory_32() {
    var i = new _no_name_provided__38();
    return function (p1, p2) {
      return i.invoke_292(p1, p2);
    };
  }
  function and$init$() {
    var tmp = _no_name_provided_$factory_31();
    return new RTypeInstruction('and', 51, 7, 0, tmp, _no_name_provided_$factory_32());
  }
  var andi;
  function _no_name_provided__39() {
  }
  _no_name_provided__39.prototype.invoke_290 = function (a, b) {
    return a & b;
  };
  _no_name_provided__39.prototype.invoke_293 = function (p1, p2) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    return this.invoke_290(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__39.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__40() {
  }
  _no_name_provided__40.prototype.invoke_292 = function (a, b) {
    return a.and(b);
  };
  _no_name_provided__40.prototype.invoke_293 = function (p1, p2) {
    var tmp = p1 instanceof Long ? p1 : THROW_CCE();
    return this.invoke_292(tmp, p2 instanceof Long ? p2 : THROW_CCE());
  };
  _no_name_provided__40.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_33() {
    var i = new _no_name_provided__39();
    return function (p1, p2) {
      return i.invoke_290(p1, p2);
    };
  }
  function _no_name_provided_$factory_34() {
    var i = new _no_name_provided__40();
    return function (p1, p2) {
      return i.invoke_292(p1, p2);
    };
  }
  function andi$init$() {
    var tmp = _no_name_provided_$factory_33();
    return new ITypeInstruction('andi', 19, 7, tmp, _no_name_provided_$factory_34());
  }
  var auipc;
  function auipc$invoke(receiver, p0, p1) {
    receiver.invoke_163(p0, p1);
  }
  function _no_name_provided__41() {
  }
  _no_name_provided__41.prototype.invoke_216 = function (mcode, sim) {
    var offset = mcode.get_12(InstructionField_IMM_31_12_getInstance()) << 12;
    sim.setReg_0(mcode.get_12(InstructionField_RD_getInstance()), sim.getPC() + offset | 0);
    sim.incrementPC(mcode._length);
  };
  _no_name_provided__41.prototype.invoke_293 = function (p1, p2) {
    var tmp = p1 instanceof MachineCode ? p1 : THROW_CCE();
    this.invoke_216(tmp, p2 instanceof Simulator ? p2 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__41.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__42($boundThis) {
    this._$boundThis_1 = $boundThis;
  }
  _no_name_provided__42.prototype.invoke_216 = function (p0, p1) {
    return auipc$invoke(this._$boundThis_1, p0, p1);
  };
  _no_name_provided__42.prototype.invoke_293 = function (p1, p2) {
    var tmp = p1 instanceof MachineCode ? p1 : THROW_CCE();
    this.invoke_216(tmp, p2 instanceof Simulator ? p2 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__42.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_35() {
    var i = new _no_name_provided__41();
    return function (p1, p2) {
      i.invoke_216(p1, p2);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_36($boundThis) {
    var i = new _no_name_provided__42($boundThis);
    return function (p1, p2) {
      i.invoke_216(p1, p2);
      return Unit_getInstance();
    };
  }
  function auipc$init$() {
    var tmp = _no_name_provided_$factory_35();
    return new UTypeInstruction('auipc', 23, tmp, _no_name_provided_$factory_36(NoImplementation_getInstance()));
  }
  var beq;
  function _no_name_provided__43() {
  }
  _no_name_provided__43.prototype.invoke_290 = function (a, b) {
    return a === b;
  };
  _no_name_provided__43.prototype.invoke_293 = function (p1, p2) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    return this.invoke_290(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__43.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__44() {
  }
  _no_name_provided__44.prototype.invoke_292 = function (a, b) {
    return a.equals(b);
  };
  _no_name_provided__44.prototype.invoke_293 = function (p1, p2) {
    var tmp = p1 instanceof Long ? p1 : THROW_CCE();
    return this.invoke_292(tmp, p2 instanceof Long ? p2 : THROW_CCE());
  };
  _no_name_provided__44.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_37() {
    var i = new _no_name_provided__43();
    return function (p1, p2) {
      return i.invoke_290(p1, p2);
    };
  }
  function _no_name_provided_$factory_38() {
    var i = new _no_name_provided__44();
    return function (p1, p2) {
      return i.invoke_292(p1, p2);
    };
  }
  function beq$init$() {
    var tmp = _no_name_provided_$factory_37();
    return new BTypeInstruction('beq', 99, 0, tmp, _no_name_provided_$factory_38());
  }
  var bge;
  function _no_name_provided__45() {
  }
  _no_name_provided__45.prototype.invoke_290 = function (a, b) {
    return a >= b;
  };
  _no_name_provided__45.prototype.invoke_293 = function (p1, p2) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    return this.invoke_290(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__45.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__46() {
  }
  _no_name_provided__46.prototype.invoke_292 = function (a, b) {
    return a.compareTo_36(b) >= 0;
  };
  _no_name_provided__46.prototype.invoke_293 = function (p1, p2) {
    var tmp = p1 instanceof Long ? p1 : THROW_CCE();
    return this.invoke_292(tmp, p2 instanceof Long ? p2 : THROW_CCE());
  };
  _no_name_provided__46.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_39() {
    var i = new _no_name_provided__45();
    return function (p1, p2) {
      return i.invoke_290(p1, p2);
    };
  }
  function _no_name_provided_$factory_40() {
    var i = new _no_name_provided__46();
    return function (p1, p2) {
      return i.invoke_292(p1, p2);
    };
  }
  function bge$init$() {
    var tmp = _no_name_provided_$factory_39();
    return new BTypeInstruction('bge', 99, 5, tmp, _no_name_provided_$factory_40());
  }
  var bgeu;
  function _no_name_provided__47() {
  }
  _no_name_provided__47.prototype.invoke_290 = function (a, b) {
    return compareUnsigned(a, b) >= 0;
  };
  _no_name_provided__47.prototype.invoke_293 = function (p1, p2) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    return this.invoke_290(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__47.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__48() {
  }
  _no_name_provided__48.prototype.invoke_292 = function (a, b) {
    return compareUnsignedLong(a, b) >= 0;
  };
  _no_name_provided__48.prototype.invoke_293 = function (p1, p2) {
    var tmp = p1 instanceof Long ? p1 : THROW_CCE();
    return this.invoke_292(tmp, p2 instanceof Long ? p2 : THROW_CCE());
  };
  _no_name_provided__48.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_41() {
    var i = new _no_name_provided__47();
    return function (p1, p2) {
      return i.invoke_290(p1, p2);
    };
  }
  function _no_name_provided_$factory_42() {
    var i = new _no_name_provided__48();
    return function (p1, p2) {
      return i.invoke_292(p1, p2);
    };
  }
  function bgeu$init$() {
    var tmp = _no_name_provided_$factory_41();
    return new BTypeInstruction('bgeu', 99, 7, tmp, _no_name_provided_$factory_42());
  }
  var blt;
  function _no_name_provided__49() {
  }
  _no_name_provided__49.prototype.invoke_290 = function (a, b) {
    return a < b;
  };
  _no_name_provided__49.prototype.invoke_293 = function (p1, p2) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    return this.invoke_290(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__49.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__50() {
  }
  _no_name_provided__50.prototype.invoke_292 = function (a, b) {
    return a.compareTo_36(b) < 0;
  };
  _no_name_provided__50.prototype.invoke_293 = function (p1, p2) {
    var tmp = p1 instanceof Long ? p1 : THROW_CCE();
    return this.invoke_292(tmp, p2 instanceof Long ? p2 : THROW_CCE());
  };
  _no_name_provided__50.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_43() {
    var i = new _no_name_provided__49();
    return function (p1, p2) {
      return i.invoke_290(p1, p2);
    };
  }
  function _no_name_provided_$factory_44() {
    var i = new _no_name_provided__50();
    return function (p1, p2) {
      return i.invoke_292(p1, p2);
    };
  }
  function blt$init$() {
    var tmp = _no_name_provided_$factory_43();
    return new BTypeInstruction('blt', 99, 4, tmp, _no_name_provided_$factory_44());
  }
  var bltu;
  function _no_name_provided__51() {
  }
  _no_name_provided__51.prototype.invoke_290 = function (a, b) {
    return compareUnsigned(a, b) < 0;
  };
  _no_name_provided__51.prototype.invoke_293 = function (p1, p2) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    return this.invoke_290(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__51.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__52() {
  }
  _no_name_provided__52.prototype.invoke_292 = function (a, b) {
    return compareUnsignedLong(a, b) < 0;
  };
  _no_name_provided__52.prototype.invoke_293 = function (p1, p2) {
    var tmp = p1 instanceof Long ? p1 : THROW_CCE();
    return this.invoke_292(tmp, p2 instanceof Long ? p2 : THROW_CCE());
  };
  _no_name_provided__52.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_45() {
    var i = new _no_name_provided__51();
    return function (p1, p2) {
      return i.invoke_290(p1, p2);
    };
  }
  function _no_name_provided_$factory_46() {
    var i = new _no_name_provided__52();
    return function (p1, p2) {
      return i.invoke_292(p1, p2);
    };
  }
  function bltu$init$() {
    var tmp = _no_name_provided_$factory_45();
    return new BTypeInstruction('bltu', 99, 6, tmp, _no_name_provided_$factory_46());
  }
  var bne;
  function _no_name_provided__53() {
  }
  _no_name_provided__53.prototype.invoke_290 = function (a, b) {
    return !(a === b);
  };
  _no_name_provided__53.prototype.invoke_293 = function (p1, p2) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    return this.invoke_290(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__53.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__54() {
  }
  _no_name_provided__54.prototype.invoke_292 = function (a, b) {
    return !a.equals(b);
  };
  _no_name_provided__54.prototype.invoke_293 = function (p1, p2) {
    var tmp = p1 instanceof Long ? p1 : THROW_CCE();
    return this.invoke_292(tmp, p2 instanceof Long ? p2 : THROW_CCE());
  };
  _no_name_provided__54.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_47() {
    var i = new _no_name_provided__53();
    return function (p1, p2) {
      return i.invoke_290(p1, p2);
    };
  }
  function _no_name_provided_$factory_48() {
    var i = new _no_name_provided__54();
    return function (p1, p2) {
      return i.invoke_292(p1, p2);
    };
  }
  function bne$init$() {
    var tmp = _no_name_provided_$factory_47();
    return new BTypeInstruction('bne', 99, 1, tmp, _no_name_provided_$factory_48());
  }
  var div;
  function _no_name_provided__55() {
  }
  _no_name_provided__55.prototype.invoke_290 = function (a, b) {
    return b === 0 ? -1 : (a === IntCompanionObject_getInstance()._MIN_VALUE ? b === -1 : false) ? a : a / b | 0;
  };
  _no_name_provided__55.prototype.invoke_293 = function (p1, p2) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    return this.invoke_290(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__55.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_49() {
    var i = new _no_name_provided__55();
    return function (p1, p2) {
      return i.invoke_290(p1, p2);
    };
  }
  function div$init$() {
    var tmp = _no_name_provided_$factory_49();
    return RTypeInstruction_init_$Create$('div', 51, 4, 1, tmp, null, 32, null);
  }
  var divu;
  function _no_name_provided__56() {
  }
  _no_name_provided__56.prototype.invoke_290 = function (a, b) {
    var x = toLong_1(a).shl_0(32).ushr_0(32);
    var y = toLong_1(b).shl_0(32).ushr_0(32);
    return y.equals(new Long(0, 0)) ? a : x.div_27(y).toInt_5();
  };
  _no_name_provided__56.prototype.invoke_293 = function (p1, p2) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    return this.invoke_290(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__56.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_50() {
    var i = new _no_name_provided__56();
    return function (p1, p2) {
      return i.invoke_290(p1, p2);
    };
  }
  function divu$init$() {
    var tmp = _no_name_provided_$factory_50();
    return RTypeInstruction_init_$Create$('divu', 51, 5, 1, tmp, null, 32, null);
  }
  function BTypeInstruction(name, opcode, funct3, cond32, cond64) {
    Instruction.call(this, name, new BTypeFormat(opcode, funct3), BTypeParser_getInstance(), new BTypeImplementation32(cond32), NoImplementation_getInstance(), BTypeDisassembler_getInstance());
  }
  BTypeInstruction.$metadata$ = {
    simpleName: 'BTypeInstruction',
    kind: 'class',
    interfaces: []
  };
  function ITypeInstruction(name, opcode, funct3, eval32, eval64) {
    Instruction.call(this, name, new ITypeFormat(opcode, funct3), ITypeParser_getInstance(), new ITypeImplementation32(eval32), NoImplementation_getInstance(), ITypeDisassembler_getInstance());
  }
  ITypeInstruction.$metadata$ = {
    simpleName: 'ITypeInstruction',
    kind: 'class',
    interfaces: []
  };
  function Companion_8() {
    Companion_instance_7 = this;
    var tmp = this;
    tmp._allInstructions = ArrayList_init_$Create$();
  }
  Companion_8.prototype.get_13 = function (mcode) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_filter_0 = this._allInstructions;
      var tmp0_filterTo_0_1 = ArrayList_init_$Create$();
      var tmp0_iterator_1_2 = tmp0_filter_0.iterator_29();
      while (tmp0_iterator_1_2.hasNext_10()) {
        var element_2_3 = tmp0_iterator_1_2.next_10();
        if (element_2_3._format._length_0 === mcode._length) {
          tmp0_filterTo_0_1.add_12(element_2_3);
          Unit_getInstance();
        } else {
        }
      }
      var tmp1_firstOrNull_0 = tmp0_filterTo_0_1;
      var tmp0_iterator_1 = tmp1_firstOrNull_0.iterator_29();
      while (tmp0_iterator_1.hasNext_10()) {
        var element_2 = tmp0_iterator_1.next_10();
        if (element_2._format.matches_7(mcode)) {
          tmp$ret$0 = element_2;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = null;
    }
     while (false);
    var tmp0_elvis_lhs = tmp$ret$0;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw SimulatorError_init_$Create$('' + 'instruction not found for ' + mcode);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  Companion_8.prototype.get_14 = function (name) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_firstOrNull_0 = this._allInstructions;
      var tmp0_iterator_1 = tmp0_firstOrNull_0.iterator_29();
      while (tmp0_iterator_1.hasNext_10()) {
        var element_2 = tmp0_iterator_1.next_10();
        if (element_2._name_1 === name) {
          tmp$ret$0 = element_2;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = null;
    }
     while (false);
    var tmp0_elvis_lhs = tmp$ret$0;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw AssemblerError_init_$Create$('' + 'instruction with name ' + name + ' not found');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  Companion_8.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_7;
  function Companion_getInstance_7() {
    if (Companion_instance_7 == null)
      new Companion_8();
    return Companion_instance_7;
  }
  function Instruction(name, format, parser, impl32, impl64, disasm) {
    Companion_getInstance_7();
    this._name_1 = name;
    this._format = format;
    this._parser = parser;
    this._impl32 = impl32;
    this._impl64 = impl64;
    this._disasm = disasm;
    Companion_getInstance_7()._allInstructions.add_12(this);
    Unit_getInstance();
  }
  Instruction.prototype.toString = function () {
    return this._name_1;
  };
  Instruction.$metadata$ = {
    simpleName: 'Instruction',
    kind: 'class',
    interfaces: []
  };
  function LoadTypeInstruction_init_$Init$(name, opcode, funct3, load32, postLoad32, load64, postLoad64, $mask0, $marker, $this) {
    if (!(($mask0 & 16) === 0)) {
      postLoad32 = _no_name_provided_$factory_51();
    }if (!(($mask0 & 32) === 0)) {
      load64 = _no_name_provided_$factory_52();
    }if (!(($mask0 & 64) === 0)) {
      postLoad64 = _no_name_provided_$factory_53();
    }LoadTypeInstruction.call($this, name, opcode, funct3, load32, postLoad32, load64, postLoad64);
    return $this;
  }
  function LoadTypeInstruction_init_$Create$(name, opcode, funct3, load32, postLoad32, load64, postLoad64, $mask0, $marker) {
    return LoadTypeInstruction_init_$Init$(name, opcode, funct3, load32, postLoad32, load64, postLoad64, $mask0, $marker, Object.create(LoadTypeInstruction.prototype));
  }
  function _no_name_provided__57() {
  }
  _no_name_provided__57.prototype.invoke_212 = function (it) {
    return it;
  };
  _no_name_provided__57.prototype.invoke_213 = function (p1) {
    return this.invoke_212((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__57.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__58() {
  }
  _no_name_provided__58.prototype.invoke_138 = function (_anonymous_parameter_0_, _anonymous_parameter_1_) {
    throw new NotImplementedError('no rv64');
  };
  _no_name_provided__58.prototype.invoke_293 = function (p1, p2) {
    var tmp = p1 instanceof Simulator ? p1 : THROW_CCE();
    return this.invoke_138(tmp, p2 instanceof Long ? p2 : THROW_CCE());
  };
  _no_name_provided__58.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__59() {
  }
  _no_name_provided__59.prototype.invoke_140 = function (it) {
    return it;
  };
  _no_name_provided__59.prototype.invoke_213 = function (p1) {
    return this.invoke_140(p1 instanceof Long ? p1 : THROW_CCE());
  };
  _no_name_provided__59.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function LoadTypeInstruction(name, opcode, funct3, load32, postLoad32, load64, postLoad64) {
    Instruction.call(this, name, new ITypeFormat(opcode, funct3), LoadParser_getInstance(), new LoadImplementation32(load32, postLoad32), NoImplementation_getInstance(), LoadDisassembler_getInstance());
  }
  LoadTypeInstruction.$metadata$ = {
    simpleName: 'LoadTypeInstruction',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_51() {
    var i = new _no_name_provided__57();
    return function (p1) {
      return i.invoke_212(p1);
    };
  }
  function _no_name_provided_$factory_52() {
    var i = new _no_name_provided__58();
    return function (p1, p2) {
      return i.invoke_138(p1, p2);
    };
  }
  function _no_name_provided_$factory_53() {
    var i = new _no_name_provided__59();
    return function (p1) {
      return i.invoke_140(p1);
    };
  }
  function RTypeInstruction_init_$Init$(name, opcode, funct3, funct7, eval32, eval64, $mask0, $marker, $this) {
    if (!(($mask0 & 32) === 0)) {
      eval64 = _no_name_provided_$factory_54();
    }RTypeInstruction.call($this, name, opcode, funct3, funct7, eval32, eval64);
    return $this;
  }
  function RTypeInstruction_init_$Create$(name, opcode, funct3, funct7, eval32, eval64, $mask0, $marker) {
    return RTypeInstruction_init_$Init$(name, opcode, funct3, funct7, eval32, eval64, $mask0, $marker, Object.create(RTypeInstruction.prototype));
  }
  function _no_name_provided__60() {
  }
  _no_name_provided__60.prototype.invoke_292 = function (_anonymous_parameter_0_, _anonymous_parameter_1_) {
    throw new NotImplementedError('no rv64');
  };
  _no_name_provided__60.prototype.invoke_293 = function (p1, p2) {
    var tmp = p1 instanceof Long ? p1 : THROW_CCE();
    return this.invoke_292(tmp, p2 instanceof Long ? p2 : THROW_CCE());
  };
  _no_name_provided__60.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function RTypeInstruction(name, opcode, funct3, funct7, eval32, eval64) {
    Instruction.call(this, name, new RTypeFormat(opcode, funct3, funct7), RTypeParser_getInstance(), new RTypeImplementation32(eval32), NoImplementation_getInstance(), RTypeDisassembler_getInstance());
  }
  RTypeInstruction.$metadata$ = {
    simpleName: 'RTypeInstruction',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_54() {
    var i = new _no_name_provided__60();
    return function (p1, p2) {
      return i.invoke_292(p1, p2);
    };
  }
  function STypeInstruction_init_$Init$(name, opcode, funct3, store32, store64, $mask0, $marker, $this) {
    if (!(($mask0 & 16) === 0)) {
      store64 = _no_name_provided_$factory_55();
    }STypeInstruction.call($this, name, opcode, funct3, store32, store64);
    return $this;
  }
  function STypeInstruction_init_$Create$(name, opcode, funct3, store32, store64, $mask0, $marker) {
    return STypeInstruction_init_$Init$(name, opcode, funct3, store32, store64, $mask0, $marker, Object.create(STypeInstruction.prototype));
  }
  function _no_name_provided__61() {
  }
  _no_name_provided__61.prototype.invoke_144 = function (_anonymous_parameter_0_, _anonymous_parameter_1_, _anonymous_parameter_2_) {
    throw new NotImplementedError('no rv64');
  };
  _no_name_provided__61.prototype.invoke_285 = function (p1, p2, p3) {
    var tmp = p1 instanceof Simulator ? p1 : THROW_CCE();
    var tmp_0 = p2 instanceof Long ? p2 : THROW_CCE();
    this.invoke_144(tmp, tmp_0, p3 instanceof Long ? p3 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__61.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function STypeInstruction(name, opcode, funct3, store32, store64) {
    Instruction.call(this, name, new STypeFormat(opcode, funct3), STypeParser_getInstance(), new STypeImplementation32(store32), NoImplementation_getInstance(), STypeDisassembler_getInstance());
  }
  STypeInstruction.$metadata$ = {
    simpleName: 'STypeInstruction',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_55() {
    var i = new _no_name_provided__61();
    return function (p1, p2, p3) {
      i.invoke_144(p1, p2, p3);
      return Unit_getInstance();
    };
  }
  function ShiftImmediateInstruction_init_$Init$(name, funct3, funct7, eval32, eval64, $mask0, $marker, $this) {
    if (!(($mask0 & 16) === 0)) {
      eval64 = _no_name_provided_$factory_56();
    }ShiftImmediateInstruction.call($this, name, funct3, funct7, eval32, eval64);
    return $this;
  }
  function ShiftImmediateInstruction_init_$Create$(name, funct3, funct7, eval32, eval64, $mask0, $marker) {
    return ShiftImmediateInstruction_init_$Init$(name, funct3, funct7, eval32, eval64, $mask0, $marker, Object.create(ShiftImmediateInstruction.prototype));
  }
  function _no_name_provided__62() {
  }
  _no_name_provided__62.prototype.invoke_292 = function (_anonymous_parameter_0_, _anonymous_parameter_1_) {
    throw new NotImplementedError('no rv64');
  };
  _no_name_provided__62.prototype.invoke_293 = function (p1, p2) {
    var tmp = p1 instanceof Long ? p1 : THROW_CCE();
    return this.invoke_292(tmp, p2 instanceof Long ? p2 : THROW_CCE());
  };
  _no_name_provided__62.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function ShiftImmediateInstruction(name, funct3, funct7, eval32, eval64) {
    Instruction.call(this, name, new RTypeFormat(19, funct3, funct7), ShiftImmediateParser_getInstance(), new ShiftImmediateImplementation32(eval32), NoImplementation_getInstance(), ShiftImmediateDisassembler_getInstance());
  }
  ShiftImmediateInstruction.$metadata$ = {
    simpleName: 'ShiftImmediateInstruction',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_56() {
    var i = new _no_name_provided__62();
    return function (p1, p2) {
      return i.invoke_292(p1, p2);
    };
  }
  function UTypeInstruction_init_$Init$(name, opcode, impl32, impl64, $mask0, $marker, $this) {
    if (!(($mask0 & 8) === 0)) {
      impl64 = _no_name_provided_$factory_57();
    }UTypeInstruction.call($this, name, opcode, impl32, impl64);
    return $this;
  }
  function UTypeInstruction_init_$Create$(name, opcode, impl32, impl64, $mask0, $marker) {
    return UTypeInstruction_init_$Init$(name, opcode, impl32, impl64, $mask0, $marker, Object.create(UTypeInstruction.prototype));
  }
  function _no_name_provided__63() {
  }
  _no_name_provided__63.prototype.invoke_216 = function (_anonymous_parameter_0_, _anonymous_parameter_1_) {
    throw new NotImplementedError('no rv64');
  };
  _no_name_provided__63.prototype.invoke_293 = function (p1, p2) {
    var tmp = p1 instanceof MachineCode ? p1 : THROW_CCE();
    this.invoke_216(tmp, p2 instanceof Simulator ? p2 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__63.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function UTypeInstruction(name, opcode, impl32, impl64) {
    Instruction.call(this, name, new UTypeFormat(opcode), UTypeParser_getInstance(), new RawImplementation(impl32), new RawImplementation(impl64), UTypeDisassembler_getInstance());
  }
  UTypeInstruction.$metadata$ = {
    simpleName: 'UTypeInstruction',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_57() {
    var i = new _no_name_provided__63();
    return function (p1, p2) {
      i.invoke_216(p1, p2);
      return Unit_getInstance();
    };
  }
  function BTypeDisassembler() {
    BTypeDisassembler_instance = this;
  }
  BTypeDisassembler.prototype.invoke_202 = function (mcode) {
    var name = Companion_getInstance_7().get_13(mcode)._name_1;
    var rs1 = mcode.get_12(InstructionField_RS1_getInstance());
    var rs2 = mcode.get_12(InstructionField_RS2_getInstance());
    var imm = constructBranchImmediate(mcode);
    return '' + name + ' x' + rs1 + ' x' + rs2 + ' ' + imm;
  };
  BTypeDisassembler.$metadata$ = {
    simpleName: 'BTypeDisassembler',
    kind: 'object',
    interfaces: [InstructionDisassembler]
  };
  var BTypeDisassembler_instance;
  function BTypeDisassembler_getInstance() {
    if (BTypeDisassembler_instance == null)
      new BTypeDisassembler();
    return BTypeDisassembler_instance;
  }
  function ITypeDisassembler() {
    ITypeDisassembler_instance = this;
  }
  ITypeDisassembler.prototype.invoke_202 = function (mcode) {
    var name = Companion_getInstance_7().get_13(mcode)._name_1;
    var rd = mcode.get_12(InstructionField_RD_getInstance());
    var rs1 = mcode.get_12(InstructionField_RS1_getInstance());
    var imm = signExtend(mcode.get_12(InstructionField_IMM_11_0_getInstance()), 12);
    return '' + name + ' x' + rd + ' x' + rs1 + ' ' + imm;
  };
  ITypeDisassembler.$metadata$ = {
    simpleName: 'ITypeDisassembler',
    kind: 'object',
    interfaces: [InstructionDisassembler]
  };
  var ITypeDisassembler_instance;
  function ITypeDisassembler_getInstance() {
    if (ITypeDisassembler_instance == null)
      new ITypeDisassembler();
    return ITypeDisassembler_instance;
  }
  function InstructionDisassembler() {
  }
  InstructionDisassembler.$metadata$ = {
    simpleName: 'InstructionDisassembler',
    kind: 'interface',
    interfaces: []
  };
  function LoadDisassembler() {
    LoadDisassembler_instance = this;
  }
  LoadDisassembler.prototype.invoke_202 = function (mcode) {
    var name = Companion_getInstance_7().get_13(mcode)._name_1;
    var rs1 = mcode.get_12(InstructionField_RS1_getInstance());
    var rd = mcode.get_12(InstructionField_RD_getInstance());
    var imm = signExtend(mcode.get_12(InstructionField_IMM_11_0_getInstance()), 12);
    return '' + name + ' x' + rd + ' ' + imm + '(x' + rs1 + ')';
  };
  LoadDisassembler.$metadata$ = {
    simpleName: 'LoadDisassembler',
    kind: 'object',
    interfaces: [InstructionDisassembler]
  };
  var LoadDisassembler_instance;
  function LoadDisassembler_getInstance() {
    if (LoadDisassembler_instance == null)
      new LoadDisassembler();
    return LoadDisassembler_instance;
  }
  function RTypeDisassembler() {
    RTypeDisassembler_instance = this;
  }
  RTypeDisassembler.prototype.invoke_202 = function (mcode) {
    var name = Companion_getInstance_7().get_13(mcode)._name_1;
    var rd = mcode.get_12(InstructionField_RD_getInstance());
    var rs1 = mcode.get_12(InstructionField_RS1_getInstance());
    var rs2 = mcode.get_12(InstructionField_RS2_getInstance());
    return '' + name + ' x' + rd + ' x' + rs1 + ' x' + rs2;
  };
  RTypeDisassembler.$metadata$ = {
    simpleName: 'RTypeDisassembler',
    kind: 'object',
    interfaces: [InstructionDisassembler]
  };
  var RTypeDisassembler_instance;
  function RTypeDisassembler_getInstance() {
    if (RTypeDisassembler_instance == null)
      new RTypeDisassembler();
    return RTypeDisassembler_instance;
  }
  function RawDisassembler(disasm) {
    this._disasm_0 = disasm;
  }
  RawDisassembler.prototype.invoke_202 = function (mcode) {
    return this._disasm_0(mcode);
  };
  RawDisassembler.$metadata$ = {
    simpleName: 'RawDisassembler',
    kind: 'class',
    interfaces: [InstructionDisassembler]
  };
  function STypeDisassembler() {
    STypeDisassembler_instance = this;
  }
  STypeDisassembler.prototype.invoke_202 = function (mcode) {
    var name = Companion_getInstance_7().get_13(mcode)._name_1;
    var rs1 = mcode.get_12(InstructionField_RS1_getInstance());
    var rs2 = mcode.get_12(InstructionField_RS2_getInstance());
    var imm = constructStoreImmediate(mcode);
    return '' + name + ' x' + rs2 + ' ' + imm + '(x' + rs1 + ')';
  };
  STypeDisassembler.$metadata$ = {
    simpleName: 'STypeDisassembler',
    kind: 'object',
    interfaces: [InstructionDisassembler]
  };
  var STypeDisassembler_instance;
  function STypeDisassembler_getInstance() {
    if (STypeDisassembler_instance == null)
      new STypeDisassembler();
    return STypeDisassembler_instance;
  }
  function ShiftImmediateDisassembler() {
    ShiftImmediateDisassembler_instance = this;
  }
  ShiftImmediateDisassembler.prototype.invoke_202 = function (mcode) {
    var name = Companion_getInstance_7().get_13(mcode)._name_1;
    var rd = mcode.get_12(InstructionField_RD_getInstance());
    var rs1 = mcode.get_12(InstructionField_RS1_getInstance());
    var shamt = mcode.get_12(InstructionField_SHAMT_getInstance());
    return '' + name + ' x' + rd + ' x' + rs1 + ' ' + shamt;
  };
  ShiftImmediateDisassembler.$metadata$ = {
    simpleName: 'ShiftImmediateDisassembler',
    kind: 'object',
    interfaces: [InstructionDisassembler]
  };
  var ShiftImmediateDisassembler_instance;
  function ShiftImmediateDisassembler_getInstance() {
    if (ShiftImmediateDisassembler_instance == null)
      new ShiftImmediateDisassembler();
    return ShiftImmediateDisassembler_instance;
  }
  function UTypeDisassembler() {
    UTypeDisassembler_instance = this;
  }
  UTypeDisassembler.prototype.invoke_202 = function (mcode) {
    var name = Companion_getInstance_7().get_13(mcode)._name_1;
    var rd = mcode.get_12(InstructionField_RD_getInstance());
    var imm = mcode.get_12(InstructionField_IMM_31_12_getInstance());
    return '' + name + ' x' + rd + ' ' + imm;
  };
  UTypeDisassembler.$metadata$ = {
    simpleName: 'UTypeDisassembler',
    kind: 'object',
    interfaces: [InstructionDisassembler]
  };
  var UTypeDisassembler_instance;
  function UTypeDisassembler_getInstance() {
    if (UTypeDisassembler_instance == null)
      new UTypeDisassembler();
    return UTypeDisassembler_instance;
  }
  function BTypeFormat(opcode, funct3) {
    OpcodeFunct3Format.call(this, opcode, funct3);
  }
  BTypeFormat.$metadata$ = {
    simpleName: 'BTypeFormat',
    kind: 'class',
    interfaces: []
  };
  function ITypeFormat(opcode, funct3) {
    OpcodeFunct3Format.call(this, opcode, funct3);
  }
  ITypeFormat.$metadata$ = {
    simpleName: 'ITypeFormat',
    kind: 'class',
    interfaces: []
  };
  function FieldEqual(ifield, required) {
    this._ifield = ifield;
    this._required = required;
  }
  FieldEqual.prototype.component1_5 = function () {
    return this._ifield;
  };
  FieldEqual.prototype.component2_6 = function () {
    return this._required;
  };
  FieldEqual.prototype.toString = function () {
    return '' + 'FieldEqual(ifield=' + this._ifield + ', required=' + this._required + ')';
  };
  FieldEqual.prototype.hashCode = function () {
    var result = this._ifield.hashCode();
    result = imul(result, 31) + this._required | 0;
    return result;
  };
  FieldEqual.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FieldEqual))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof FieldEqual ? other : THROW_CCE();
    if (!this._ifield.equals(tmp0_other_with_cast._ifield))
      return false;
    if (!(this._required === tmp0_other_with_cast._required))
      return false;
    return true;
  };
  FieldEqual.$metadata$ = {
    simpleName: 'FieldEqual',
    kind: 'class',
    interfaces: []
  };
  function InstructionFormat(length, ifields) {
    this._length_0 = length;
    this._ifields = ifields;
  }
  InstructionFormat.prototype.matches_7 = function (mcode) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_all_0 = this._ifields;
      var tmp;
      if (isInterface(tmp0_all_0, Collection)) {
        tmp = tmp0_all_0.isEmpty_16();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = true;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = tmp0_all_0.iterator_29();
      while (tmp0_iterator_1.hasNext_10()) {
        var element_2 = tmp0_iterator_1.next_10();
        var ifield_4 = element_2.component1_5();
        var required_5 = element_2.component2_6();
        if (!(mcode.get_12(ifield_4) === required_5)) {
          tmp$ret$0 = false;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = true;
    }
     while (false);
    return tmp$ret$0;
  };
  InstructionFormat.prototype.fill_7 = function () {
    var mcode = new MachineCode(0);
    var tmp0_iterator = this._ifields.iterator_29();
    while (tmp0_iterator.hasNext_10()) {
      var tmp1_loop_parameter = tmp0_iterator.next_10();
      var ifield = tmp1_loop_parameter.component1_5();
      var required = tmp1_loop_parameter.component2_6();
      mcode.set_0(ifield, required);
    }
    return mcode;
  };
  InstructionFormat.$metadata$ = {
    simpleName: 'InstructionFormat',
    kind: 'class',
    interfaces: []
  };
  function OpcodeFormat(opcode) {
    InstructionFormat.call(this, 4, listOf_0(new FieldEqual(InstructionField_OPCODE_getInstance(), opcode)));
  }
  OpcodeFormat.$metadata$ = {
    simpleName: 'OpcodeFormat',
    kind: 'class',
    interfaces: []
  };
  function OpcodeFunct3Format(opcode, funct3) {
    InstructionFormat.call(this, 4, listOf([new FieldEqual(InstructionField_OPCODE_getInstance(), opcode), new FieldEqual(InstructionField_FUNCT3_getInstance(), funct3)]));
  }
  OpcodeFunct3Format.$metadata$ = {
    simpleName: 'OpcodeFunct3Format',
    kind: 'class',
    interfaces: []
  };
  function RTypeFormat(opcode, funct3, funct7) {
    InstructionFormat.call(this, 4, listOf([new FieldEqual(InstructionField_OPCODE_getInstance(), opcode), new FieldEqual(InstructionField_FUNCT3_getInstance(), funct3), new FieldEqual(InstructionField_FUNCT7_getInstance(), funct7)]));
  }
  RTypeFormat.$metadata$ = {
    simpleName: 'RTypeFormat',
    kind: 'class',
    interfaces: []
  };
  function STypeFormat(opcode, funct3) {
    OpcodeFunct3Format.call(this, opcode, funct3);
  }
  STypeFormat.$metadata$ = {
    simpleName: 'STypeFormat',
    kind: 'class',
    interfaces: []
  };
  function UTypeFormat(opcode) {
    OpcodeFormat.call(this, opcode);
  }
  UTypeFormat.$metadata$ = {
    simpleName: 'UTypeFormat',
    kind: 'class',
    interfaces: []
  };
  function BTypeImplementation32(cond) {
    this._cond = cond;
  }
  BTypeImplementation32.prototype.invoke_216 = function (mcode, sim) {
    var rs1 = mcode.get_12(InstructionField_RS1_getInstance());
    var rs2 = mcode.get_12(InstructionField_RS2_getInstance());
    var imm = constructBranchImmediate(mcode);
    var vrs1 = sim.getReg_0(rs1);
    var vrs2 = sim.getReg_0(rs2);
    if (this._cond(vrs1, vrs2))
      sim.incrementPC(imm);
    else
      sim.incrementPC(mcode._length);
  };
  BTypeImplementation32.$metadata$ = {
    simpleName: 'BTypeImplementation32',
    kind: 'class',
    interfaces: [InstructionImplementation]
  };
  function constructBranchImmediate(mcode) {
    var imm_11 = mcode.get_12(InstructionField_IMM_11_B_getInstance());
    var imm_4_1 = mcode.get_12(InstructionField_IMM_4_1_getInstance());
    var imm_10_5 = mcode.get_12(InstructionField_IMM_10_5_getInstance());
    var imm_12 = mcode.get_12(InstructionField_IMM_12_getInstance());
    var imm = 0;
    imm = setBitslice(imm, imm_11, 11, 12);
    imm = setBitslice(imm, imm_4_1, 1, 5);
    imm = setBitslice(imm, imm_10_5, 5, 11);
    imm = setBitslice(imm, imm_12, 12, 13);
    return signExtend(imm, 13);
  }
  function ITypeImplementation32(eval_0) {
    this._eval = eval_0;
  }
  ITypeImplementation32.prototype.invoke_216 = function (mcode, sim) {
    var rs1 = mcode.get_12(InstructionField_RS1_getInstance());
    var imm = signExtend(mcode.get_12(InstructionField_IMM_11_0_getInstance()), 12);
    var rd = mcode.get_12(InstructionField_RD_getInstance());
    var vrs1 = sim.getReg_0(rs1);
    sim.setReg_0(rd, this._eval(vrs1, imm));
    sim.incrementPC(mcode._length);
  };
  ITypeImplementation32.$metadata$ = {
    simpleName: 'ITypeImplementation32',
    kind: 'class',
    interfaces: [InstructionImplementation]
  };
  function InstructionImplementation() {
  }
  InstructionImplementation.$metadata$ = {
    simpleName: 'InstructionImplementation',
    kind: 'interface',
    interfaces: []
  };
  function LoadImplementation32(load, postLoad) {
    this._load = load;
    this._postLoad = postLoad;
  }
  LoadImplementation32.prototype.invoke_216 = function (mcode, sim) {
    var rs1 = mcode.get_12(InstructionField_RS1_getInstance());
    var rd = mcode.get_12(InstructionField_RD_getInstance());
    var vrs1 = sim.getReg_0(rs1);
    var imm = signExtend(mcode.get_12(InstructionField_IMM_11_0_getInstance()), 12);
    sim.setReg_0(rd, this._postLoad(this._load(sim, vrs1 + imm | 0)));
    sim.incrementPC(mcode._length);
  };
  LoadImplementation32.$metadata$ = {
    simpleName: 'LoadImplementation32',
    kind: 'class',
    interfaces: [InstructionImplementation]
  };
  function NoImplementation() {
    NoImplementation_instance = this;
  }
  NoImplementation.prototype.invoke_163 = function (mcode, sim) {
    throw new NotImplementedError('no implementation available');
  };
  NoImplementation.prototype.invoke_216 = function (mcode, sim) {
    return this.invoke_163(mcode, sim);
  };
  NoImplementation.$metadata$ = {
    simpleName: 'NoImplementation',
    kind: 'object',
    interfaces: [InstructionImplementation]
  };
  var NoImplementation_instance;
  function NoImplementation_getInstance() {
    if (NoImplementation_instance == null)
      new NoImplementation();
    return NoImplementation_instance;
  }
  function RTypeImplementation32(eval_0) {
    this._eval_0 = eval_0;
  }
  RTypeImplementation32.prototype.invoke_216 = function (mcode, sim) {
    var rs1 = mcode.get_12(InstructionField_RS1_getInstance());
    var rs2 = mcode.get_12(InstructionField_RS2_getInstance());
    var rd = mcode.get_12(InstructionField_RD_getInstance());
    var vrs1 = sim.getReg_0(rs1);
    var vrs2 = sim.getReg_0(rs2);
    sim.setReg_0(rd, this._eval_0(vrs1, vrs2));
    sim.incrementPC(mcode._length);
  };
  RTypeImplementation32.$metadata$ = {
    simpleName: 'RTypeImplementation32',
    kind: 'class',
    interfaces: [InstructionImplementation]
  };
  function RawImplementation(eval_0) {
    this._eval_1 = eval_0;
  }
  RawImplementation.prototype.invoke_216 = function (mcode, sim) {
    return this._eval_1(mcode, sim);
  };
  RawImplementation.$metadata$ = {
    simpleName: 'RawImplementation',
    kind: 'class',
    interfaces: [InstructionImplementation]
  };
  function STypeImplementation32(store) {
    this._store = store;
  }
  STypeImplementation32.prototype.invoke_216 = function (mcode, sim) {
    var rs1 = mcode.get_12(InstructionField_RS1_getInstance());
    var rs2 = mcode.get_12(InstructionField_RS2_getInstance());
    var imm = constructStoreImmediate(mcode);
    var vrs1 = sim.getReg_0(rs1);
    var vrs2 = sim.getReg_0(rs2);
    this._store(sim, vrs1 + imm | 0, vrs2);
    sim.incrementPC(mcode._length);
  };
  STypeImplementation32.$metadata$ = {
    simpleName: 'STypeImplementation32',
    kind: 'class',
    interfaces: [InstructionImplementation]
  };
  function constructStoreImmediate(mcode) {
    var imm_11_5 = mcode.get_12(InstructionField_IMM_11_5_getInstance());
    var imm_4_0 = mcode.get_12(InstructionField_IMM_4_0_getInstance());
    var imm = 0;
    imm = setBitslice(imm, imm_11_5, 5, 12);
    imm = setBitslice(imm, imm_4_0, 0, 5);
    return signExtend(imm, 12);
  }
  function ShiftImmediateImplementation32(eval_0) {
    this._eval_2 = eval_0;
  }
  ShiftImmediateImplementation32.prototype.invoke_216 = function (mcode, sim) {
    var rs1 = mcode.get_12(InstructionField_RS1_getInstance());
    var shamt = mcode.get_12(InstructionField_SHAMT_getInstance());
    var rd = mcode.get_12(InstructionField_RD_getInstance());
    var vrs1 = sim.getReg_0(rs1);
    sim.setReg_0(rd, this._eval_2(vrs1, shamt));
    sim.incrementPC(mcode._length);
  };
  ShiftImmediateImplementation32.$metadata$ = {
    simpleName: 'ShiftImmediateImplementation32',
    kind: 'class',
    interfaces: [InstructionImplementation]
  };
  function signExtend(v, sz) {
    return v << (32 - sz | 0) >> (32 - sz | 0);
  }
  function setBitslice(x, y, start, end) {
    var mask = (new Long(1, 0)).shl_0(end).minus_28((new Long(1, 0)).shl_0(start)).inv_0().toInt_5();
    return mask & x | y << start;
  }
  function BTypeParser() {
    BTypeParser_instance = this;
    this._B_TYPE_MIN = -2048;
    this._B_TYPE_MAX = 2047;
  }
  BTypeParser.prototype.invoke_198 = function (prog, mcode, args) {
    checkArgsLength_0(args._get_size__23(), 3);
    mcode.set_0(InstructionField_RS1_getInstance(), regNameToNumber(args.get_24(0)));
    mcode.set_0(InstructionField_RS2_getInstance(), regNameToNumber(args.get_24(1)));
    var label = args.get_24(2);
    var tmp0_elvis_lhs = prog.getLabelOffset(label);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw AssemblerError_init_$Create$('' + 'could not find label ' + label);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var imm = tmp;
    var containsLower = -2048;
    if (!(imm <= 2047 ? containsLower <= imm : false))
      throw AssemblerError_init_$Create$('' + 'branch to ' + label + ' too far');
    else {
    }
    mcode.set_0(InstructionField_IMM_11_B_getInstance(), imm >> 11);
    mcode.set_0(InstructionField_IMM_4_1_getInstance(), imm >> 1);
    mcode.set_0(InstructionField_IMM_12_getInstance(), imm >> 12);
    mcode.set_0(InstructionField_IMM_10_5_getInstance(), imm >> 5);
  };
  BTypeParser.$metadata$ = {
    simpleName: 'BTypeParser',
    kind: 'object',
    interfaces: [InstructionParser]
  };
  var BTypeParser_instance;
  function BTypeParser_getInstance() {
    if (BTypeParser_instance == null)
      new BTypeParser();
    return BTypeParser_instance;
  }
  function DoNothingParser() {
    DoNothingParser_instance = this;
    this._B_TYPE_MIN_0 = -2048;
    this._B_TYPE_MAX_0 = 2047;
  }
  DoNothingParser.prototype.invoke_198 = function (prog, mcode, args) {
    checkArgsLength_0(args._get_size__23(), 0);
  };
  DoNothingParser.$metadata$ = {
    simpleName: 'DoNothingParser',
    kind: 'object',
    interfaces: [InstructionParser]
  };
  var DoNothingParser_instance;
  function DoNothingParser_getInstance() {
    if (DoNothingParser_instance == null)
      new DoNothingParser();
    return DoNothingParser_instance;
  }
  function ITypeParser() {
    ITypeParser_instance = this;
    this._I_TYPE_MIN = -2048;
    this._I_TYPE_MAX = 2047;
  }
  ITypeParser.prototype.invoke_198 = function (prog, mcode, args) {
    checkArgsLength_0(args._get_size__23(), 3);
    mcode.set_0(InstructionField_RD_getInstance(), regNameToNumber(args.get_24(0)));
    mcode.set_0(InstructionField_RS1_getInstance(), regNameToNumber(args.get_24(1)));
    mcode.set_0(InstructionField_IMM_11_0_getInstance(), getImmediate(args.get_24(2), -2048, 2047));
  };
  ITypeParser.$metadata$ = {
    simpleName: 'ITypeParser',
    kind: 'object',
    interfaces: [InstructionParser]
  };
  var ITypeParser_instance;
  function ITypeParser_getInstance() {
    if (ITypeParser_instance == null)
      new ITypeParser();
    return ITypeParser_instance;
  }
  function InstructionParser() {
  }
  InstructionParser.$metadata$ = {
    simpleName: 'InstructionParser',
    kind: 'interface',
    interfaces: []
  };
  function LoadParser() {
    LoadParser_instance = this;
    this._I_TYPE_MIN_0 = -2048;
    this._I_TYPE_MAX_0 = 2047;
  }
  LoadParser.prototype.invoke_198 = function (prog, mcode, args) {
    checkArgsLength_0(args._get_size__23(), 3);
    mcode.set_0(InstructionField_RD_getInstance(), regNameToNumber(args.get_24(0)));
    mcode.set_0(InstructionField_RS1_getInstance(), regNameToNumber(args.get_24(2)));
    mcode.set_0(InstructionField_IMM_11_0_getInstance(), getImmediate(args.get_24(1), -2048, 2047));
  };
  LoadParser.$metadata$ = {
    simpleName: 'LoadParser',
    kind: 'object',
    interfaces: [InstructionParser]
  };
  var LoadParser_instance;
  function LoadParser_getInstance() {
    if (LoadParser_instance == null)
      new LoadParser();
    return LoadParser_instance;
  }
  function RTypeParser() {
    RTypeParser_instance = this;
  }
  RTypeParser.prototype.invoke_198 = function (prog, mcode, args) {
    checkArgsLength_0(args._get_size__23(), 3);
    mcode.set_0(InstructionField_RD_getInstance(), regNameToNumber(args.get_24(0)));
    mcode.set_0(InstructionField_RS1_getInstance(), regNameToNumber(args.get_24(1)));
    mcode.set_0(InstructionField_RS2_getInstance(), regNameToNumber(args.get_24(2)));
  };
  RTypeParser.$metadata$ = {
    simpleName: 'RTypeParser',
    kind: 'object',
    interfaces: [InstructionParser]
  };
  var RTypeParser_instance;
  function RTypeParser_getInstance() {
    if (RTypeParser_instance == null)
      new RTypeParser();
    return RTypeParser_instance;
  }
  function RawParser(eval_0) {
    this._eval_3 = eval_0;
  }
  RawParser.prototype.invoke_198 = function (prog, mcode, args) {
    return this._eval_3(prog, mcode, args);
  };
  RawParser.$metadata$ = {
    simpleName: 'RawParser',
    kind: 'class',
    interfaces: [InstructionParser]
  };
  function STypeParser() {
    STypeParser_instance = this;
    this._S_TYPE_MIN = -2048;
    this._S_TYPE_MAX = 2047;
  }
  STypeParser.prototype.invoke_198 = function (prog, mcode, args) {
    checkArgsLength_0(args._get_size__23(), 3);
    var imm = getImmediate(args.get_24(1), -2048, 2047);
    mcode.set_0(InstructionField_RS1_getInstance(), regNameToNumber(args.get_24(2)));
    mcode.set_0(InstructionField_RS2_getInstance(), regNameToNumber(args.get_24(0)));
    mcode.set_0(InstructionField_IMM_4_0_getInstance(), imm);
    mcode.set_0(InstructionField_IMM_11_5_getInstance(), imm >> 5);
  };
  STypeParser.$metadata$ = {
    simpleName: 'STypeParser',
    kind: 'object',
    interfaces: [InstructionParser]
  };
  var STypeParser_instance;
  function STypeParser_getInstance() {
    if (STypeParser_instance == null)
      new STypeParser();
    return STypeParser_instance;
  }
  function ShiftImmediateParser() {
    ShiftImmediateParser_instance = this;
    this._SHIFT_MIN = 0;
    this._SHIFT_MAX = 31;
  }
  ShiftImmediateParser.prototype.invoke_198 = function (prog, mcode, args) {
    checkArgsLength_0(args._get_size__23(), 3);
    mcode.set_0(InstructionField_RD_getInstance(), regNameToNumber(args.get_24(0)));
    mcode.set_0(InstructionField_RS1_getInstance(), regNameToNumber(args.get_24(1)));
    mcode.set_0(InstructionField_SHAMT_getInstance(), getImmediate(args.get_24(2), 0, 31));
  };
  ShiftImmediateParser.$metadata$ = {
    simpleName: 'ShiftImmediateParser',
    kind: 'object',
    interfaces: [InstructionParser]
  };
  var ShiftImmediateParser_instance;
  function ShiftImmediateParser_getInstance() {
    if (ShiftImmediateParser_instance == null)
      new ShiftImmediateParser();
    return ShiftImmediateParser_instance;
  }
  function UTypeParser() {
    UTypeParser_instance = this;
    this._U_TYPE_MIN = 0;
    this._U_TYPE_MAX = 1048575;
  }
  UTypeParser.prototype.invoke_198 = function (prog, mcode, args) {
    checkArgsLength_0(args._get_size__23(), 2);
    mcode.set_0(InstructionField_RD_getInstance(), regNameToNumber(args.get_24(0)));
    mcode.set_0(InstructionField_IMM_31_12_getInstance(), getImmediate(args.get_24(1), 0, 1048575));
  };
  UTypeParser.$metadata$ = {
    simpleName: 'UTypeParser',
    kind: 'object',
    interfaces: [InstructionParser]
  };
  var UTypeParser_instance;
  function UTypeParser_getInstance() {
    if (UTypeParser_instance == null)
      new UTypeParser();
    return UTypeParser_instance;
  }
  function checkArgsLength_0(argsSize, required) {
    if (!(argsSize === required))
      throw AssemblerError_init_$Create$('' + 'got ' + argsSize + ' arguments but expected ' + required);
  }
  function regNameToNumber(reg) {
    if (startsWith$default_0(reg, 'x', false, 2, null)) {
      var ret = toInt(drop_0(reg, 1));
      if (0 <= ret ? ret <= 31 : false)
        return ret;
      throw AssemblerError_init_$Create$('' + 'register ' + reg + ' not recognized');
    } else {
    }
    var tmp0_subject = reg;
    var tmp;
    switch (tmp0_subject) {
      case 'zero':
        tmp = 0;
        break;
      case 'ra':
        tmp = 1;
        break;
      case 'sp':
        tmp = 2;
        break;
      case 'gp':
        tmp = 3;
        break;
      case 'tp':
        tmp = 4;
        break;
      case 't0':
        tmp = 5;
        break;
      case 't1':
        tmp = 6;
        break;
      case 't2':
        tmp = 7;
        break;
      case 's0':
      case 'fp':
        tmp = 8;
        break;
      case 's1':
        tmp = 9;
        break;
      case 'a0':
        tmp = 10;
        break;
      case 'a1':
        tmp = 11;
        break;
      case 'a2':
        tmp = 12;
        break;
      case 'a3':
        tmp = 13;
        break;
      case 'a4':
        tmp = 14;
        break;
      case 'a5':
        tmp = 15;
        break;
      case 'a6':
        tmp = 16;
        break;
      case 'a7':
        tmp = 17;
        break;
      case 's2':
        tmp = 18;
        break;
      case 's3':
        tmp = 19;
        break;
      case 's4':
        tmp = 20;
        break;
      case 's5':
        tmp = 21;
        break;
      case 's6':
        tmp = 22;
        break;
      case 's7':
        tmp = 23;
        break;
      case 's8':
        tmp = 24;
        break;
      case 's9':
        tmp = 25;
        break;
      case 's10':
        tmp = 26;
        break;
      case 's11':
        tmp = 27;
        break;
      case 't3':
        tmp = 28;
        break;
      case 't4':
        tmp = 29;
        break;
      case 't5':
        tmp = 30;
        break;
      case 't6':
        tmp = 31;
        break;
      default:throw AssemblerError_init_$Create$('' + 'register ' + reg + ' not recognized');
    }
    return tmp;
  }
  var JALRelocator;
  function JALRelocator32() {
    JALRelocator32_instance = this;
  }
  JALRelocator32.prototype.invoke_185 = function (mcode, pc, target) {
    var imm = target - pc | 0;
    mcode.set_0(InstructionField_IMM_20_getInstance(), imm >> 20);
    mcode.set_0(InstructionField_IMM_10_1_getInstance(), imm >> 1);
    mcode.set_0(InstructionField_IMM_19_12_getInstance(), imm >> 12);
    mcode.set_0(InstructionField_IMM_11_J_getInstance(), imm >> 11);
  };
  JALRelocator32.$metadata$ = {
    simpleName: 'JALRelocator32',
    kind: 'object',
    interfaces: [Relocator32]
  };
  var JALRelocator32_instance;
  function JALRelocator32_getInstance() {
    if (JALRelocator32_instance == null)
      new JALRelocator32();
    return JALRelocator32_instance;
  }
  function NoRelocator64() {
    NoRelocator64_instance = this;
  }
  NoRelocator64.prototype.invoke_180 = function (mcode, pc, target) {
    throw new NotImplementedError('' + 'no relocator64 for ' + mcode);
  };
  NoRelocator64.prototype.invoke_186 = function (mcode, pc, target) {
    return this.invoke_180(mcode, pc, target);
  };
  NoRelocator64.$metadata$ = {
    simpleName: 'NoRelocator64',
    kind: 'object',
    interfaces: [Relocator64]
  };
  var NoRelocator64_instance;
  function NoRelocator64_getInstance() {
    if (NoRelocator64_instance == null)
      new NoRelocator64();
    return NoRelocator64_instance;
  }
  var PCRelHiRelocator;
  function PCRelHiRelocator32() {
    PCRelHiRelocator32_instance = this;
  }
  PCRelHiRelocator32.prototype.invoke_185 = function (mcode, pc, target) {
    mcode.set_0(InstructionField_IMM_31_12_getInstance(), ((target - pc | 0) + 2048 | 0) >> 12);
  };
  PCRelHiRelocator32.$metadata$ = {
    simpleName: 'PCRelHiRelocator32',
    kind: 'object',
    interfaces: [Relocator32]
  };
  var PCRelHiRelocator32_instance;
  function PCRelHiRelocator32_getInstance() {
    if (PCRelHiRelocator32_instance == null)
      new PCRelHiRelocator32();
    return PCRelHiRelocator32_instance;
  }
  var PCRelLoRelocator;
  function PCRelLoRelocator32() {
    PCRelLoRelocator32_instance = this;
  }
  PCRelLoRelocator32.prototype.invoke_185 = function (mcode, pc, target) {
    mcode.set_0(InstructionField_IMM_11_0_getInstance(), target - (pc - 4 | 0) | 0);
  };
  PCRelLoRelocator32.$metadata$ = {
    simpleName: 'PCRelLoRelocator32',
    kind: 'object',
    interfaces: [Relocator32]
  };
  var PCRelLoRelocator32_instance;
  function PCRelLoRelocator32_getInstance() {
    if (PCRelLoRelocator32_instance == null)
      new PCRelLoRelocator32();
    return PCRelLoRelocator32_instance;
  }
  var PCRelLoStoreRelocator;
  function PCRelLoStoreRelocator32() {
    PCRelLoStoreRelocator32_instance = this;
  }
  PCRelLoStoreRelocator32.prototype.invoke_185 = function (mcode, pc, target) {
    var offset = target - (pc - 4 | 0) | 0;
    mcode.set_0(InstructionField_IMM_4_0_getInstance(), offset);
    mcode.set_0(InstructionField_IMM_11_5_getInstance(), offset >> 5);
  };
  PCRelLoStoreRelocator32.$metadata$ = {
    simpleName: 'PCRelLoStoreRelocator32',
    kind: 'object',
    interfaces: [Relocator32]
  };
  var PCRelLoStoreRelocator32_instance;
  function PCRelLoStoreRelocator32_getInstance() {
    if (PCRelLoStoreRelocator32_instance == null)
      new PCRelLoStoreRelocator32();
    return PCRelLoStoreRelocator32_instance;
  }
  function Relocator32() {
  }
  Relocator32.$metadata$ = {
    simpleName: 'Relocator32',
    kind: 'interface',
    interfaces: []
  };
  function Relocator64() {
  }
  Relocator64.$metadata$ = {
    simpleName: 'Relocator64',
    kind: 'interface',
    interfaces: []
  };
  function Relocator(relocator32, relocator64) {
    this._relocator32 = relocator32;
    this._relocator64 = relocator64;
  }
  Relocator.prototype.invoke_187 = function (mcode, pc, target, is64) {
    if (is64)
      this._relocator64.invoke_186(mcode, numberToLong(pc), numberToLong(target));
    else
      this._relocator32.invoke_185(mcode, numberToInt(pc), numberToInt(target));
  };
  Relocator.prototype.invoke$default = function (mcode, pc, target, is64, $mask0, $handler) {
    if (!(($mask0 & 8) === 0))
      is64 = false;
    return this.invoke_187(mcode, pc, target, is64);
  };
  Relocator.$metadata$ = {
    simpleName: 'Relocator',
    kind: 'class',
    interfaces: []
  };
  function getImmediate(str, min, max) {
    var tmp;
    try {
      tmp = userStringToInt(str);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof NumberFormatException) {
        var hint = str.length > 4 ? ' (might be too large)' : '';
        throw AssemblerError_init_$Create$('' + 'invalid number, got ' + str + hint);
      } else {
        {
          throw $p;
        }
      }
      tmp = tmp_0;
    }
    var imm = tmp;
    if (!(min <= imm ? imm <= max : false))
      throw AssemblerError_init_$Create$('' + 'immediate ' + str + ' (= ' + imm + ') out of range (should be between ' + min + ' and ' + max + ')');
    return imm;
  }
  function compareUnsigned(v1, v2) {
    return compareTo(v1 ^ IntCompanionObject_getInstance()._MIN_VALUE, v2 ^ IntCompanionObject_getInstance()._MIN_VALUE);
  }
  function compareUnsignedLong(v1, v2) {
    Companion_getInstance_6();
    var tmp = v1.xor(new Long(0, -2147483648));
    Companion_getInstance_6();
    return tmp.compareTo_36(v2.xor(new Long(0, -2147483648)));
  }
  var ecall;
  function printInteger(sim) {
    var arg = sim.getReg_0(11);
    Renderer_getInstance().printConsole(arg);
  }
  function printString(sim) {
    var arg = sim.getReg_0(11);
    var c = sim.loadByte_0(arg);
    var tmp0 = arg;
    arg = tmp0 + 1 | 0;
    Unit_getInstance();
    while (!(c === 0)) {
      Renderer_getInstance().printConsole(numberToChar(c));
      c = sim.loadByte_0(arg);
      var tmp1 = arg;
      arg = tmp1 + 1 | 0;
      Unit_getInstance();
    }
  }
  function sbrk(sim) {
    var bytes = sim.getReg_0(11);
    if (bytes < 0)
      return Unit_getInstance();
    sim.setReg_0(10, sim.getHeapEnd());
    sim.addHeapSpace(bytes);
  }
  function exit(sim) {
    MemorySegments_getInstance();
    sim.setPC(268435456);
  }
  function printChar(sim) {
    var arg = sim.getReg_0(11);
    Renderer_getInstance().printConsole(numberToChar(arg));
  }
  function exitWithCode(sim) {
    MemorySegments_getInstance();
    sim.setPC(268435456);
    var retVal = sim.getReg_0(11);
    Renderer_getInstance().printConsole('' + 'Exited with error code ' + retVal + '\n');
  }
  function _no_name_provided__64() {
  }
  _no_name_provided__64.prototype.invoke_216 = function (mcode, sim) {
    var whichCall = sim.getReg_0(10);
    var tmp0_subject = whichCall;
    switch (tmp0_subject) {
      case 1:
        printInteger(sim);
        break;
      case 4:
        printString(sim);
        break;
      case 9:
        sbrk(sim);
        break;
      case 10:
        exit(sim);
        break;
      case 11:
        printChar(sim);
        break;
      case 17:
        exitWithCode(sim);
        break;
      default:Renderer_getInstance().printConsole('' + 'Invalid ecall ' + whichCall);
        break;
    }
    sim.incrementPC(mcode._length);
  };
  _no_name_provided__64.prototype.invoke_293 = function (p1, p2) {
    var tmp = p1 instanceof MachineCode ? p1 : THROW_CCE();
    this.invoke_216(tmp, p2 instanceof Simulator ? p2 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__64.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__65() {
  }
  _no_name_provided__65.prototype.invoke_202 = function (it) {
    return 'ecall';
  };
  _no_name_provided__65.prototype.invoke_213 = function (p1) {
    return this.invoke_202(p1 instanceof MachineCode ? p1 : THROW_CCE());
  };
  _no_name_provided__65.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_58() {
    var i = new _no_name_provided__64();
    return function (p1, p2) {
      i.invoke_216(p1, p2);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_59() {
    var i = new _no_name_provided__65();
    return function (p1) {
      return i.invoke_202(p1);
    };
  }
  function ecall$init$() {
    var tmp = new InstructionFormat(4, listOf_0(new FieldEqual(InstructionField_ENTIRE_getInstance(), 115)));
    var tmp_0 = DoNothingParser_getInstance();
    var tmp_1 = new RawImplementation(_no_name_provided_$factory_58());
    var tmp_2 = NoImplementation_getInstance();
    return new Instruction('ecall', tmp, tmp_0, tmp_1, tmp_2, new RawDisassembler(_no_name_provided_$factory_59()));
  }
  var jal;
  function constructJALImmediate(mcode) {
    var imm_20 = mcode.get_12(InstructionField_IMM_20_getInstance());
    var imm_10_1 = mcode.get_12(InstructionField_IMM_10_1_getInstance());
    var imm_11 = mcode.get_12(InstructionField_IMM_11_J_getInstance());
    var imm_19_12 = mcode.get_12(InstructionField_IMM_19_12_getInstance());
    var imm = 0;
    imm = setBitslice(imm, imm_20, 20, 21);
    imm = setBitslice(imm, imm_10_1, 1, 11);
    imm = setBitslice(imm, imm_11, 11, 12);
    imm = setBitslice(imm, imm_19_12, 12, 20);
    return signExtend(imm, 21);
  }
  function _no_name_provided__66() {
  }
  _no_name_provided__66.prototype.invoke_198 = function (prog, mcode, args) {
    checkArgsLength_0(args._get_size__23(), 2);
    mcode.set_0(InstructionField_RD_getInstance(), regNameToNumber(args.get_24(0)));
    var tmp = args.get_24(1);
    prog.addRelocation$default(JALRelocator, tmp, 0, 4, null);
    Unit_getInstance();
  };
  _no_name_provided__66.prototype.invoke_285 = function (p1, p2, p3) {
    var tmp = p1 instanceof Program ? p1 : THROW_CCE();
    var tmp_0 = p2 instanceof MachineCode ? p2 : THROW_CCE();
    this.invoke_198(tmp, tmp_0, (!(p3 == null) ? isInterface(p3, List) : false) ? p3 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__66.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__67() {
  }
  _no_name_provided__67.prototype.invoke_216 = function (mcode, sim) {
    var rd = mcode.get_12(InstructionField_RD_getInstance());
    var imm = constructJALImmediate(mcode);
    sim.setReg_0(rd, sim.getPC() + mcode._length | 0);
    sim.incrementPC(imm);
  };
  _no_name_provided__67.prototype.invoke_293 = function (p1, p2) {
    var tmp = p1 instanceof MachineCode ? p1 : THROW_CCE();
    this.invoke_216(tmp, p2 instanceof Simulator ? p2 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__67.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__68() {
  }
  _no_name_provided__68.prototype.invoke_202 = function (mcode) {
    var rd = mcode.get_12(InstructionField_RD_getInstance());
    var imm = constructJALImmediate(mcode);
    return '' + 'jal x' + rd + ' ' + imm;
  };
  _no_name_provided__68.prototype.invoke_213 = function (p1) {
    return this.invoke_202(p1 instanceof MachineCode ? p1 : THROW_CCE());
  };
  _no_name_provided__68.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_60() {
    var i = new _no_name_provided__66();
    return function (p1, p2, p3) {
      i.invoke_198(p1, p2, p3);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_61() {
    var i = new _no_name_provided__67();
    return function (p1, p2) {
      i.invoke_216(p1, p2);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_62() {
    var i = new _no_name_provided__68();
    return function (p1) {
      return i.invoke_202(p1);
    };
  }
  function jal$init$() {
    var tmp = new OpcodeFormat(111);
    var tmp_0 = new RawParser(_no_name_provided_$factory_60());
    var tmp_1 = new RawImplementation(_no_name_provided_$factory_61());
    var tmp_2 = NoImplementation_getInstance();
    return new Instruction('jal', tmp, tmp_0, tmp_1, tmp_2, new RawDisassembler(_no_name_provided_$factory_62()));
  }
  var jalr;
  function _no_name_provided__69() {
  }
  _no_name_provided__69.prototype.invoke_198 = function (prog, mcode, args) {
    try {
      ITypeParser_getInstance().invoke_198(prog, mcode, args);
    } catch ($p) {
      if ($p instanceof AssemblerError) {
        try {
          LoadParser_getInstance().invoke_198(prog, mcode, args);
        } catch ($p_0) {
          if ($p_0 instanceof AssemblerError) {
            throw $p;
          } else {
            {
              throw $p_0;
            }
          }
        }
      } else {
        {
          throw $p;
        }
      }
    }
  };
  _no_name_provided__69.prototype.invoke_285 = function (p1, p2, p3) {
    var tmp = p1 instanceof Program ? p1 : THROW_CCE();
    var tmp_0 = p2 instanceof MachineCode ? p2 : THROW_CCE();
    this.invoke_198(tmp, tmp_0, (!(p3 == null) ? isInterface(p3, List) : false) ? p3 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__69.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__70() {
  }
  _no_name_provided__70.prototype.invoke_216 = function (mcode, sim) {
    var rd = mcode.get_12(InstructionField_RD_getInstance());
    var rs1 = mcode.get_12(InstructionField_RS1_getInstance());
    var imm = signExtend(mcode.get_12(InstructionField_IMM_11_0_getInstance()), 12);
    var vrs1 = sim.getReg_0(rs1);
    sim.setReg_0(rd, sim.getPC() + mcode._length | 0);
    sim.setPC((vrs1 + imm | 0) >> 1 << 1);
  };
  _no_name_provided__70.prototype.invoke_293 = function (p1, p2) {
    var tmp = p1 instanceof MachineCode ? p1 : THROW_CCE();
    this.invoke_216(tmp, p2 instanceof Simulator ? p2 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__70.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__71() {
  }
  _no_name_provided__71.prototype.invoke_202 = function (mcode) {
    var rd = mcode.get_12(InstructionField_RD_getInstance());
    var rs1 = mcode.get_12(InstructionField_RS1_getInstance());
    var imm = signExtend(mcode.get_12(InstructionField_IMM_11_0_getInstance()), 12);
    return '' + 'jalr x' + rd + ' x' + rs1 + ' ' + imm;
  };
  _no_name_provided__71.prototype.invoke_213 = function (p1) {
    return this.invoke_202(p1 instanceof MachineCode ? p1 : THROW_CCE());
  };
  _no_name_provided__71.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_63() {
    var i = new _no_name_provided__69();
    return function (p1, p2, p3) {
      i.invoke_198(p1, p2, p3);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_64() {
    var i = new _no_name_provided__70();
    return function (p1, p2) {
      i.invoke_216(p1, p2);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_65() {
    var i = new _no_name_provided__71();
    return function (p1) {
      return i.invoke_202(p1);
    };
  }
  function jalr$init$() {
    var tmp = new ITypeFormat(103, 0);
    var tmp_0 = new RawParser(_no_name_provided_$factory_63());
    var tmp_1 = new RawImplementation(_no_name_provided_$factory_64());
    var tmp_2 = NoImplementation_getInstance();
    return new Instruction('jalr', tmp, tmp_0, tmp_1, tmp_2, new RawDisassembler(_no_name_provided_$factory_65()));
  }
  var lb;
  function _no_name_provided__72() {
  }
  _no_name_provided__72.prototype.invoke_218 = function (p0, p1) {
    return p0.loadByte_0(p1);
  };
  _no_name_provided__72.prototype.invoke_293 = function (p1, p2) {
    var tmp = p1 instanceof Simulator ? p1 : THROW_CCE();
    return this.invoke_218(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__72.prototype._get_name__20 = function () {
    return 'loadByte';
  };
  _no_name_provided__72.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__73() {
  }
  _no_name_provided__73.prototype.invoke_212 = function (v) {
    return signExtend(v, 8);
  };
  _no_name_provided__73.prototype.invoke_213 = function (p1) {
    return this.invoke_212((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__73.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_66() {
    var i = new _no_name_provided__72();
    var l = function (p1, p2) {
      return i.invoke_218(p1, p2);
    };
    l.callableName = i._get_name__20();
    return l;
  }
  function _no_name_provided_$factory_67() {
    var i = new _no_name_provided__73();
    return function (p1) {
      return i.invoke_212(p1);
    };
  }
  function lb$init$() {
    var tmp = _no_name_provided_$factory_66();
    var tmp_0 = _no_name_provided_$factory_67();
    return LoadTypeInstruction_init_$Create$('lb', 3, 0, tmp, tmp_0, null, null, 96, null);
  }
  var lbu;
  function _no_name_provided__74() {
  }
  _no_name_provided__74.prototype.invoke_218 = function (p0, p1) {
    return p0.loadByte_0(p1);
  };
  _no_name_provided__74.prototype.invoke_293 = function (p1, p2) {
    var tmp = p1 instanceof Simulator ? p1 : THROW_CCE();
    return this.invoke_218(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__74.prototype._get_name__20 = function () {
    return 'loadByte';
  };
  _no_name_provided__74.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_68() {
    var i = new _no_name_provided__74();
    var l = function (p1, p2) {
      return i.invoke_218(p1, p2);
    };
    l.callableName = i._get_name__20();
    return l;
  }
  function lbu$init$() {
    var tmp = _no_name_provided_$factory_68();
    return LoadTypeInstruction_init_$Create$('lbu', 3, 4, tmp, null, null, null, 112, null);
  }
  var lh;
  function _no_name_provided__75() {
  }
  _no_name_provided__75.prototype.invoke_218 = function (p0, p1) {
    return p0.loadHalfWord_0(p1);
  };
  _no_name_provided__75.prototype.invoke_293 = function (p1, p2) {
    var tmp = p1 instanceof Simulator ? p1 : THROW_CCE();
    return this.invoke_218(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__75.prototype._get_name__20 = function () {
    return 'loadHalfWord';
  };
  _no_name_provided__75.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__76() {
  }
  _no_name_provided__76.prototype.invoke_212 = function (v) {
    return signExtend(v, 16);
  };
  _no_name_provided__76.prototype.invoke_213 = function (p1) {
    return this.invoke_212((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__76.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_69() {
    var i = new _no_name_provided__75();
    var l = function (p1, p2) {
      return i.invoke_218(p1, p2);
    };
    l.callableName = i._get_name__20();
    return l;
  }
  function _no_name_provided_$factory_70() {
    var i = new _no_name_provided__76();
    return function (p1) {
      return i.invoke_212(p1);
    };
  }
  function lh$init$() {
    var tmp = _no_name_provided_$factory_69();
    var tmp_0 = _no_name_provided_$factory_70();
    return LoadTypeInstruction_init_$Create$('lh', 3, 1, tmp, tmp_0, null, null, 96, null);
  }
  var lhu;
  function _no_name_provided__77() {
  }
  _no_name_provided__77.prototype.invoke_218 = function (p0, p1) {
    return p0.loadHalfWord_0(p1);
  };
  _no_name_provided__77.prototype.invoke_293 = function (p1, p2) {
    var tmp = p1 instanceof Simulator ? p1 : THROW_CCE();
    return this.invoke_218(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__77.prototype._get_name__20 = function () {
    return 'loadHalfWord';
  };
  _no_name_provided__77.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_71() {
    var i = new _no_name_provided__77();
    var l = function (p1, p2) {
      return i.invoke_218(p1, p2);
    };
    l.callableName = i._get_name__20();
    return l;
  }
  function lhu$init$() {
    var tmp = _no_name_provided_$factory_71();
    return LoadTypeInstruction_init_$Create$('lhu', 3, 5, tmp, null, null, null, 112, null);
  }
  var lui;
  function _no_name_provided__78() {
  }
  _no_name_provided__78.prototype.invoke_216 = function (mcode, sim) {
    var imm = mcode.get_12(InstructionField_IMM_31_12_getInstance()) << 12;
    sim.setReg_0(mcode.get_12(InstructionField_RD_getInstance()), imm);
    sim.incrementPC(mcode._length);
  };
  _no_name_provided__78.prototype.invoke_293 = function (p1, p2) {
    var tmp = p1 instanceof MachineCode ? p1 : THROW_CCE();
    this.invoke_216(tmp, p2 instanceof Simulator ? p2 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__78.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_72() {
    var i = new _no_name_provided__78();
    return function (p1, p2) {
      i.invoke_216(p1, p2);
      return Unit_getInstance();
    };
  }
  function lui$init$() {
    var tmp = _no_name_provided_$factory_72();
    return UTypeInstruction_init_$Create$('lui', 55, tmp, null, 8, null);
  }
  var lw;
  function _no_name_provided__79() {
  }
  _no_name_provided__79.prototype.invoke_218 = function (p0, p1) {
    return p0.loadWord_0(p1);
  };
  _no_name_provided__79.prototype.invoke_293 = function (p1, p2) {
    var tmp = p1 instanceof Simulator ? p1 : THROW_CCE();
    return this.invoke_218(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__79.prototype._get_name__20 = function () {
    return 'loadWord';
  };
  _no_name_provided__79.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_73() {
    var i = new _no_name_provided__79();
    var l = function (p1, p2) {
      return i.invoke_218(p1, p2);
    };
    l.callableName = i._get_name__20();
    return l;
  }
  function lw$init$() {
    var tmp = _no_name_provided_$factory_73();
    return LoadTypeInstruction_init_$Create$('lw', 3, 2, tmp, null, null, null, 112, null);
  }
  var mul;
  function _no_name_provided__80() {
  }
  _no_name_provided__80.prototype.invoke_290 = function (a, b) {
    return imul(a, b);
  };
  _no_name_provided__80.prototype.invoke_293 = function (p1, p2) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    return this.invoke_290(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__80.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__81() {
  }
  _no_name_provided__81.prototype.invoke_292 = function (a, b) {
    return a.times_27(b);
  };
  _no_name_provided__81.prototype.invoke_293 = function (p1, p2) {
    var tmp = p1 instanceof Long ? p1 : THROW_CCE();
    return this.invoke_292(tmp, p2 instanceof Long ? p2 : THROW_CCE());
  };
  _no_name_provided__81.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_74() {
    var i = new _no_name_provided__80();
    return function (p1, p2) {
      return i.invoke_290(p1, p2);
    };
  }
  function _no_name_provided_$factory_75() {
    var i = new _no_name_provided__81();
    return function (p1, p2) {
      return i.invoke_292(p1, p2);
    };
  }
  function mul$init$() {
    var tmp = _no_name_provided_$factory_74();
    return new RTypeInstruction('mul', 51, 0, 1, tmp, _no_name_provided_$factory_75());
  }
  var mulh;
  function _no_name_provided__82() {
  }
  _no_name_provided__82.prototype.invoke_290 = function (a, b) {
    var x = toLong_1(a);
    var y = toLong_1(b);
    return x.times_27(y).ushr_0(32).toInt_5();
  };
  _no_name_provided__82.prototype.invoke_293 = function (p1, p2) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    return this.invoke_290(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__82.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_76() {
    var i = new _no_name_provided__82();
    return function (p1, p2) {
      return i.invoke_290(p1, p2);
    };
  }
  function mulh$init$() {
    var tmp = _no_name_provided_$factory_76();
    return RTypeInstruction_init_$Create$('mulh', 51, 1, 1, tmp, null, 32, null);
  }
  var mulhsu;
  function _no_name_provided__83() {
  }
  _no_name_provided__83.prototype.invoke_290 = function (a, b) {
    var x = toLong_1(a);
    var y = toLong_1(b).shl_0(32).ushr_0(32);
    return x.times_27(y).ushr_0(32).toInt_5();
  };
  _no_name_provided__83.prototype.invoke_293 = function (p1, p2) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    return this.invoke_290(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__83.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_77() {
    var i = new _no_name_provided__83();
    return function (p1, p2) {
      return i.invoke_290(p1, p2);
    };
  }
  function mulhsu$init$() {
    var tmp = _no_name_provided_$factory_77();
    return RTypeInstruction_init_$Create$('mulhsu', 51, 2, 1, tmp, null, 32, null);
  }
  var mulhu;
  function _no_name_provided__84() {
  }
  _no_name_provided__84.prototype.invoke_290 = function (a, b) {
    var x = toLong_1(a).shl_0(32).ushr_0(32);
    var y = toLong_1(b).shl_0(32).ushr_0(32);
    return x.times_27(y).ushr_0(32).toInt_5();
  };
  _no_name_provided__84.prototype.invoke_293 = function (p1, p2) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    return this.invoke_290(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__84.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_78() {
    var i = new _no_name_provided__84();
    return function (p1, p2) {
      return i.invoke_290(p1, p2);
    };
  }
  function mulhu$init$() {
    var tmp = _no_name_provided_$factory_78();
    return RTypeInstruction_init_$Create$('mulhu', 51, 3, 1, tmp, null, 32, null);
  }
  var or;
  function _no_name_provided__85() {
  }
  _no_name_provided__85.prototype.invoke_290 = function (a, b) {
    return a | b;
  };
  _no_name_provided__85.prototype.invoke_293 = function (p1, p2) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    return this.invoke_290(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__85.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__86() {
  }
  _no_name_provided__86.prototype.invoke_292 = function (a, b) {
    return a.or(b);
  };
  _no_name_provided__86.prototype.invoke_293 = function (p1, p2) {
    var tmp = p1 instanceof Long ? p1 : THROW_CCE();
    return this.invoke_292(tmp, p2 instanceof Long ? p2 : THROW_CCE());
  };
  _no_name_provided__86.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_79() {
    var i = new _no_name_provided__85();
    return function (p1, p2) {
      return i.invoke_290(p1, p2);
    };
  }
  function _no_name_provided_$factory_80() {
    var i = new _no_name_provided__86();
    return function (p1, p2) {
      return i.invoke_292(p1, p2);
    };
  }
  function or$init$() {
    var tmp = _no_name_provided_$factory_79();
    return new RTypeInstruction('or', 51, 6, 0, tmp, _no_name_provided_$factory_80());
  }
  var ori;
  function _no_name_provided__87() {
  }
  _no_name_provided__87.prototype.invoke_290 = function (a, b) {
    return a | b;
  };
  _no_name_provided__87.prototype.invoke_293 = function (p1, p2) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    return this.invoke_290(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__87.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__88() {
  }
  _no_name_provided__88.prototype.invoke_292 = function (a, b) {
    return a.or(b);
  };
  _no_name_provided__88.prototype.invoke_293 = function (p1, p2) {
    var tmp = p1 instanceof Long ? p1 : THROW_CCE();
    return this.invoke_292(tmp, p2 instanceof Long ? p2 : THROW_CCE());
  };
  _no_name_provided__88.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_81() {
    var i = new _no_name_provided__87();
    return function (p1, p2) {
      return i.invoke_290(p1, p2);
    };
  }
  function _no_name_provided_$factory_82() {
    var i = new _no_name_provided__88();
    return function (p1, p2) {
      return i.invoke_292(p1, p2);
    };
  }
  function ori$init$() {
    var tmp = _no_name_provided_$factory_81();
    return new ITypeInstruction('ori', 19, 6, tmp, _no_name_provided_$factory_82());
  }
  var rem;
  function _no_name_provided__89() {
  }
  _no_name_provided__89.prototype.invoke_290 = function (a, b) {
    return b === 0 ? a : (a === IntCompanionObject_getInstance()._MIN_VALUE ? b === -1 : false) ? 0 : a % b;
  };
  _no_name_provided__89.prototype.invoke_293 = function (p1, p2) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    return this.invoke_290(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__89.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_83() {
    var i = new _no_name_provided__89();
    return function (p1, p2) {
      return i.invoke_290(p1, p2);
    };
  }
  function rem$init$() {
    var tmp = _no_name_provided_$factory_83();
    return RTypeInstruction_init_$Create$('rem', 51, 6, 1, tmp, null, 32, null);
  }
  var remu;
  function _no_name_provided__90() {
  }
  _no_name_provided__90.prototype.invoke_290 = function (a, b) {
    var x = toLong_1(a).shl_0(32).ushr_0(32);
    var y = toLong_1(b).shl_0(32).ushr_0(32);
    return b === 0 ? a : x.rem_27(y).toInt_5();
  };
  _no_name_provided__90.prototype.invoke_293 = function (p1, p2) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    return this.invoke_290(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__90.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_84() {
    var i = new _no_name_provided__90();
    return function (p1, p2) {
      return i.invoke_290(p1, p2);
    };
  }
  function remu$init$() {
    var tmp = _no_name_provided_$factory_84();
    return RTypeInstruction_init_$Create$('remu', 51, 7, 1, tmp, null, 32, null);
  }
  var sb;
  function _no_name_provided__91() {
  }
  _no_name_provided__91.prototype.invoke_284 = function (p0, p1, p2) {
    return p0.storeByte_0(p1, p2);
  };
  _no_name_provided__91.prototype.invoke_285 = function (p1, p2, p3) {
    var tmp = p1 instanceof Simulator ? p1 : THROW_CCE();
    var tmp_0 = (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE();
    this.invoke_284(tmp, tmp_0, (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__91.prototype._get_name__20 = function () {
    return 'storeByte';
  };
  _no_name_provided__91.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_85() {
    var i = new _no_name_provided__91();
    var l = function (p1, p2, p3) {
      i.invoke_284(p1, p2, p3);
      return Unit_getInstance();
    };
    l.callableName = i._get_name__20();
    return l;
  }
  function sb$init$() {
    var tmp = _no_name_provided_$factory_85();
    return STypeInstruction_init_$Create$('sb', 35, 0, tmp, null, 16, null);
  }
  var sh;
  function _no_name_provided__92() {
  }
  _no_name_provided__92.prototype.invoke_284 = function (p0, p1, p2) {
    return p0.storeHalfWord_0(p1, p2);
  };
  _no_name_provided__92.prototype.invoke_285 = function (p1, p2, p3) {
    var tmp = p1 instanceof Simulator ? p1 : THROW_CCE();
    var tmp_0 = (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE();
    this.invoke_284(tmp, tmp_0, (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__92.prototype._get_name__20 = function () {
    return 'storeHalfWord';
  };
  _no_name_provided__92.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_86() {
    var i = new _no_name_provided__92();
    var l = function (p1, p2, p3) {
      i.invoke_284(p1, p2, p3);
      return Unit_getInstance();
    };
    l.callableName = i._get_name__20();
    return l;
  }
  function sh$init$() {
    var tmp = _no_name_provided_$factory_86();
    return STypeInstruction_init_$Create$('sh', 35, 1, tmp, null, 16, null);
  }
  var sll;
  function _no_name_provided__93() {
  }
  _no_name_provided__93.prototype.invoke_290 = function (a, b) {
    var shift = b & 31;
    return shift === 0 ? a : a << shift;
  };
  _no_name_provided__93.prototype.invoke_293 = function (p1, p2) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    return this.invoke_290(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__93.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__94() {
  }
  _no_name_provided__94.prototype.invoke_292 = function (a, b) {
    var shift = b.toInt_5() & 63;
    return shift === 0 ? a : a.shl_0(shift);
  };
  _no_name_provided__94.prototype.invoke_293 = function (p1, p2) {
    var tmp = p1 instanceof Long ? p1 : THROW_CCE();
    return this.invoke_292(tmp, p2 instanceof Long ? p2 : THROW_CCE());
  };
  _no_name_provided__94.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_87() {
    var i = new _no_name_provided__93();
    return function (p1, p2) {
      return i.invoke_290(p1, p2);
    };
  }
  function _no_name_provided_$factory_88() {
    var i = new _no_name_provided__94();
    return function (p1, p2) {
      return i.invoke_292(p1, p2);
    };
  }
  function sll$init$() {
    var tmp = _no_name_provided_$factory_87();
    return new RTypeInstruction('sll', 51, 1, 0, tmp, _no_name_provided_$factory_88());
  }
  var slli;
  function _no_name_provided__95() {
  }
  _no_name_provided__95.prototype.invoke_290 = function (a, b) {
    return b === 0 ? a : a << b;
  };
  _no_name_provided__95.prototype.invoke_293 = function (p1, p2) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    return this.invoke_290(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__95.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_89() {
    var i = new _no_name_provided__95();
    return function (p1, p2) {
      return i.invoke_290(p1, p2);
    };
  }
  function slli$init$() {
    var tmp = _no_name_provided_$factory_89();
    return ShiftImmediateInstruction_init_$Create$('slli', 1, 0, tmp, null, 16, null);
  }
  var slt;
  function _no_name_provided__96() {
  }
  _no_name_provided__96.prototype.invoke_290 = function (a, b) {
    return a < b ? 1 : 0;
  };
  _no_name_provided__96.prototype.invoke_293 = function (p1, p2) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    return this.invoke_290(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__96.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__97() {
  }
  _no_name_provided__97.prototype.invoke_292 = function (a, b) {
    return a.compareTo_36(b) < 0 ? new Long(1, 0) : new Long(0, 0);
  };
  _no_name_provided__97.prototype.invoke_293 = function (p1, p2) {
    var tmp = p1 instanceof Long ? p1 : THROW_CCE();
    return this.invoke_292(tmp, p2 instanceof Long ? p2 : THROW_CCE());
  };
  _no_name_provided__97.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_90() {
    var i = new _no_name_provided__96();
    return function (p1, p2) {
      return i.invoke_290(p1, p2);
    };
  }
  function _no_name_provided_$factory_91() {
    var i = new _no_name_provided__97();
    return function (p1, p2) {
      return i.invoke_292(p1, p2);
    };
  }
  function slt$init$() {
    var tmp = _no_name_provided_$factory_90();
    return new RTypeInstruction('slt', 51, 2, 0, tmp, _no_name_provided_$factory_91());
  }
  var slti;
  function _no_name_provided__98() {
  }
  _no_name_provided__98.prototype.invoke_290 = function (a, b) {
    return a < b ? 1 : 0;
  };
  _no_name_provided__98.prototype.invoke_293 = function (p1, p2) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    return this.invoke_290(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__98.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__99() {
  }
  _no_name_provided__99.prototype.invoke_292 = function (a, b) {
    return a.compareTo_36(b) < 0 ? new Long(1, 0) : new Long(0, 0);
  };
  _no_name_provided__99.prototype.invoke_293 = function (p1, p2) {
    var tmp = p1 instanceof Long ? p1 : THROW_CCE();
    return this.invoke_292(tmp, p2 instanceof Long ? p2 : THROW_CCE());
  };
  _no_name_provided__99.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_92() {
    var i = new _no_name_provided__98();
    return function (p1, p2) {
      return i.invoke_290(p1, p2);
    };
  }
  function _no_name_provided_$factory_93() {
    var i = new _no_name_provided__99();
    return function (p1, p2) {
      return i.invoke_292(p1, p2);
    };
  }
  function slti$init$() {
    var tmp = _no_name_provided_$factory_92();
    return new ITypeInstruction('slti', 19, 2, tmp, _no_name_provided_$factory_93());
  }
  var sltiu;
  function _no_name_provided__100() {
  }
  _no_name_provided__100.prototype.invoke_290 = function (a, b) {
    return compareUnsigned(a, b) < 0 ? 1 : 0;
  };
  _no_name_provided__100.prototype.invoke_293 = function (p1, p2) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    return this.invoke_290(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__100.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__101() {
  }
  _no_name_provided__101.prototype.invoke_292 = function (a, b) {
    return compareUnsignedLong(a, b) < 0 ? new Long(1, 0) : new Long(0, 0);
  };
  _no_name_provided__101.prototype.invoke_293 = function (p1, p2) {
    var tmp = p1 instanceof Long ? p1 : THROW_CCE();
    return this.invoke_292(tmp, p2 instanceof Long ? p2 : THROW_CCE());
  };
  _no_name_provided__101.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_94() {
    var i = new _no_name_provided__100();
    return function (p1, p2) {
      return i.invoke_290(p1, p2);
    };
  }
  function _no_name_provided_$factory_95() {
    var i = new _no_name_provided__101();
    return function (p1, p2) {
      return i.invoke_292(p1, p2);
    };
  }
  function sltiu$init$() {
    var tmp = _no_name_provided_$factory_94();
    return new ITypeInstruction('sltiu', 19, 3, tmp, _no_name_provided_$factory_95());
  }
  var sltu;
  function _no_name_provided__102() {
  }
  _no_name_provided__102.prototype.invoke_290 = function (a, b) {
    return compareUnsigned(a, b) < 0 ? 1 : 0;
  };
  _no_name_provided__102.prototype.invoke_293 = function (p1, p2) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    return this.invoke_290(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__102.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__103() {
  }
  _no_name_provided__103.prototype.invoke_292 = function (a, b) {
    return compareUnsignedLong(a, b) < 0 ? new Long(1, 0) : new Long(0, 0);
  };
  _no_name_provided__103.prototype.invoke_293 = function (p1, p2) {
    var tmp = p1 instanceof Long ? p1 : THROW_CCE();
    return this.invoke_292(tmp, p2 instanceof Long ? p2 : THROW_CCE());
  };
  _no_name_provided__103.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_96() {
    var i = new _no_name_provided__102();
    return function (p1, p2) {
      return i.invoke_290(p1, p2);
    };
  }
  function _no_name_provided_$factory_97() {
    var i = new _no_name_provided__103();
    return function (p1, p2) {
      return i.invoke_292(p1, p2);
    };
  }
  function sltu$init$() {
    var tmp = _no_name_provided_$factory_96();
    return new RTypeInstruction('sltu', 51, 3, 0, tmp, _no_name_provided_$factory_97());
  }
  var sra;
  function _no_name_provided__104() {
  }
  _no_name_provided__104.prototype.invoke_290 = function (a, b) {
    var shift = b & 31;
    return shift === 0 ? a : a >> shift;
  };
  _no_name_provided__104.prototype.invoke_293 = function (p1, p2) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    return this.invoke_290(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__104.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__105() {
  }
  _no_name_provided__105.prototype.invoke_292 = function (a, b) {
    var shift = b.toInt_5() & 63;
    return shift === 0 ? a : a.shr_0(shift);
  };
  _no_name_provided__105.prototype.invoke_293 = function (p1, p2) {
    var tmp = p1 instanceof Long ? p1 : THROW_CCE();
    return this.invoke_292(tmp, p2 instanceof Long ? p2 : THROW_CCE());
  };
  _no_name_provided__105.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_98() {
    var i = new _no_name_provided__104();
    return function (p1, p2) {
      return i.invoke_290(p1, p2);
    };
  }
  function _no_name_provided_$factory_99() {
    var i = new _no_name_provided__105();
    return function (p1, p2) {
      return i.invoke_292(p1, p2);
    };
  }
  function sra$init$() {
    var tmp = _no_name_provided_$factory_98();
    return new RTypeInstruction('sra', 51, 5, 32, tmp, _no_name_provided_$factory_99());
  }
  var srai;
  function _no_name_provided__106() {
  }
  _no_name_provided__106.prototype.invoke_290 = function (a, b) {
    return b === 0 ? a : a >> b;
  };
  _no_name_provided__106.prototype.invoke_293 = function (p1, p2) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    return this.invoke_290(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__106.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_100() {
    var i = new _no_name_provided__106();
    return function (p1, p2) {
      return i.invoke_290(p1, p2);
    };
  }
  function srai$init$() {
    var tmp = _no_name_provided_$factory_100();
    return ShiftImmediateInstruction_init_$Create$('srai', 5, 32, tmp, null, 16, null);
  }
  var srl;
  function _no_name_provided__107() {
  }
  _no_name_provided__107.prototype.invoke_290 = function (a, b) {
    var shift = b & 31;
    return shift === 0 ? a : a >>> shift;
  };
  _no_name_provided__107.prototype.invoke_293 = function (p1, p2) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    return this.invoke_290(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__107.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__108() {
  }
  _no_name_provided__108.prototype.invoke_292 = function (a, b) {
    var shift = b.toInt_5() & 63;
    return shift === 0 ? a : a.ushr_0(shift);
  };
  _no_name_provided__108.prototype.invoke_293 = function (p1, p2) {
    var tmp = p1 instanceof Long ? p1 : THROW_CCE();
    return this.invoke_292(tmp, p2 instanceof Long ? p2 : THROW_CCE());
  };
  _no_name_provided__108.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_101() {
    var i = new _no_name_provided__107();
    return function (p1, p2) {
      return i.invoke_290(p1, p2);
    };
  }
  function _no_name_provided_$factory_102() {
    var i = new _no_name_provided__108();
    return function (p1, p2) {
      return i.invoke_292(p1, p2);
    };
  }
  function srl$init$() {
    var tmp = _no_name_provided_$factory_101();
    return new RTypeInstruction('srl', 51, 5, 0, tmp, _no_name_provided_$factory_102());
  }
  var srli;
  function _no_name_provided__109() {
  }
  _no_name_provided__109.prototype.invoke_290 = function (a, b) {
    return b === 0 ? a : a >>> b;
  };
  _no_name_provided__109.prototype.invoke_293 = function (p1, p2) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    return this.invoke_290(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__109.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_103() {
    var i = new _no_name_provided__109();
    return function (p1, p2) {
      return i.invoke_290(p1, p2);
    };
  }
  function srli$init$() {
    var tmp = _no_name_provided_$factory_103();
    return ShiftImmediateInstruction_init_$Create$('srli', 5, 0, tmp, null, 16, null);
  }
  var sub;
  function _no_name_provided__110() {
  }
  _no_name_provided__110.prototype.invoke_290 = function (a, b) {
    return a - b | 0;
  };
  _no_name_provided__110.prototype.invoke_293 = function (p1, p2) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    return this.invoke_290(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__110.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__111() {
  }
  _no_name_provided__111.prototype.invoke_292 = function (a, b) {
    return a.minus_28(b);
  };
  _no_name_provided__111.prototype.invoke_293 = function (p1, p2) {
    var tmp = p1 instanceof Long ? p1 : THROW_CCE();
    return this.invoke_292(tmp, p2 instanceof Long ? p2 : THROW_CCE());
  };
  _no_name_provided__111.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_104() {
    var i = new _no_name_provided__110();
    return function (p1, p2) {
      return i.invoke_290(p1, p2);
    };
  }
  function _no_name_provided_$factory_105() {
    var i = new _no_name_provided__111();
    return function (p1, p2) {
      return i.invoke_292(p1, p2);
    };
  }
  function sub$init$() {
    var tmp = _no_name_provided_$factory_104();
    return new RTypeInstruction('sub', 51, 0, 32, tmp, _no_name_provided_$factory_105());
  }
  var sw;
  function _no_name_provided__112() {
  }
  _no_name_provided__112.prototype.invoke_284 = function (p0, p1, p2) {
    return p0.storeWord_0(p1, p2);
  };
  _no_name_provided__112.prototype.invoke_285 = function (p1, p2, p3) {
    var tmp = p1 instanceof Simulator ? p1 : THROW_CCE();
    var tmp_0 = (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE();
    this.invoke_284(tmp, tmp_0, (!(p3 == null) ? typeof p3 === 'number' : false) ? p3 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__112.prototype._get_name__20 = function () {
    return 'storeWord';
  };
  _no_name_provided__112.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_106() {
    var i = new _no_name_provided__112();
    var l = function (p1, p2, p3) {
      i.invoke_284(p1, p2, p3);
      return Unit_getInstance();
    };
    l.callableName = i._get_name__20();
    return l;
  }
  function sw$init$() {
    var tmp = _no_name_provided_$factory_106();
    return STypeInstruction_init_$Create$('sw', 35, 2, tmp, null, 16, null);
  }
  var xor;
  function _no_name_provided__113() {
  }
  _no_name_provided__113.prototype.invoke_290 = function (a, b) {
    return a ^ b;
  };
  _no_name_provided__113.prototype.invoke_293 = function (p1, p2) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    return this.invoke_290(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__113.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__114() {
  }
  _no_name_provided__114.prototype.invoke_292 = function (a, b) {
    return a.xor(b);
  };
  _no_name_provided__114.prototype.invoke_293 = function (p1, p2) {
    var tmp = p1 instanceof Long ? p1 : THROW_CCE();
    return this.invoke_292(tmp, p2 instanceof Long ? p2 : THROW_CCE());
  };
  _no_name_provided__114.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_107() {
    var i = new _no_name_provided__113();
    return function (p1, p2) {
      return i.invoke_290(p1, p2);
    };
  }
  function _no_name_provided_$factory_108() {
    var i = new _no_name_provided__114();
    return function (p1, p2) {
      return i.invoke_292(p1, p2);
    };
  }
  function xor$init$() {
    var tmp = _no_name_provided_$factory_107();
    return new RTypeInstruction('xor', 51, 4, 0, tmp, _no_name_provided_$factory_108());
  }
  var xori;
  function _no_name_provided__115() {
  }
  _no_name_provided__115.prototype.invoke_290 = function (a, b) {
    return a ^ b;
  };
  _no_name_provided__115.prototype.invoke_293 = function (p1, p2) {
    var tmp = (!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE();
    return this.invoke_290(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__115.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__116() {
  }
  _no_name_provided__116.prototype.invoke_292 = function (a, b) {
    return a.xor(b);
  };
  _no_name_provided__116.prototype.invoke_293 = function (p1, p2) {
    var tmp = p1 instanceof Long ? p1 : THROW_CCE();
    return this.invoke_292(tmp, p2 instanceof Long ? p2 : THROW_CCE());
  };
  _no_name_provided__116.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_109() {
    var i = new _no_name_provided__115();
    return function (p1, p2) {
      return i.invoke_290(p1, p2);
    };
  }
  function _no_name_provided_$factory_110() {
    var i = new _no_name_provided__116();
    return function (p1, p2) {
      return i.invoke_292(p1, p2);
    };
  }
  function xori$init$() {
    var tmp = _no_name_provided_$factory_109();
    return new ITypeInstruction('xori', 19, 4, tmp, _no_name_provided_$factory_110());
  }
  function userStringToInt(s) {
    if (isCharacterLiteral(s)) {
      return characterLiteralToInt(s);
    }var tmp;
    if (startsWith$default_0(s, '0x', false, 2, null)) {
      tmp = 16;
    } else {
      if (startsWith$default_0(s, '0b', false, 2, null)) {
        tmp = 2;
      } else {
        var tmp_0 = drop_0(s, 1);
        if (startsWith$default_0(tmp_0, '0x', false, 2, null)) {
          tmp = 16;
        } else {
          var tmp_1 = drop_0(s, 1);
          if (startsWith$default_0(tmp_1, '0b', false, 2, null)) {
            tmp = 2;
          } else {
            {
              return toLong(s).toInt_5();
            }
          }
        }
      }
    }
    var radix = tmp;
    var tmp0_subject = first_0(s);
    var skipSign = (tmp0_subject.equals(new Char(43)) ? true : tmp0_subject.equals(new Char(45))) ? 1 : 0;
    var noRadixString = take(s, skipSign) + drop_0(s, skipSign + 2 | 0);
    return toLong_0(noRadixString, radix).toInt_5();
  }
  function isCharacterLiteral(s) {
    return first_0(s).equals(new Char(39)) ? last_1(s).equals(new Char(39)) : false;
  }
  function characterLiteralToInt(s) {
    var stripSingleQuotes = dropLast(drop_0(s, 1), 1);
    if (stripSingleQuotes === "\\'") {
      var tmp0__get_code__0 = new Char(39);
      return tmp0__get_code__0.toInt_5();
    }if (stripSingleQuotes === '"') {
      var tmp1__get_code__0 = new Char(34);
      return tmp1__get_code__0.toInt_5();
    }var jsonString = '' + '"' + stripSingleQuotes + '"';
    try {
      var parsed = JSON.parse(jsonString);
      if (charSequenceLength(parsed) === 0)
        throw NumberFormatException_init_$Create$('' + 'character literal ' + s + ' is empty');
      else {
      }
      if (parsed.length > 1)
        throw NumberFormatException_init_$Create$('' + 'character literal ' + s + ' too long');
      var tmp2__get_code__0 = charSequenceGet(parsed, 0);
      return tmp2__get_code__0.toInt_5();
    } catch ($p) {
      if ($p instanceof Error) {
        throw NumberFormatException_init_$Create$('' + 'could not parse character literal ' + s);
      } else {
        {
          throw $p;
        }
      }
    }
  }
  function Diff() {
  }
  Diff.$metadata$ = {
    simpleName: 'Diff',
    kind: 'class',
    interfaces: []
  };
  function HeapSpaceDiff(heapEnd) {
    Diff.call(this);
    this._heapEnd = heapEnd;
  }
  HeapSpaceDiff.prototype.invoke_298 = function (state) {
    state._heapEnd_0 = this._heapEnd;
  };
  HeapSpaceDiff.$metadata$ = {
    simpleName: 'HeapSpaceDiff',
    kind: 'class',
    interfaces: []
  };
  function MemoryDiff(addr, value) {
    Diff.call(this);
    this._addr = addr;
    this._value_0 = value;
  }
  MemoryDiff.prototype.invoke_298 = function (state) {
    state._mem.storeWord_0(this._addr, this._value_0);
  };
  MemoryDiff.$metadata$ = {
    simpleName: 'MemoryDiff',
    kind: 'class',
    interfaces: []
  };
  function PCDiff(pc) {
    Diff.call(this);
    this._pc = pc;
  }
  PCDiff.prototype.invoke_298 = function (state) {
    state._pc_0 = this._pc;
  };
  PCDiff.$metadata$ = {
    simpleName: 'PCDiff',
    kind: 'class',
    interfaces: []
  };
  function RegisterDiff(id, v) {
    Diff.call(this);
    this._id = id;
    this._v = v;
  }
  RegisterDiff.prototype.invoke_298 = function (state) {
    return state.setReg_0(this._id, this._v);
  };
  RegisterDiff.$metadata$ = {
    simpleName: 'RegisterDiff',
    kind: 'class',
    interfaces: []
  };
  function History_0() {
    this._diffs = ArrayList_init_$Create$();
  }
  History_0.prototype.add_14 = function (pre) {
    return this._diffs.add_12(toList(pre));
  };
  History_0.prototype.pop = function () {
    return this._diffs.removeAt(this._diffs._get_size__23() - 1 | 0);
  };
  History_0.prototype.isEmpty_16 = function () {
    return this._diffs.isEmpty_16();
  };
  History_0.$metadata$ = {
    simpleName: 'History',
    kind: 'class',
    interfaces: []
  };
  function Memory() {
    this._memory = HashMap_init_$Create$();
  }
  Memory.prototype.loadByte_0 = function (addr) {
    var tmp0_safe_receiver = this._memory.get_11(addr);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver & 255;
    return tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs;
  };
  Memory.prototype.loadHalfWord_0 = function (addr) {
    return this.loadByte_0(addr + 1 | 0) << 8 | this.loadByte_0(addr);
  };
  Memory.prototype.loadWord_0 = function (addr) {
    return this.loadHalfWord_0(addr + 2 | 0) << 16 | this.loadHalfWord_0(addr);
  };
  Memory.prototype.storeByte_0 = function (addr, value) {
    this._memory.put_2(addr, toByte(value));
    Unit_getInstance();
  };
  Memory.prototype.storeHalfWord_0 = function (addr, value) {
    this.storeByte_0(addr, value);
    this.storeByte_0(addr + 1 | 0, value >> 8);
  };
  Memory.prototype.storeWord_0 = function (addr, value) {
    this.storeHalfWord_0(addr, value);
    this.storeHalfWord_0(addr + 2 | 0, value >> 16);
  };
  Memory.$metadata$ = {
    simpleName: 'Memory',
    kind: 'class',
    interfaces: []
  };
  function getInstructionLength($this, short0) {
    if (!((short0 & 3) === 3)) {
      return 2;
    } else if (!((short0 & 31) === 31)) {
      return 4;
    } else if ((short0 & 63) === 31) {
      return 6;
    } else if ((short0 & 127) === 63) {
      return 8;
    } else {
      throw SimulatorError_init_$Create$('instruction lengths > 8 not supported');
    }
  }
  function getNextInstruction($this) {
    var short0 = $this.loadHalfWord_0($this.getPC());
    var length = getInstructionLength($this, short0);
    if (!(length === 4)) {
      throw SimulatorError_init_$Create$('instruction length != 4 not supported');
    }var short1 = $this.loadHalfWord_0($this.getPC() + 2 | 0);
    return new MachineCode(short1 << 16 | short0);
  }
  function Simulator(linkedProgram) {
    this._linkedProgram = linkedProgram;
    this._state_0 = new SimulatorState();
    var tmp = this;
    MemorySegments_getInstance();
    tmp._maxpc = 0;
    this._cycles = 0;
    this._history = new History_0();
    this._preInstruction = ArrayList_init_$Create$();
    this._postInstruction = ArrayList_init_$Create$();
    var tmp0_iterator = this._linkedProgram._prog_3._insts.iterator_29();
    while (tmp0_iterator.hasNext_10()) {
      var inst = tmp0_iterator.next_10();
      this._state_0._mem.storeWord_0(this._maxpc, inst.get_12(InstructionField_ENTIRE_getInstance()));
      var tmp1_this = this;
      tmp1_this._maxpc = tmp1_this._maxpc + inst._length | 0;
    }
    MemorySegments_getInstance();
    var dataOffset = 268435456;
    var tmp2_iterator = this._linkedProgram._prog_3._dataSegment.iterator_29();
    while (tmp2_iterator.hasNext_10()) {
      var datum = tmp2_iterator.next_10();
      this._state_0._mem.storeByte_0(dataOffset, datum);
      var tmp3 = dataOffset;
      dataOffset = tmp3 + 1 | 0;
      Unit_getInstance();
    }
    var tmp_0 = this._state_0;
    var tmp4_elvis_lhs = this._linkedProgram._startPC;
    var tmp_1;
    if (tmp4_elvis_lhs == null) {
      MemorySegments_getInstance();
      tmp_1 = 0;
    } else {
      tmp_1 = tmp4_elvis_lhs;
    }
    tmp_0._pc_0 = tmp_1;
    MemorySegments_getInstance();
    this._state_0.setReg_0(2, 2147483632);
    MemorySegments_getInstance();
    this._state_0.setReg_0(3, 268435456);
    var tmp_2 = this;
    var tmp_3 = 0;
    var tmp_4 = this._linkedProgram._prog_3._insts._get_size__23();
    var tmp_5 = fillArrayVal(Array(tmp_4), null);
    while (tmp_3 < tmp_4) {
      var tmp_6 = tmp_3;
      tmp_5[tmp_6] = false;
      tmp_3 = tmp_3 + 1 | 0;
    }
    tmp_2._breakpoints = tmp_5;
  }
  Simulator.prototype.isDone = function () {
    return this.getPC() >= this._maxpc;
  };
  Simulator.prototype.step_0 = function () {
    this._preInstruction.clear_0();
    this._postInstruction.clear_0();
    var mcode = getNextInstruction(this);
    Companion_getInstance_7().get_13(mcode)._impl32.invoke_216(mcode, this);
    this._history.add_14(this._preInstruction);
    Unit_getInstance();
    return toList(this._postInstruction);
  };
  Simulator.prototype.undo_0 = function () {
    if (!this.canUndo())
      return emptyList();
    var diffs = this._history.pop();
    var tmp0_iterator = diffs.iterator_29();
    while (tmp0_iterator.hasNext_10()) {
      var diff = tmp0_iterator.next_10();
      diff.invoke_298(this._state_0);
    }
    return diffs;
  };
  Simulator.prototype.canUndo = function () {
    return !this._history.isEmpty_16();
  };
  Simulator.prototype.getReg_0 = function (id) {
    return this._state_0.getReg_0(id);
  };
  Simulator.prototype.setReg_0 = function (id, v) {
    this._preInstruction.add_12(new RegisterDiff(id, this._state_0.getReg_0(id)));
    Unit_getInstance();
    this._state_0.setReg_0(id, v);
    this._postInstruction.add_12(new RegisterDiff(id, this._state_0.getReg_0(id)));
    Unit_getInstance();
  };
  Simulator.prototype.setRegNoUndo = function (id, v) {
    this._state_0.setReg_0(id, v);
  };
  Simulator.prototype.toggleBreakpointAt = function (idx) {
    this._breakpoints[idx] = !this._breakpoints[idx];
    return this._breakpoints[idx];
  };
  Simulator.prototype.atBreakpoint = function () {
    return this._breakpoints[this._state_0._pc_0 / 4 | 0];
  };
  Simulator.prototype.getPC = function () {
    return this._state_0._pc_0;
  };
  Simulator.prototype.setPC = function (newPC) {
    this._preInstruction.add_12(new PCDiff(this._state_0._pc_0));
    Unit_getInstance();
    this._state_0._pc_0 = newPC;
    this._postInstruction.add_12(new PCDiff(this._state_0._pc_0));
    Unit_getInstance();
  };
  Simulator.prototype.incrementPC = function (inc) {
    this._preInstruction.add_12(new PCDiff(this._state_0._pc_0));
    Unit_getInstance();
    var tmp0_this = this._state_0;
    tmp0_this._pc_0 = tmp0_this._pc_0 + inc | 0;
    this._postInstruction.add_12(new PCDiff(this._state_0._pc_0));
    Unit_getInstance();
  };
  Simulator.prototype.loadByte_0 = function (addr) {
    return this._state_0._mem.loadByte_0(addr);
  };
  Simulator.prototype.loadHalfWord_0 = function (addr) {
    return this._state_0._mem.loadHalfWord_0(addr);
  };
  Simulator.prototype.loadWord_0 = function (addr) {
    return this._state_0._mem.loadWord_0(addr);
  };
  Simulator.prototype.storeByte_0 = function (addr, value) {
    this._preInstruction.add_12(new MemoryDiff(addr, this.loadWord_0(addr)));
    Unit_getInstance();
    this._state_0._mem.storeByte_0(addr, value);
    this._postInstruction.add_12(new MemoryDiff(addr, this.loadWord_0(addr)));
    Unit_getInstance();
  };
  Simulator.prototype.storeHalfWord_0 = function (addr, value) {
    this._preInstruction.add_12(new MemoryDiff(addr, this.loadWord_0(addr)));
    Unit_getInstance();
    this._state_0._mem.storeHalfWord_0(addr, value);
    this._postInstruction.add_12(new MemoryDiff(addr, this.loadWord_0(addr)));
    Unit_getInstance();
  };
  Simulator.prototype.storeWord_0 = function (addr, value) {
    this._preInstruction.add_12(new MemoryDiff(addr, this.loadWord_0(addr)));
    Unit_getInstance();
    this._state_0._mem.storeWord_0(addr, value);
    this._postInstruction.add_12(new MemoryDiff(addr, this.loadWord_0(addr)));
    Unit_getInstance();
  };
  Simulator.prototype.getHeapEnd = function () {
    return this._state_0._heapEnd_0;
  };
  Simulator.prototype.addHeapSpace = function (bytes) {
    this._preInstruction.add_12(new HeapSpaceDiff(this._state_0._heapEnd_0));
    Unit_getInstance();
    var tmp0_this = this._state_0;
    tmp0_this._heapEnd_0 = tmp0_this._heapEnd_0 + bytes | 0;
    this._postInstruction.add_12(new HeapSpaceDiff(this._state_0._heapEnd_0));
    Unit_getInstance();
  };
  Simulator.$metadata$ = {
    simpleName: 'Simulator',
    kind: 'class',
    interfaces: []
  };
  function SimulatorError_init_$Init$(msg, $this) {
    extendThrowable($this, msg, void 1);
    SimulatorError.call($this);
    return $this;
  }
  function SimulatorError_init_$Create$(msg) {
    var tmp = SimulatorError_init_$Init$(msg, Object.create(SimulatorError.prototype));
    captureStack(tmp, SimulatorError_init_$Create$);
    return tmp;
  }
  function SimulatorError() {
    captureStack(this, SimulatorError);
  }
  SimulatorError.$metadata$ = {
    simpleName: 'SimulatorError',
    kind: 'class',
    interfaces: []
  };
  function SimulatorState() {
    this._regs = new Int32Array(32);
    this._mem = new Memory();
    this._pc_0 = 0;
    var tmp = this;
    MemorySegments_getInstance();
    tmp._heapEnd_0 = 268468224;
  }
  SimulatorState.prototype.getReg_0 = function (i) {
    return this._regs[i];
  };
  SimulatorState.prototype.setReg_0 = function (i, v) {
    if (!(i === 0))
      this._regs[i] = v;
  };
  SimulatorState.$metadata$ = {
    simpleName: 'SimulatorState',
    kind: 'class',
    interfaces: []
  };
  AbstractMap.prototype._get_entries__3 = Map_0.prototype._get_entries__3;
  IntIterator.prototype.hasNext_10 = Iterator.prototype.hasNext_10;
  AbstractMutableList.prototype.get_24 = List.prototype.get_24;
  AbstractMutableMap.prototype._get_entries__3 = MutableMap.prototype._get_entries__3;
  InternalHashCodeMap.prototype.createJsMap_0 = InternalMap.prototype.createJsMap_0;
  KClassImpl.prototype._get_simpleName__2 = KClass.prototype._get_simpleName__2;
  output = output$init$();
  functionClasses = functionClasses$init$();
  buf = new ArrayBuffer(8);
  bufFloat64 = bufFloat64$init$();
  bufInt32 = bufInt32$init$();
  lowIndex = lowIndex$init$();
  highIndex = 1 - lowIndex | 0;
  ZERO = fromInt(0);
  ONE = fromInt(1);
  NEG_ONE = fromInt(-1);
  MAX_VALUE = new Long(-1, 2147483647);
  MIN_VALUE = new Long(0, -2147483648);
  TWO_PWR_24_ = fromInt(16777216);
  add_0 = add$init$();
  addi = addi$init$();
  and = and$init$();
  andi = andi$init$();
  auipc = auipc$init$();
  beq = beq$init$();
  bge = bge$init$();
  bgeu = bgeu$init$();
  blt = blt$init$();
  bltu = bltu$init$();
  bne = bne$init$();
  div = div$init$();
  divu = divu$init$();
  JALRelocator = new Relocator(JALRelocator32_getInstance(), NoRelocator64_getInstance());
  PCRelHiRelocator = new Relocator(PCRelHiRelocator32_getInstance(), NoRelocator64_getInstance());
  PCRelLoRelocator = new Relocator(PCRelLoRelocator32_getInstance(), NoRelocator64_getInstance());
  PCRelLoStoreRelocator = new Relocator(PCRelLoStoreRelocator32_getInstance(), NoRelocator64_getInstance());
  ecall = ecall$init$();
  jal = jal$init$();
  jalr = jalr$init$();
  lb = lb$init$();
  lbu = lbu$init$();
  lh = lh$init$();
  lhu = lhu$init$();
  lui = lui$init$();
  lw = lw$init$();
  mul = mul$init$();
  mulh = mulh$init$();
  mulhsu = mulhsu$init$();
  mulhu = mulhu$init$();
  or = or$init$();
  ori = ori$init$();
  rem = rem$init$();
  remu = remu$init$();
  sb = sb$init$();
  sh = sh$init$();
  sll = sll$init$();
  slli = slli$init$();
  slt = slt$init$();
  slti = slti$init$();
  sltiu = sltiu$init$();
  sltu = sltu$init$();
  sra = sra$init$();
  srai = srai$init$();
  srl = srl$init$();
  srli = srli$init$();
  sub = sub$init$();
  sw = sw$init$();
  xor = xor$init$();
  xori = xori$init$();
  var $venus = _.venus || (_.venus = {});
  var $venus$assembler = $venus.assembler || ($venus.assembler = {});
  Object.defineProperty($venus$assembler, 'Linter', {
    configurable: true,
    get: Linter_getInstance
  });
  var $venus$glue = $venus.glue || ($venus.glue = {});
  Object.defineProperty($venus$glue, 'Driver', {
    configurable: true,
    get: Driver_getInstance
  });
  return _;
}));
